/* eslint-disable */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Any: { input: any; output: any }
  Byte: { input: any; output: any }
  DateTime: { input: any; output: any }
  Decimal: { input: number; output: number }
  URL: { input: any; output: any }
  UUID: { input: any; output: any }
}

export type AbTestInformation = {
  companies: Array<Scalars['String']['output']>
  optimizelyId: Scalars['String']['output']
  versionA: AbTestVersion
  versionB: AbTestVersion
}

export type AbTestVersion = {
  sourceSystem: SourceSystem
  value: Array<QualifiedValueOfString>
}

export type Accessories = {
  articleAccessories: Array<ProductAccessory>
  articleAccessoriesCount: Scalars['Int']['output']
  categoryAccessories: Array<CategoryAccessory>
  categoryAccessoriesCount: Scalars['Int']['output']
  dependentAccessories: Array<Product>
  insuranceAccessories: Array<Product>
  insuranceAccessoryIds: Array<Scalars['String']['output']>
  isEmpty: Scalars['Boolean']['output']
  keyPrefix: Scalars['String']['output']
  mandatoryAccessories: Array<Product>
  normalAccessories: Array<Product>
  productNearServicesAccessories: Array<Product>
  topAccessories: Array<Product>
}

export type AccessoryGuide = {
  category: Category
  manufacturerNames: Array<Scalars['String']['output']>
}

export type AccessoryGuideProductsWithHits = {
  hits: Scalars['Int']['output']
  products?: Maybe<Array<ProductReference>>
}

export type AccessoryProductModel = {
  availabilityInformation?: Maybe<AccountGraphql_Availability>
  product?: Maybe<LatestBoughtProduct>
}

export enum AccessoryType {
  Accessories = 'ACCESSORIES',
  AddonCampaign = 'ADDON_CAMPAIGN',
  CategoryAccessory = 'CATEGORY_ACCESSORY',
  MandatoryAccessory = 'MANDATORY_ACCESSORY',
  Paas = 'PAAS',
  PaasReference = 'PAAS_REFERENCE',
  ProductNearServices = 'PRODUCT_NEAR_SERVICES',
  RecommendedAccessories = 'RECOMMENDED_ACCESSORIES',
  SparePart = 'SPARE_PART',
  Unspecified = 'UNSPECIFIED',
}

export enum AccountAndPrivacyTermsState {
  Accepted = 'ACCEPTED',
  NeedsToAcceptPrivacyTermsUpdate = 'NEEDS_TO_ACCEPT_PRIVACY_TERMS_UPDATE',
  None = 'NONE',
  NotAccepted = 'NOT_ACCEPTED',
}

export enum ActivationEmailStatus {
  CustomerAlreadyExists = 'CUSTOMER_ALREADY_EXISTS',
  IsFederated = 'IS_FEDERATED',
  OngoingActivation = 'ONGOING_ACTIVATION',
  Valid = 'VALID',
}

export enum ActivationStatus {
  BadRequest = 'BAD_REQUEST',
  Conflict = 'CONFLICT',
  DisallowNewContact = 'DISALLOW_NEW_CONTACT',
  LoginNotExists = 'LOGIN_NOT_EXISTS',
  OrganizationNumberInvalid = 'ORGANIZATION_NUMBER_INVALID',
  PreRegistrationEmailDomainInvalid = 'PRE_REGISTRATION_EMAIL_DOMAIN_INVALID',
  Success = 'SUCCESS',
}

export type Activity = {
  banners?: Maybe<Array<Maybe<Banner>>>
  id: Scalars['Int']['output']
  productErpIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  productFilterList: ProductFilterList
  products: Array<Product>
  title?: Maybe<Scalars['String']['output']>
}

export type ActivityProductFilterListArgs = {
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortBy>
}

export type AdContainer = {
  activityId: Scalars['Int']['output']
  banner?: Maybe<Banner>
  bannerId: Scalars['Int']['output']
  productReferences: Array<ProductReference>
  ticket: Scalars['String']['output']
}

export type AdditionalProperty = {
  name: Scalars['String']['output']
  typeValue: Scalars['String']['output']
  unitCode: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type Address = {
  accessCode?: Maybe<Scalars['String']['output']>
  addressErpIdentifier?: Maybe<Scalars['String']['output']>
  addressLine?: Maybe<Scalars['String']['output']>
  addressSpecificationList?: Maybe<Array<Maybe<AddressSpecification>>>
  addressSpecificationTypes?: Maybe<Scalars['String']['output']>
  addressee?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdDateTimeUtc: Scalars['DateTime']['output']
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  department?: Maybe<Scalars['String']['output']>
  goodsReceiverName?: Maybe<Scalars['String']['output']>
  hiddenForGui: Scalars['Boolean']['output']
  houseNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  inactive: Scalars['Boolean']['output']
  isBox: Scalars['Boolean']['output']
  isNew: Scalars['Boolean']['output']
  isOnetime: Scalars['Boolean']['output']
  lastModifiedBy?: Maybe<Scalars['String']['output']>
  lastModifiedDateTimeUtc: Scalars['DateTime']['output']
  lastValidatedDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  locationIdentifier?: Maybe<Scalars['String']['output']>
  origin?: Maybe<AddressOrigin>
  postalCode?: Maybe<Scalars['String']['output']>
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
  validFromDateTimeUtc: Scalars['DateTime']['output']
  validToDateTimeUtc: Scalars['DateTime']['output']
}

export type AddressDetails = {
  addressLine?: Maybe<Scalars['String']['output']>
  addressee?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  department?: Maybe<Scalars['String']['output']>
  goodsReceiverName?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
}

export enum AddressOrigin {
  Contact = 'CONTACT',
  Customer = 'CUSTOMER',
}

export type AddressSpecification = {
  addressId: Scalars['Int']['output']
  addressType: AddressType
  isPrimary: Scalars['Boolean']['output']
}

export type AddressSuggestionModel = {
  label: Scalars['String']['output']
  locality: Scalars['String']['output']
  postalCode: Scalars['String']['output']
  value: Scalars['String']['output']
}

export enum AddressType {
  Billing = 'BILLING',
  Business = 'BUSINESS',
  None = 'NONE',
  OfficialBilling = 'OFFICIAL_BILLING',
  OfficialShipping = 'OFFICIAL_SHIPPING',
  Other = 'OTHER',
  Shipping = 'SHIPPING',
  Visiting = 'VISITING',
}

export enum AmountType {
  Fixed = 'FIXED',
  None = 'NONE',
  Percentage = 'PERCENTAGE',
  PerUnit = 'PER_UNIT',
}

export type Area = {
  blocks: Array<GridBlock>
  name: Scalars['String']['output']
}

export type Article = {
  categoryName: Scalars['String']['output']
  mainImage?: Maybe<Image>
  postDate: Scalars['DateTime']['output']
  postDateText: Scalars['String']['output']
  summary: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedDate: Scalars['DateTime']['output']
  updatedDateText: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ArticleAbTest = {
  description?: Maybe<DescriptionAbTest>
  keySellingPoints: AbTestInformation
}

export type ArticleBoxList = {
  articles: Array<Article>
  blogUrl: Scalars['String']['output']
}

export type ArticlePage = {
  blogUrl: Scalars['String']['output']
  body: Scalars['String']['output']
  breadcrumbs: Array<Breadcrumb>
  categoryArticles: Array<BlogArticle>
  categoryName: Scalars['String']['output']
  categoryNumberOfArticles: Scalars['Int']['output']
  content: Array<GridBlock>
  disableSiteSelector: Scalars['Boolean']['output']
  excerpt?: Maybe<Scalars['String']['output']>
  header: Scalars['String']['output']
  heroImage?: Maybe<Image>
  mainImage?: Maybe<Image>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  postDate: Scalars['DateTime']['output']
  postDateIso8601Text: Scalars['String']['output']
  postDateText: Scalars['String']['output']
  tags: Array<Scalars['String']['output']>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
  updatedDate: Scalars['DateTime']['output']
  updatedDateIso8601Text: Scalars['String']['output']
  updatedDateText: Scalars['String']['output']
  youTubeId?: Maybe<Scalars['String']['output']>
}

export type ArticleTagCount = {
  articleCount: Scalars['Int']['output']
  tag: Scalars['String']['output']
}

export type Attachments = {
  charger?: Maybe<Charger>
}

export type AttestContact = {
  attesterLevelIds?: Maybe<Array<Scalars['Int']['output']>>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  purchaserGroupId?: Maybe<Scalars['Int']['output']>
}

export type AttestGroup = {
  customerId: Scalars['Int']['output']
  errorCodes?: Maybe<Array<ErrorCode>>
  id: Scalars['Int']['output']
  isDefault: Scalars['Boolean']['output']
  isValid: Scalars['Boolean']['output']
  levels?: Maybe<Array<Maybe<AttestGroupLevel>>>
  members?: Maybe<Array<Scalars['Int']['output']>>
  name?: Maybe<Scalars['String']['output']>
  useOnlyHighestAttestLevel: Scalars['Boolean']['output']
}

export type AttestGroupLevel = {
  /** @deprecated This list contains only main attesters (no stand-in attesters). Use AttestersWithStandins instead */
  attesters?: Maybe<Array<Scalars['Int']['output']>>
  attestersWithStandins?: Maybe<Array<Maybe<Attester>>>
  errorCodes?: Maybe<Array<ErrorCode>>
  id: Scalars['Int']['output']
  isValid: Scalars['Boolean']['output']
  level: Scalars['Int']['output']
  limit: Scalars['Decimal']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type AttestGroupOverview = {
  id: Scalars['Int']['output']
  isDefault: Scalars['Boolean']['output']
  isValid: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  useHighestLevel: Scalars['Boolean']['output']
}

export type AttestModel = {
  availableStandInContacts: Array<KeyValuePairOfInt32AndString>
  isAttester: Scalars['Boolean']['output']
  selectedStandIn: Scalars['Int']['output']
  standInForContacts: Array<Scalars['String']['output']>
  standInUntilDateTime?: Maybe<Scalars['DateTime']['output']>
}

export type AttestPreOrderRequestInput = {
  approve: Scalars['Boolean']['input']
  comment: Scalars['String']['input']
  preOrderId: Scalars['Int']['input']
  stepNumber: Scalars['Int']['input']
}

export type AttestPreOrderResult = {
  attestPreOrderResultEnum: AttestPreOrderResultEnum
  orderId: Scalars['Int']['output']
}

export enum AttestPreOrderResultEnum {
  AlreadyApproved = 'ALREADY_APPROVED',
  Approved = 'APPROVED',
  Error = 'ERROR',
  StillPending = 'STILL_PENDING',
}

export type AttestSetupOverview = {
  attestContacts: Array<AttestContact>
  attestGroups: Array<AttestGroupOverview>
}

export type Attester = {
  contactId: Scalars['Int']['output']
  standInContactId?: Maybe<Scalars['Int']['output']>
}

export type AttesterRequestInput = {
  contactId: Scalars['Int']['input']
  levelId: Scalars['Int']['input']
}

export type AuthConnectedListContact = {
  companyName: Scalars['String']['output']
  contactInfo?: Maybe<GetContactsForContactSelectorDto>
  customerClassificationType?: Maybe<CustomerClassificationType>
  customerErpIdentifier?: Maybe<Scalars['String']['output']>
  customerId: Scalars['Int']['output']
  email: Scalars['String']['output']
  erpId?: Maybe<Scalars['String']['output']>
  fullName: Scalars['String']['output']
  id: Scalars['Int']['output']
  isB2B: Scalars['Boolean']['output']
  isBlocked: Scalars['Boolean']['output']
  isInactive: Scalars['Boolean']['output']
  isManaged: Scalars['Boolean']['output']
  isPrimary: Scalars['Boolean']['output']
  isPunchOut: Scalars['Boolean']['output']
  isSuperUser: Scalars['Boolean']['output']
  loginUrl?: Maybe<Scalars['String']['output']>
  siteInfo?: Maybe<SiteInfo>
  sourcingCompany: SourcingCompany
  userIdentifier: Scalars['UUID']['output']
}

export type AutoComplete = {
  contentList?: Maybe<Array<Maybe<ContentReference>>>
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  productHitCount: Scalars['Int']['output']
  products?: Maybe<Array<Maybe<ProductReference>>>
  recentSearches?: Maybe<Array<Maybe<RecentSearch>>>
  recentlyViewed?: Maybe<Array<Maybe<ProductReference>>>
  relatedCategories: Array<AutoCompleteCategory>
  searchPhrase?: Maybe<Scalars['String']['output']>
  suggestions?: Maybe<Array<Maybe<Suggestion>>>
}

export type AutoCompleteCategory = {
  category?: Maybe<Category>
  count: Scalars['Int']['output']
  selected: Scalars['Boolean']['output']
  text?: Maybe<Scalars['String']['output']>
  ticket?: Maybe<Scalars['String']['output']>
}

export type AutoCompleteE4 = {
  contentList?: Maybe<Array<Maybe<ContentReference>>>
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  productHitCount: Scalars['Int']['output']
  products?: Maybe<Array<Maybe<ProductReference>>>
  recentSearches?: Maybe<Array<Maybe<RecentSearch>>>
  recentlyViewed?: Maybe<Array<Maybe<ProductReference>>>
  relatedCategories?: Maybe<Array<AutoCompleteCategory>>
  searchPhrase?: Maybe<Scalars['String']['output']>
  suggestions?: Maybe<Array<Maybe<Suggestion>>>
}

export type AutoCorrect = {
  originalTotalHits: Scalars['Int']['output']
  q?: Maybe<Scalars['String']['output']>
}

export type Availability = {
  IsNotifyEligible: Scalars['Boolean']['output']
  availabilityDetails?: Maybe<AvailabilityDetails>
  availabilityStatus: AvailabilityStatus
  availabilityStatusPresentation: AvailabilityStatusPresentation
  externalStock?: Maybe<ExternalStockAvailability>
  internal: Scalars['Boolean']['output']
  internalEtaStock?: Maybe<InternalEtaStockAvailability>
  internalStock?: Maybe<InternalStockAvailability>
  isAvailableForSale: Scalars['Boolean']['output']
  isIncludedInKit: Scalars['Boolean']['output']
  isNotifyEligible: Scalars['Boolean']['output']
  isPreOrder: Scalars['Boolean']['output']
  maxAvailableQuantity?: Maybe<Scalars['Int']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  productLifeCycleState: ProductLifeCycleState
  showAvailabilityQuantities: Scalars['Boolean']['output']
  showEtaDate: Scalars['Boolean']['output']
}

export type AvailabilityDetails = {
  dateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  formattedDateUtc?: Maybe<Scalars['String']['output']>
  key: AvailabilityStatusType
}

export enum AvailabilityStatus {
  ComingSoon = 'COMING_SOON',
  ExternalStock = 'EXTERNAL_STOCK',
  ImmediateShipping = 'IMMEDIATE_SHIPPING',
  OutOfStock = 'OUT_OF_STOCK',
  Unknown = 'UNKNOWN',
}

export enum AvailabilityStatusPresentation {
  ShowAsComingSoon = 'SHOW_AS_COMING_SOON',
  ShowAsExternalStock = 'SHOW_AS_EXTERNAL_STOCK',
  ShowAsImmediateShipping = 'SHOW_AS_IMMEDIATE_SHIPPING',
  ShowAsOutOfStock = 'SHOW_AS_OUT_OF_STOCK',
}

export enum AvailabilityStatusType {
  ProductAvailabilityEsd = 'PRODUCT_AVAILABILITY_ESD',
  ProductAvailabilityEstimatedShippingDate = 'PRODUCT_AVAILABILITY_ESTIMATED_SHIPPING_DATE',
  ProductAvailabilityImmediateShipping = 'PRODUCT_AVAILABILITY_IMMEDIATE_SHIPPING',
  ProductAvailabilityNoImmediateShipping = 'PRODUCT_AVAILABILITY_NO_IMMEDIATE_SHIPPING',
  ProductAvailabilityOutOfStock = 'PRODUCT_AVAILABILITY_OUT_OF_STOCK',
  ProductAvailabilityOutOfStockComingSoon = 'PRODUCT_AVAILABILITY_OUT_OF_STOCK_COMING_SOON',
  ProductAvailabilityShippingDate = 'PRODUCT_AVAILABILITY_SHIPPING_DATE',
  ProductAvailabilityShippingDateAtTheEarliest = 'PRODUCT_AVAILABILITY_SHIPPING_DATE_AT_THE_EARLIEST',
  ProductAvailabilityShortage = 'PRODUCT_AVAILABILITY_SHORTAGE',
  ProductDistributorLeadTimeFourSixDays = 'PRODUCT_DISTRIBUTOR_LEAD_TIME_FOUR_SIX_DAYS',
  ProductDistributorLeadTimeOneTwoDays = 'PRODUCT_DISTRIBUTOR_LEAD_TIME_ONE_TWO_DAYS',
  ProductDistributorLeadTimeSixEightDays = 'PRODUCT_DISTRIBUTOR_LEAD_TIME_SIX_EIGHT_DAYS',
  ProductDistributorLeadTimeTenTwelveDays = 'PRODUCT_DISTRIBUTOR_LEAD_TIME_TEN_TWELVE_DAYS',
  ProductDistributorLeadTimeThreeFourDays = 'PRODUCT_DISTRIBUTOR_LEAD_TIME_THREE_FOUR_DAYS',
  ProductEstimatedInOurStore = 'PRODUCT_ESTIMATED_IN_OUR_STORE',
  ProductEstimatedInOurStoreNoDate = 'PRODUCT_ESTIMATED_IN_OUR_STORE_NO_DATE',
  ProductEtaLeadTimeEnumOne2TwoWeeks = 'PRODUCT_ETA_LEAD_TIME_ENUM_ONE2_TWO_WEEKS',
  ProductEtaLeadTimeEnumThree2FourWeeks = 'PRODUCT_ETA_LEAD_TIME_ENUM_THREE2_FOUR_WEEKS',
  ProductEtaLeadTimeEnumTwo2ThreeWeeks = 'PRODUCT_ETA_LEAD_TIME_ENUM_TWO2_THREE_WEEKS',
}

export type AxCategory = {
  accessoryGuideEnabled: Scalars['Boolean']['output']
  allUnspsc?: Maybe<Array<Maybe<Unspsc>>>
  attributes: Array<StructureGroupAttribute>
  co2?: Maybe<CategoryCo2>
  documentType: Scalars['String']['output']
  id: Scalars['String']['output']
  idPath: Scalars['String']['output']
  isLeaf: Scalars['Boolean']['output']
  keyPrefix: Scalars['String']['output']
  name: Scalars['String']['output']
  namePath?: Maybe<Scalars['String']['output']>
  parentId: Scalars['String']['output']
  partitionKey: Scalars['String']['output']
  recycledContent?: Maybe<RecycledContent>
  /** Returns the highest version Unspsc */
  unspsc?: Maybe<Unspsc>
  unspscLatest?: Maybe<Scalars['String']['output']>
  webCategoryId?: Maybe<Scalars['String']['output']>
}

export type Banner = {
  buttonText?: Maybe<Scalars['String']['output']>
  comment?: Maybe<Scalars['String']['output']>
  displayMode: Scalars['String']['output']
  endDateTimeUtc: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  productImageOverrideUrl?: Maybe<Scalars['String']['output']>
  relatedProductErpIdentifiers?: Maybe<Array<Scalars['String']['output']>>
  relatedProducts?: Maybe<Array<Product>>
  showOnCategories: Scalars['String']['output']
  startDateTimeUtc: Scalars['DateTime']['output']
  text?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type BannerDto = {
  fileName?: Maybe<Scalars['String']['output']>
  filePath?: Maybe<Scalars['String']['output']>
  fileSize: Scalars['Int']['output']
  pageId: Scalars['Int']['output']
}

export type BlogArticle = {
  categoryName: Scalars['String']['output']
  mainImage?: Maybe<Image>
  postDate: Scalars['DateTime']['output']
  postDateText: Scalars['String']['output']
  summary: Scalars['String']['output']
  tags: Array<Scalars['String']['output']>
  title: Scalars['String']['output']
  updatedDate: Scalars['DateTime']['output']
  url: Scalars['String']['output']
  youTubeId?: Maybe<Scalars['String']['output']>
}

export type BlogCategory = {
  name: Scalars['String']['output']
  summary?: Maybe<Scalars['String']['output']>
}

export type BlogPage = {
  articles: Array<BlogArticle>
  banner: Image
  breadcrumbs: Array<Breadcrumb>
  /** @deprecated Use FullCategories instead, which should replace this property in the future. */
  categories: Array<Scalars['String']['output']>
  categoryTags: Array<ArticleTagCount>
  description: Scalars['String']['output']
  disableSiteSelector: Scalars['Boolean']['output']
  fullCategories: Array<BlogCategory>
  header: Scalars['String']['output']
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  numberOfArticles: Scalars['Int']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export type Brand = {
  logo?: Maybe<Image>
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BrandContent = {
  bigHeader: Scalars['Boolean']['output']
  brandName?: Maybe<Scalars['String']['output']>
  campaignOnly: Scalars['Boolean']['output']
  categoryPath?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  contentBlocks: Array<GridBlock>
  cssClass: Scalars['String']['output']
  cssStyle?: Maybe<Scalars['String']['output']>
  header?: Maybe<Scalars['String']['output']>
  image?: Maybe<Image>
  newProductsOnly: Scalars['Boolean']['output']
  outerCssClass: Scalars['String']['output']
  outerCssStyle: Scalars['String']['output']
  searchPhrase?: Maybe<Scalars['String']['output']>
  showMoreText?: Maybe<Scalars['String']['output']>
  showMoreUrl?: Maybe<Scalars['String']['output']>
  textFirst: Scalars['Boolean']['output']
  type: BrandContentType
}

export type BrandContentNavigationItem = {
  displayName: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  subNavigationItems: Array<BrandContentSubNavigationItem>
  url: Scalars['String']['output']
}

export type BrandContentPage = {
  allBrandsUrl: Scalars['String']['output']
  breadcrumbs: Array<Breadcrumb>
  content: Array<BrandContent>
  disableSiteSelector: Scalars['Boolean']['output']
  header?: Maybe<Scalars['String']['output']>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  navigationItems: Array<BrandContentNavigationItem>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export type BrandContentSubNavigationItem = {
  displayName: Scalars['String']['output']
  subNavigationItems: Array<BrandContentSubNavigationItem>
  url: Scalars['String']['output']
}

export enum BrandContentType {
  ActivityBanner = 'ACTIVITY_BANNER',
  HeaderBanner = 'HEADER_BANNER',
  HtmlBlock = 'HTML_BLOCK',
  ProductFilterBlock = 'PRODUCT_FILTER_BLOCK',
  ProductGroup = 'PRODUCT_GROUP',
  ShopByBrandSectionsContentBlocks = 'SHOP_BY_BRAND_SECTIONS_CONTENT_BLOCKS',
}

export type BrandListPage = {
  brands: Array<Brand>
  breadcrumbs: Array<Breadcrumb>
  disableSiteSelector: Scalars['Boolean']['output']
  header: Scalars['String']['output']
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export type BrandNavigation = {
  allBrandsUrl: Scalars['String']['output']
  brands: Array<Brand>
}

export type BrandPage = {
  allBrandsUrl: Scalars['String']['output']
  breadcrumbs: Array<Breadcrumb>
  description: Scalars['String']['output']
  disableSiteSelector: Scalars['Boolean']['output']
  header: Scalars['String']['output']
  logo?: Maybe<Image>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
  url: Scalars['String']['output']
}

export type BreadCrumb = {
  label?: Maybe<Scalars['String']['output']>
  path?: Maybe<Scalars['String']['output']>
}

export type Breadcrumb = {
  displayName: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BusinessCustomer = {
  addresses?: Maybe<Array<Maybe<Address>>>
  assortmentGroupId: Scalars['Int']['output']
  assortmentGroupName?: Maybe<Scalars['String']['output']>
  assortments?: Maybe<Array<Maybe<CustomerAssortment>>>
  attestEnabled: Scalars['Boolean']['output']
  bidGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  billingAddress?: Maybe<Address>
  blocked: Scalars['Boolean']['output']
  businessType: Scalars['Int']['output']
  cellPhone?: Maybe<Scalars['String']['output']>
  chargeGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdInSystem?: Maybe<Scalars['String']['output']>
  creditCheckAnswer?: Maybe<Scalars['String']['output']>
  creditCheckProvider?: Maybe<Scalars['String']['output']>
  creditLimit: Scalars['Decimal']['output']
  creditLimitLastModifiedDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  customerClassificationType: CustomerClassificationType
  customerGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  customerType: UserType
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  deliveryModeOverride: Scalars['Boolean']['output']
  deliveryStatus: CustomerQueryDeliveryStatus
  electronicAddresses?: Maybe<Array<Maybe<ElectronicAddress>>>
  electronicInvoiceReceiverList?: Maybe<Array<Maybe<ElectronicInvoiceReceiver>>>
  email?: Maybe<Scalars['String']['output']>
  erpIdentifier?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  inactive: Scalars['Boolean']['output']
  invoiceEmail?: Maybe<Scalars['String']['output']>
  invoiceType: CustomerInvoiceType
  isCustomerReferenceMandatory: Scalars['Boolean']['output']
  isGoodsMarkMandatory: Scalars['Boolean']['output']
  isGuestCustomer: Scalars['Boolean']['output']
  isInvoiceCostCenterMandatory: Scalars['Boolean']['output']
  isPurchaseOrderNumberMandatory: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  offersByEmail: Scalars['Boolean']['output']
  organizationNumber?: Maybe<Scalars['String']['output']>
  paymentTermsErpIdentifier?: Maybe<Scalars['String']['output']>
  priceGroupLineDiscount?: Maybe<Scalars['String']['output']>
  priceGroupStatic?: Maybe<Scalars['String']['output']>
  productFilterErpIdentifier?: Maybe<Scalars['String']['output']>
  rentalAgreementId?: Maybe<Scalars['String']['output']>
  rentalDisabled: Scalars['Boolean']['output']
  rentalOfferId?: Maybe<Scalars['String']['output']>
  sendCatalog: Scalars['Boolean']['output']
  shippingAddress?: Maybe<Address>
  skiNumber?: Maybe<Scalars['String']['output']>
  sourcingCompany: SourcingCompanyInput
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
  vatRegistrationNumber?: Maybe<Scalars['String']['output']>
}

export enum ByUrlState {
  HasNoLogin = 'HAS_NO_LOGIN',
  IsLockedOut = 'IS_LOCKED_OUT',
  Ok = 'OK',
  UnexpectedError = 'UNEXPECTED_ERROR',
}

export enum CampaignType {
  Campaign = 'CAMPAIGN',
  LimitedBatch = 'LIMITED_BATCH',
  NewLowerPrice = 'NEW_LOWER_PRICE',
}

export enum CanContactCreateRmaStatus {
  ContactIsNotAllowed = 'CONTACT_IS_NOT_ALLOWED',
  Ok = 'OK',
  WrongPurchaseIsDeniedOnlyUnopen = 'WRONG_PURCHASE_IS_DENIED_ONLY_UNOPEN',
  WrongPurchaseIsDeniedOver60Days = 'WRONG_PURCHASE_IS_DENIED_OVER60_DAYS',
}

export type CancelContactInvitationRequestInput = {
  contactId: Scalars['Int']['input']
}

export type CancelPreOrderRequestInput = {
  preOrderId: Scalars['Int']['input']
}

export type Cart = {
  id: Scalars['Int']['output']
  items: Array<CartItem>
}

export type CartItem = {
  comment?: Maybe<Scalars['String']['output']>
  endUserInformation?: Maybe<Array<Maybe<EndUserInformation>>>
  id: Scalars['Int']['output']
  isDependent: Scalars['Boolean']['output']
  isMandatory: Scalars['Boolean']['output']
  mainProductErpIdentifier?: Maybe<Scalars['String']['output']>
  parentCartItemId?: Maybe<Scalars['Int']['output']>
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  quantity: Scalars['Int']['output']
}

export type CartItemInput = {
  lastViewedPriceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>
  lastViewedPriceIncludingVat?: InputMaybe<Scalars['Decimal']['input']>
  lastViewedVatAmount?: InputMaybe<Scalars['Decimal']['input']>
  parentCartItemId?: InputMaybe<Scalars['Int']['input']>
  productErpIdentifier: Scalars['String']['input']
  quantity: Scalars['Int']['input']
}

export type CartItemParamInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  mainProductErpIdentifier: Scalars['String']['input']
  parentCartItemId?: InputMaybe<Scalars['Int']['input']>
  productErpIdentifier: Scalars['String']['input']
  quantity: Scalars['Int']['input']
}

export type CartItemResult = {
  comment?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  isDependent: Scalars['Boolean']['output']
  isMandatory: Scalars['Boolean']['output']
  mainProductErpIdentifier?: Maybe<Scalars['String']['output']>
  parentCartItemId: Scalars['Int']['output']
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  quantity: Scalars['Int']['output']
}

export type CartPageRecommendations = {
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  productReferences: Array<ProductReference>
}

export type CartProduct = {
  availabilityInformation?: Maybe<AccountGraphql_Availability>
  displayName?: Maybe<Scalars['String']['output']>
  freeFreight: Scalars['Boolean']['output']
  isRentable: Scalars['Boolean']['output']
  manufacturer?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
  nonReturnable: Scalars['Boolean']['output']
  price?: Maybe<CartProductPrice>
  priceDisplay?: Maybe<Scalars['String']['output']>
  primaryImageId?: Maybe<Scalars['String']['output']>
  primaryVendorId?: Maybe<Scalars['String']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  productForAvailability?: Maybe<Product>
  productType: ProductType
  wayOfTransport: WayOfTransport
}

export type CartProductPrice = {
  bidSourceLocally: Scalars['Boolean']['output']
  excludingVat: Scalars['Decimal']['output']
  includingVat: Scalars['Decimal']['output']
  isBidPrice: Scalars['Boolean']['output']
  serviceDuration?: Maybe<Scalars['Int']['output']>
  vat: Scalars['Decimal']['output']
}

export type CartTotals = {
  subTotals?: Maybe<Array<Maybe<SubTotal>>>
  totalExcludingVat: Scalars['Decimal']['output']
  totalIncludingVat: Scalars['Decimal']['output']
  totalQuantity: Scalars['Decimal']['output']
  totalVat: Scalars['Decimal']['output']
}

export type CaseDetailModel = {
  created: Scalars['DateTime']['output']
  description: Scalars['String']['output']
  modified: Scalars['DateTime']['output']
  orderErpIdentifier: Scalars['String']['output']
  productList: Array<CaseDetailProductModel>
  products: Scalars['String']['output']
  status: CaseStatus
  statusReason: CaseStatusReason
  ticket: Scalars['String']['output']
  type: CaseType
}

export type CaseDetailProductModel = {
  description: Scalars['String']['output']
  productDetails?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  quantity: Scalars['Int']['output']
}

export type CaseReferenceModel = {
  created: Scalars['DateTime']['output']
  modified: Scalars['DateTime']['output']
  orderErpIdentifier: Scalars['String']['output']
  status: CaseStatus
  statusReason: CaseStatusReason
  ticket: Scalars['String']['output']
  type: CaseType
}

export enum CaseStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  None = 'NONE',
  Resolved = 'RESOLVED',
}

export enum CaseStatusReason {
  AddressTagSent = 'ADDRESS_TAG_SENT',
  BackFromService = 'BACK_FROM_SERVICE',
  Canceled = 'CANCELED',
  ClosedWaitingForMoney = 'CLOSED_WAITING_FOR_MONEY',
  Created = 'CREATED',
  CreditOrReplacement = 'CREDIT_OR_REPLACEMENT',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  None = 'NONE',
  NoHandling = 'NO_HANDLING',
  ProblemSolved = 'PROBLEM_SOLVED',
  ProductReceived = 'PRODUCT_RECEIVED',
  ReferredToOtherDepartment = 'REFERRED_TO_OTHER_DEPARTMENT',
  ReferredToSupport = 'REFERRED_TO_SUPPORT',
  SentToServiceProvider = 'SENT_TO_SERVICE_PROVIDER',
  Solved = 'SOLVED',
  WaitingForDetails = 'WAITING_FOR_DETAILS',
}

export enum CaseType {
  DamagedInTransit = 'DAMAGED_IN_TRANSIT',
  DefectiveProduct = 'DEFECTIVE_PRODUCT',
  IncorrectDelivery = 'INCORRECT_DELIVERY',
  MissingDelivery = 'MISSING_DELIVERY',
  MissingProduct = 'MISSING_PRODUCT',
  None = 'NONE',
  WrongPurchase = 'WRONG_PURCHASE',
  WrongSpecification = 'WRONG_SPECIFICATION',
}

export type Category = {
  axCategoryId?: Maybe<Scalars['String']['output']>
  banners?: Maybe<Array<Maybe<Banner>>>
  categoryIcon: Scalars['String']['output']
  categoryImageFileName?: Maybe<Scalars['String']['output']>
  categoryImages: Array<CategoryImages>
  children?: Maybe<Array<Category>>
  classification?: Maybe<Scalars['String']['output']>
  documentType: Scalars['String']['output']
  englishCategoryName?: Maybe<Scalars['String']['output']>
  englishName?: Maybe<Scalars['String']['output']>
  englishNamePath?: Maybe<Scalars['String']['output']>
  englishPathSlug?: Maybe<Scalars['String']['output']>
  foPathSlug?: Maybe<Scalars['String']['output']>
  hasAccessoryGuideEnabled: Scalars['Boolean']['output']
  hasAccessoryGuides: Scalars['Boolean']['output']
  hasVisibleProducts: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  idPath: Scalars['String']['output']
  isLeaf: Scalars['Boolean']['output']
  keyPrefix: Scalars['String']['output']
  language: Language
  lastModified?: Maybe<Scalars['DateTime']['output']>
  mostPopularProduct?: Maybe<ProductReference>
  name?: Maybe<Scalars['String']['output']>
  namePath?: Maybe<Scalars['String']['output']>
  navigation?: Maybe<NavigationByCategory>
  parentId: Scalars['String']['output']
  partitionKey: Scalars['String']['output']
  pathSlug: Scalars['String']['output']
  productLists?: Maybe<CategoryProductLists>
  productSearch?: Maybe<ProductsByCategory>
  seoLongCategoryTitle: Array<QualifiedValueOfString>
  seoLongTitleName?: Maybe<Scalars['String']['output']>
  seoMetaDescription?: Maybe<Scalars['String']['output']>
  seoText?: Maybe<Scalars['String']['output']>
  seoTitle?: Maybe<Scalars['String']['output']>
  sortOrder: Scalars['Int']['output']
}

export type CategoryNavigationArgs = {
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
}

export type CategoryProductSearchArgs = {
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortBy>
}

export type CategoryAccessory = {
  articleAssortment: Scalars['String']['output']
  articleAxCategory: Scalars['String']['output']
  articleId: Scalars['String']['output']
  articleManufacturerId: Scalars['String']['output']
  axCategoryId: Scalars['String']['output']
  currency: Scalars['String']['output']
  customerType: Scalars['String']['output']
  dependent: Scalars['Boolean']['output']
  displayOrder: Scalars['Int']['output']
  id: Scalars['String']['output']
  itemGroup: Scalars['String']['output']
  mandatory: Scalars['Boolean']['output']
  manufacturerId: Scalars['String']['output']
  maxPrice: Scalars['Decimal']['output']
  minPrice: Scalars['Decimal']['output']
  placement: Placement
  priority: Scalars['String']['output']
  productLifecycle?: Maybe<Array<ProductLifecycle>>
  sourcingCompany: Scalars['String']['output']
  specificationFilter: Scalars['String']['output']
  type: AccessoryType
}

export type CategoryCo2 = {
  endOfLifeKgCo2Eq?: Maybe<Scalars['Decimal']['output']>
  manufacturingKgCo2Eq?: Maybe<Scalars['Decimal']['output']>
  transportationKgCo2Eq?: Maybe<Scalars['Decimal']['output']>
  useKgCo2Eq?: Maybe<Scalars['Decimal']['output']>
}

export type CategoryDto = {
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  pageId: Scalars['Int']['output']
  productCount: Scalars['Int']['output']
}

export type CategoryImages = {
  categoryId: Scalars['String']['output']
  imageFileName: Scalars['String']['output']
}

export type CategoryNavigation = {
  breadcrumbs?: Maybe<Array<Maybe<BreadCrumb>>>
  navigationGroup?: Maybe<CategoryNavigationGroup>
}

export type CategoryNavigationGroup = {
  categoryChildItems?: Maybe<Array<Maybe<ProductCategoryChildNavigationItem>>>
  categorySiblingItems?: Maybe<Array<Maybe<CategoryNavigationItem>>>
  categoryTreeItems?: Maybe<Array<Maybe<CategoryNavigationItem>>>
}

export type CategoryNavigationItem = {
  category?: Maybe<Category>
  categoryDisplayName?: Maybe<Scalars['String']['output']>
  categoryEnglishDisplayName?: Maybe<Scalars['String']['output']>
  categoryId: Scalars['String']['output']
  children?: Maybe<Array<Maybe<CategoryNavigationItem>>>
  hits: Scalars['Int']['output']
  productCategoryPimIdentifier?: Maybe<Scalars['Int']['output']>
  selected: Scalars['Boolean']['output']
  sortOrder: Scalars['Int']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type CategoryNavigationTreeItem = {
  categoryDisplayName: Scalars['String']['output']
  categoryEnglishDisplayName: Scalars['String']['output']
  categoryId: Scalars['String']['output']
  categoryIdPath: Scalars['String']['output']
  categoryPathSlug: Scalars['String']['output']
  children: Array<CategoryNavigationTreeItem>
  hits: Scalars['Int']['output']
  selected: Scalars['Boolean']['output']
  ticket: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type CategoryProductLists = {
  ads: Array<AdContainer>
  bestsellers: ProductReferenceList
  campaignProducts: ProductReferenceList
  newProducts: ProductReferenceList
  popularAccessories: ProductReferenceList
}

export type CategoryProductListsBestsellersArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryProductListsCampaignProductsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryProductListsNewProductsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryProductListsPopularAccessoriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type CertificationItem = {
  name: Scalars['String']['output']
  typeValue: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ChangePasswordBasicResult = {
  ok: Scalars['Boolean']['output']
}

export type ChangePasswordRequestInput = {
  confirmNewPassword: Scalars['String']['input']
  newPassword: Scalars['String']['input']
  oldPassword: Scalars['String']['input']
}

export enum Channel {
  B2B = 'B2B',
  B2Bb2C = 'B2BB2C',
  B2C = 'B2C',
  Undefined = 'UNDEFINED',
}

export enum ChargeType {
  ChemicalTax = 'CHEMICAL_TAX',
  Delivery = 'DELIVERY',
  DeliveryInsurance = 'DELIVERY_INSURANCE',
  DiscountCopy = 'DISCOUNT_COPY',
  DiscountCopyInternal = 'DISCOUNT_COPY_INTERNAL',
  DiscountVoucher = 'DISCOUNT_VOUCHER',
  DiscountVoucherOrderTotal = 'DISCOUNT_VOUCHER_ORDER_TOTAL',
  DiscountVoucherSelection = 'DISCOUNT_VOUCHER_SELECTION',
  DiscountVoucherShipping = 'DISCOUNT_VOUCHER_SHIPPING',
  InvoicePayment = 'INVOICE_PAYMENT',
  Kickback = 'KICKBACK',
  None = 'NONE',
}

export type Charger = {
  isIncluded: Scalars['Boolean']['output']
  isUsbPdSupported: Scalars['Boolean']['output']
  maxW?: Maybe<Scalars['Float']['output']>
  minW?: Maybe<Scalars['Float']['output']>
}

export type CheckoutPaymentMethod = {
  available: Scalars['Boolean']['output']
  creditLimitRequired: Scalars['Boolean']['output']
  description?: Maybe<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  hasMonthlyCost: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  imageName?: Maybe<Scalars['String']['output']>
  invoiceType: InvoiceType
  isCreditCard: Scalars['Boolean']['output']
  isExpressDeliveryAllowed: Scalars['Boolean']['output']
  isPayLater: Scalars['Boolean']['output']
  isRental: Scalars['Boolean']['output']
  monthlyCost?: Maybe<MonthlyCostDto>
  monthlyCostExcludingVat?: Maybe<Scalars['Decimal']['output']>
  monthlyCostIncludingVat?: Maybe<Scalars['Decimal']['output']>
  paymentCharge?: Maybe<PaymentCharge>
  paymentMethodGroupId: Scalars['Int']['output']
  paymentServiceProvider?: Maybe<Scalars['String']['output']>
  paymentServiceProviderParameters?: Maybe<
    Array<Maybe<PaymentMethodPaymentServiceProviderParameter>>
  >
  paymentTermsErpIdentifier?: Maybe<Scalars['String']['output']>
  paymentType?: Maybe<Scalars['String']['output']>
  requiresAddressLookup: Scalars['Boolean']['output']
  requiresBillingAddress: Scalars['Boolean']['output']
  requiresSocialSecurityNumber: Scalars['Boolean']['output']
  selected: Scalars['Boolean']['output']
  unavailableMessage?: Maybe<Scalars['String']['output']>
}

export type CompactOrderDto = {
  grandTotalExcludingVat: Scalars['Decimal']['output']
  grandTotalIncludingVat: Scalars['Decimal']['output']
  invoiceDueDate?: Maybe<Scalars['DateTime']['output']>
  invoiceDueDateExpired?: Maybe<Scalars['Boolean']['output']>
  orderChipStatus?: Maybe<OrderChipStatus>
  orderDateUtc: Scalars['DateTime']['output']
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderId: Scalars['Int']['output']
  orderItems?: Maybe<Array<Maybe<CompactOrderItemDto>>>
  orderState: OrderState
  paymentChipStatus?: Maybe<OrderPaymentChipStatus>
  paymentState: PaymentState
  preOrderId?: Maybe<Scalars['Int']['output']>
  priceDisplay?: Maybe<Scalars['String']['output']>
}

export type CompactOrderItemDto = {
  orderItemId: Scalars['Int']['output']
  orderItemState: OrderItemState
}

export type CompactPreOrder = {
  createdDateTimeUtc: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  placedByFirstName?: Maybe<Scalars['String']['output']>
  placedByLastName?: Maybe<Scalars['String']['output']>
  status: PreOrderAttestState
}

export type Comparisons = {
  productLists: Array<ProductList>
}

export type ConnectedListContact = {
  companyName: Scalars['String']['output']
  customerClassificationType?: Maybe<CustomerClassificationType>
  customerErpIdentifier?: Maybe<Scalars['String']['output']>
  customerId: Scalars['Int']['output']
  email: Scalars['String']['output']
  erpId?: Maybe<Scalars['String']['output']>
  fullName: Scalars['String']['output']
  id: Scalars['Int']['output']
  isB2B: Scalars['Boolean']['output']
  isBlocked: Scalars['Boolean']['output']
  isInactive: Scalars['Boolean']['output']
  isManaged: Scalars['Boolean']['output']
  isPrimary: Scalars['Boolean']['output']
  isPunchOut: Scalars['Boolean']['output']
  isSuperUser: Scalars['Boolean']['output']
  loginUrl: Scalars['String']['output']
  sourcingCompany: SourcingCompanyInput
  userIdentifier: Scalars['UUID']['output']
}

export type ConsumerCustomer = {
  addresses?: Maybe<Array<Maybe<Address>>>
  assortmentGroupId: Scalars['Int']['output']
  assortmentGroupName?: Maybe<Scalars['String']['output']>
  assortments?: Maybe<Array<Maybe<CustomerAssortment>>>
  bidGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  blocked: Scalars['Boolean']['output']
  chargeGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdInSystem?: Maybe<Scalars['String']['output']>
  creditCheckAnswer?: Maybe<Scalars['String']['output']>
  creditCheckProvider?: Maybe<Scalars['String']['output']>
  creditLimit: Scalars['Decimal']['output']
  creditLimitLastModifiedDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  customerClassificationType: CustomerClassificationType
  customerGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  customerType: UserType
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  deliveryModeOverride: Scalars['Boolean']['output']
  deliveryStatus: CustomerQueryDeliveryStatus
  electronicAddresses?: Maybe<Array<Maybe<ElectronicAddress>>>
  electronicInvoiceReceiverList?: Maybe<Array<Maybe<ElectronicInvoiceReceiver>>>
  erpIdentifier?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  inactive: Scalars['Boolean']['output']
  invoiceEmail?: Maybe<Scalars['String']['output']>
  invoiceType: CustomerInvoiceType
  isGuestCustomer: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  offersByEmail: Scalars['Boolean']['output']
  paymentTermsErpIdentifier?: Maybe<Scalars['String']['output']>
  priceGroupLineDiscount?: Maybe<Scalars['String']['output']>
  priceGroupStatic?: Maybe<Scalars['String']['output']>
  productFilterErpIdentifier?: Maybe<Scalars['String']['output']>
  rentalAgreementId?: Maybe<Scalars['String']['output']>
  rentalOfferId?: Maybe<Scalars['String']['output']>
  sendCatalog: Scalars['Boolean']['output']
  socialSecurityNumber?: Maybe<Scalars['String']['output']>
  sourcingCompany: SourcingCompanyInput
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type Contact = {
  accountTermsAccepted: Scalars['Boolean']['output']
  addresses?: Maybe<Array<Maybe<Address>>>
  billingAddress?: Maybe<Address>
  blockWebLogin: Scalars['Boolean']['output']
  businessCustomer?: Maybe<BusinessCustomer>
  businessCustomerId?: Maybe<Scalars['Int']['output']>
  canSeeAllOrders: Scalars['Boolean']['output']
  cannotManageAddresses: Scalars['Boolean']['output']
  cellPhone?: Maybe<Scalars['String']['output']>
  connectedContacts?: Maybe<Array<ConnectedListContact>>
  consumerCustomerId?: Maybe<Scalars['Int']['output']>
  contactInvitationStatus?: Maybe<Scalars['String']['output']>
  createdDateTimeUtc: Scalars['DateTime']['output']
  createdInSystem?: Maybe<Scalars['String']['output']>
  customer?: Maybe<Customer>
  customerReferenceCostCenter?: Maybe<Scalars['String']['output']>
  customerReferenceName?: Maybe<Scalars['String']['output']>
  electronicAddresses?: Maybe<Array<Maybe<ElectronicAddress>>>
  email?: Maybe<Scalars['String']['output']>
  erpIdentifier?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  inactive: Scalars['Boolean']['output']
  invoiceEmail?: Maybe<Scalars['String']['output']>
  invoiceType: CustomerInvoiceType
  isPrimary: Scalars['Boolean']['output']
  isPunchOutUser: Scalars['Boolean']['output']
  languageCode?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  needsToAcceptPrivacyTerms: Scalars['Boolean']['output']
  offersByEmail: Scalars['Boolean']['output']
  phone?: Maybe<Scalars['String']['output']>
  preCalculatePrices: Scalars['Boolean']['output']
  preselectedBillingAddressId?: Maybe<Scalars['Int']['output']>
  preselectedShippingAddressId?: Maybe<Scalars['Int']['output']>
  preventFromPlacingOrders: Scalars['Boolean']['output']
  priceFeedType?: Maybe<PriceFeedType>
  productFilterErpIdentifier?: Maybe<Scalars['String']['output']>
  profilingAccepted: Scalars['Boolean']['output']
  sendCatalog: Scalars['Boolean']['output']
  sendSolutionsMagazine: Scalars['Boolean']['output']
  shippingAddress?: Maybe<Address>
  sourcingCompany: SourcingCompanyInput
  superUser: Scalars['Boolean']['output']
  suppressCampaignsAndAccessories: Scalars['Boolean']['output']
  userIdentifier: Scalars['UUID']['output']
  userType: UserType
  visibility?: Maybe<ContactVisibility>
}

export enum ContactInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  None = 'NONE',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
}

export enum ContactInvitationValidationResult {
  AlreadyAccepted = 'ALREADY_ACCEPTED',
  AlreadyDeclined = 'ALREADY_DECLINED',
  InvalidActivationLink = 'INVALID_ACTIVATION_LINK',
  InvalidContact = 'INVALID_CONTACT',
  InvalidToken = 'INVALID_TOKEN',
  Ok = 'OK',
}

export type ContactModel = {
  cellphone?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ContactVisibility = {
  showAddresses: Scalars['Boolean']['output']
  showAttest: Scalars['Boolean']['output']
  showContacts: Scalars['Boolean']['output']
  showExternalOrders: Scalars['Boolean']['output']
  showInvoices: Scalars['Boolean']['output']
  showPreOrder: Scalars['Boolean']['output']
  showServices: Scalars['Boolean']['output']
}

export type ContactWithTypedCustomerResult = {
  attest: AttestModel
  availableDisplayInvoiceTypes?: Maybe<Array<CustomerInvoiceType>>
  availableDisplayLanguages: Array<Language>
  businessCustomer?: Maybe<BusinessCustomer>
  consumerCustomer?: Maybe<ConsumerCustomer>
  contact: Contact
  contextUsername: Scalars['String']['output']
  language: Language
  showInvoiceTypeDropdown: Scalars['Boolean']['output']
  username: Scalars['String']['output']
}

export type ContentLink = {
  isContentPageLink: Scalars['Boolean']['output']
  openInNewWindow: Scalars['Boolean']['output']
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ContentPart = {
  container: ContentPartContainerType
  content?: Maybe<Scalars['String']['output']>
}

export enum ContentPartContainerType {
  Fluid = 'FLUID',
  None = 'NONE',
  Normal = 'NORMAL',
}

export type ContentPartListType = {
  contentParts: Array<ContentPart>
}

export type ContentReference = {
  description?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  ticket?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type CreateActivationResult = {
  activationId?: Maybe<Scalars['UUID']['output']>
  messages?: Maybe<Array<Maybe<ErrorMessage>>>
  status: ActivationStatus
}

export type CreateAddressRequestInput = {
  addressLine: Scalars['String']['input']
  addressee: Scalars['String']['input']
  billing: Scalars['Boolean']['input']
  city: Scalars['String']['input']
  department: Scalars['String']['input']
  goodsReceiverName: Scalars['String']['input']
  houseNumber: Scalars['String']['input']
  houseNumberSuffix: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  shipping: Scalars['Boolean']['input']
  suppressValidation: Scalars['Boolean']['input']
}

export type CreateAddressResult = {
  addressId: Scalars['Int']['output']
}

export type CreateAttestGroupLevelCommandResult = {
  id: Scalars['Int']['output']
  level: Scalars['Int']['output']
}

export type CreateBannerDto = {
  logo?: Maybe<BannerDto>
  signedUrl?: Maybe<Scalars['String']['output']>
}

export type CreateBannerRequestInput = {
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  pageId: Scalars['Int']['input']
}

export type CreateCategoryRequestInput = {
  name: Scalars['String']['input']
  pageId: Scalars['Int']['input']
}

export type CreateGroupLevelRequestInput = {
  groupId: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type CreateGroupRequestInput = {
  name: Scalars['String']['input']
  useOnlyHighestAttestLevel: Scalars['Boolean']['input']
}

export type CreateGroupResult = {
  result: Scalars['Int']['output']
}

export type CreateLogoDto = {
  logo?: Maybe<LogoDto>
  signedUrl?: Maybe<Scalars['String']['output']>
}

export type CreateLogoRequestInput = {
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  pageId: Scalars['Int']['input']
}

export type CreatePageContentRequestInput = {
  content: Scalars['String']['input']
  header: Scalars['String']['input']
  lead: Scalars['String']['input']
  pageId: Scalars['Int']['input']
}

export type CreateProductRequestInput = {
  categoryId: Scalars['Int']['input']
  productErpIdentifier: Scalars['String']['input']
}

export type CreateRmaRequestInput = {
  caseType: CaseType
  description: Scalars['String']['input']
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  orderErpIdentifier: Scalars['String']['input']
  phone: Scalars['String']['input']
  products: Array<ProductModelInput>
}

export type CreateRmaResult = {
  canContactCreateRmaStatus: CanContactCreateRmaStatus
}

export enum Currency {
  Dkk = 'DKK',
  Eur = 'EUR',
  Nok = 'NOK',
  None = 'NONE',
  Sek = 'SEK',
}

export type Customer = {
  addresses?: Maybe<Array<Maybe<Address>>>
  assortmentGroupId: Scalars['Int']['output']
  assortmentGroupName?: Maybe<Scalars['String']['output']>
  assortments?: Maybe<Array<Maybe<CustomerAssortment>>>
  bidGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  blocked: Scalars['Boolean']['output']
  chargeGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdInSystem?: Maybe<Scalars['String']['output']>
  creditCheckAnswer?: Maybe<Scalars['String']['output']>
  creditCheckProvider?: Maybe<Scalars['String']['output']>
  creditLimit: Scalars['Decimal']['output']
  creditLimitLastModifiedDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  customerClassificationType: CustomerClassificationType
  customerGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  customerType: UserType
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  deliveryModeOverride: Scalars['Boolean']['output']
  deliveryStatus: CustomerQueryDeliveryStatus
  electronicAddresses?: Maybe<Array<Maybe<ElectronicAddress>>>
  electronicInvoiceReceiverList?: Maybe<Array<Maybe<ElectronicInvoiceReceiver>>>
  erpIdentifier?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  inactive: Scalars['Boolean']['output']
  invoiceEmail?: Maybe<Scalars['String']['output']>
  invoiceType: CustomerInvoiceType
  isGuestCustomer: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  offersByEmail: Scalars['Boolean']['output']
  paymentTermsErpIdentifier?: Maybe<Scalars['String']['output']>
  priceGroupLineDiscount?: Maybe<Scalars['String']['output']>
  priceGroupStatic?: Maybe<Scalars['String']['output']>
  productFilterErpIdentifier?: Maybe<Scalars['String']['output']>
  rentalAgreementId?: Maybe<Scalars['String']['output']>
  rentalOfferId?: Maybe<Scalars['String']['output']>
  sendCatalog: Scalars['Boolean']['output']
  sourcingCompany: SourcingCompanyInput
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type CustomerAssortment = {
  assortmentErpIdentifier?: Maybe<Scalars['String']['output']>
  assortmentId: Scalars['Int']['output']
  erpRecordIdentifier?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  licenseAgreementNumber?: Maybe<Scalars['String']['output']>
}

export enum CustomerClassificationType {
  Corporate = 'CORPORATE',
  CurrencuGainLoss = 'CURRENCU_GAIN_LOSS',
  DkCorporate = 'DK_CORPORATE',
  DkHome = 'DK_HOME',
  DkPublic = 'DK_PUBLIC',
  DkSmbLarge = 'DK_SMB_LARGE',
  DkSmbMid = 'DK_SMB_MID',
  DkSmbSmall = 'DK_SMB_SMALL',
  FiCorporate = 'FI_CORPORATE',
  FiHome = 'FI_HOME',
  FiPublic = 'FI_PUBLIC',
  FiSmbLarge = 'FI_SMB_LARGE',
  FiSmbMid = 'FI_SMB_MID',
  FiSmbSmall = 'FI_SMB_SMALL',
  Home = 'HOME',
  IcInterCompany = 'IC_INTER_COMPANY',
  None = 'NONE',
  NoCorporate = 'NO_CORPORATE',
  NoHome = 'NO_HOME',
  NoLargeCorpDirect = 'NO_LARGE_CORP_DIRECT',
  NoPublic = 'NO_PUBLIC',
  NoSmbLarge = 'NO_SMB_LARGE',
  NoSmbMid = 'NO_SMB_MID',
  NoSmbSmall = 'NO_SMB_SMALL',
  ProMarketing = 'PRO_MARKETING',
  Public = 'PUBLIC',
  SeCorporate = 'SE_CORPORATE',
  SeHome = 'SE_HOME',
  SeIth = 'SE_ITH',
  SePublic = 'SE_PUBLIC',
  SeSmbLarge = 'SE_SMB_LARGE',
  SeSmbMid = 'SE_SMB_MID',
  SeSmbSmall = 'SE_SMB_SMALL',
  SmbLarge = 'SMB_LARGE',
  SmbMid = 'SMB_MID',
  SmbSmall = 'SMB_SMALL',
  Solutions = 'SOLUTIONS',
}

export type CustomerContact = {
  avatar?: Maybe<Image>
  email?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type CustomerContent = {
  categoryPaths?: Maybe<Array<Scalars['String']['output']>>
  displayAsList: Scalars['Boolean']['output']
  groupDisplayName?: Maybe<Scalars['String']['output']>
  groupProductLists?: Maybe<Array<CustomerContentProductGroupingProductList>>
  linkBoxes?: Maybe<Array<CustomerContentLinkBox>>
  listProductIds?: Maybe<Array<Scalars['String']['output']>>
  textContent?: Maybe<Scalars['String']['output']>
  type: CustomerContentType
}

export type CustomerContentLinkBox = {
  alternativeImageUrl?: Maybe<Scalars['String']['output']>
  image?: Maybe<Image>
  openInNewWindow: Scalars['Boolean']['output']
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type CustomerContentProductGroupingProductList = {
  displayAsList: Scalars['Boolean']['output']
  productIds: Array<Scalars['String']['output']>
}

export enum CustomerContentType {
  CategoryLinkBoxes = 'CATEGORY_LINK_BOXES',
  LinkBoxes = 'LINK_BOXES',
  ProductGrouping = 'PRODUCT_GROUPING',
  ProductList = 'PRODUCT_LIST',
  Text = 'TEXT',
}

export type CustomerInformation = {
  cellphone?: Maybe<Scalars['String']['output']>
  customerId: Scalars['Int']['output']
  customerOrderCount: Scalars['Int']['output']
  emailAddress?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  placedByContactId: Scalars['Int']['output']
}

export enum CustomerInvoiceType {
  Email = 'EMAIL',
  EmailAndPaper = 'EMAIL_AND_PAPER',
  None = 'NONE',
  NoPrint = 'NO_PRINT',
  Paper = 'PAPER',
  Xml = 'XML',
  XmlAndEmail = 'XML_AND_EMAIL',
  XmlAndPdf = 'XML_AND_PDF',
}

export type CustomerLink = {
  displayName: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type CustomerNavigation = {
  contacts: Array<CustomerContact>
  customerName: Scalars['String']['output']
  documentsAndLinks: Array<CustomerLink>
  landingPageUrl: Scalars['String']['output']
  logo?: Maybe<Image>
  parentCustomerLandingPageUrl?: Maybe<Scalars['String']['output']>
  parentCustomerName?: Maybe<Scalars['String']['output']>
  parentCustomerProductCategoryLinks: Array<CustomerLink>
  productCategoryLinks: Array<CustomerLink>
}

export type CustomerProductGroupPage = {
  breadcrumbs: Array<Breadcrumb>
  content: Array<CustomerContent>
  customerName: Scalars['String']['output']
  customerNavigation?: Maybe<CustomerNavigation>
  disableSiteSelector: Scalars['Boolean']['output']
  header: Scalars['String']['output']
  logo?: Maybe<Image>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export enum CustomerQueryDeliveryStatus {
  Complete = 'COMPLETE',
  Continuous = 'CONTINUOUS',
  Intermediate = 'INTERMEDIATE',
  None = 'NONE',
}

export type CustomerServiceInquiry = {
  fields: Array<CustomerServiceInquiryField>
  title: Scalars['String']['output']
}

export type CustomerServiceInquiryField = {
  allowMultipleSelections: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  options?: Maybe<Array<Scalars['String']['output']>>
  required: Scalars['Boolean']['output']
  rows: Scalars['Int']['output']
  type: QueryFieldType
  zendeskId?: Maybe<Scalars['String']['output']>
}

export type CustomerServiceInquiryFieldInput = {
  isDropdownField?: InputMaybe<Scalars['Boolean']['input']>
  label: Scalars['String']['input']
  values: Array<Scalars['String']['input']>
  zendeskId?: InputMaybe<Scalars['String']['input']>
}

export type CustomerStartPage = {
  breadcrumbs: Array<Breadcrumb>
  content: Array<CustomerContent>
  customerName: Scalars['String']['output']
  customerNavigation?: Maybe<CustomerNavigation>
  disableSiteSelector: Scalars['Boolean']['output']
  logo?: Maybe<Image>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export type CxmlDataResult = {
  authorizationCode?: Maybe<Scalars['String']['output']>
  contactId: Scalars['Int']['output']
  customerLandingPage?: Maybe<Scalars['URL']['output']>
  punchOutTicket: Scalars['UUID']['output']
  sessionUserIdentifier: Scalars['UUID']['output']
  state: CxmlDataState
}

export enum CxmlDataState {
  InvalidGuid = 'INVALID_GUID',
  InvalidSiteType = 'INVALID_SITE_TYPE',
  LoginNotFound = 'LOGIN_NOT_FOUND',
  MultipleContacts = 'MULTIPLE_CONTACTS',
  NoContacts = 'NO_CONTACTS',
  Ok = 'OK',
  TicketDoesNotExist = 'TICKET_DOES_NOT_EXIST',
}

export type CxmlPreDataResult = {
  xml?: Maybe<Scalars['String']['output']>
}

export enum DatePeriodType {
  All = 'ALL',
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  SixMonths = 'SIX_MONTHS',
  Specified = 'SPECIFIED',
  ThreeMonths = 'THREE_MONTHS',
  TwelveMonths = 'TWELVE_MONTHS',
  TwoWeeks = 'TWO_WEEKS',
}

export type DeclineContactInvitationResult = {
  status: ContactInvitationValidationResult
}

export type DeleteAddressRequestInput = {
  addressId: Scalars['Int']['input']
}

export type DeleteAddressesRequestInput = {
  addressIds: Array<Scalars['Int']['input']>
}

export type DeleteBannerRequestInput = {
  pageId: Scalars['Int']['input']
}

export type DeleteCategoryRequestInput = {
  categoryId: Scalars['Int']['input']
}

export type DeleteGroupLevelRequestInput = {
  id: Scalars['Int']['input']
}

export type DeleteGroupRequestInput = {
  groupId: Scalars['Int']['input']
}

export type DeleteLogoRequestInput = {
  pageId: Scalars['Int']['input']
}

export type DeleteProductListResult = {
  id: Scalars['Int']['output']
}

export type DeleteProductRequestInput = {
  categoryId: Scalars['Int']['input']
  productErpIdentifiers: Array<Scalars['String']['input']>
}

export type Delivery = {
  deliveryDateUtc?: Maybe<Scalars['DateTime']['output']>
  deliveryMethod?: Maybe<AccountGraphql_DeliveryMethod>
  deliveryPackages?: Maybe<Array<Maybe<DeliveryPackage>>>
  id: Scalars['Int']['output']
}

export type DeliveryDto = {
  deliveryDateUtc?: Maybe<Scalars['DateTime']['output']>
  deliveryMethod?: Maybe<DeliveryMethodDto>
  deliveryPackages?: Maybe<Array<Maybe<DeliveryPackageDto>>>
  id: Scalars['Int']['output']
}

export type DeliveryMethod = {
  description: Scalars['String']['output']
  displayName: Scalars['String']['output']
  shippingFee: Price
  shippingFeeExcludingVat: Scalars['Decimal']['output']
  shippingFeeVat: Scalars['Decimal']['output']
  shippingInsuranceFee: Price
  shippingInsuranceFeeExcludingVat: Scalars['Decimal']['output']
  shippingInsuranceFeeVat: Scalars['Decimal']['output']
  shippingWithInsuranceFee: Price
  totalFeeExcludingVat: Scalars['Decimal']['output']
  totalFeeVat: Scalars['Decimal']['output']
}

export type DeliveryMethodDto = {
  description?: Maybe<Scalars['String']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  shippingFeeExcludingVat: Scalars['Decimal']['output']
  shippingFeeVat: Scalars['Decimal']['output']
  shippingInsuranceFeeExcludingVat: Scalars['Decimal']['output']
  shippingInsuranceFeeVat: Scalars['Decimal']['output']
  totalFeeExcludingVat: Scalars['Decimal']['output']
  totalFeeVat: Scalars['Decimal']['output']
}

export type DeliveryPackage = {
  id: Scalars['Int']['output']
  trackingNumber?: Maybe<Scalars['String']['output']>
  trackingUrl?: Maybe<Scalars['String']['output']>
}

export type DeliveryPackageDto = {
  id: Scalars['Int']['output']
  trackingNumber?: Maybe<Scalars['String']['output']>
  trackingUrl?: Maybe<Scalars['String']['output']>
}

export type DescriptionAbTest = {
  optimizelyId: Scalars['String']['output']
  versionA: Scalars['String']['output']
  versionB: Scalars['String']['output']
}

export type DidYouMean = {
  rank: Scalars['Int']['output']
  relevance: Scalars['Decimal']['output']
  ticket?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type DimensionBase = {
  additionalProperty?: Maybe<Array<AdditionalProperty>>
  name: Scalars['String']['output']
  typeValue: Scalars['String']['output']
  unitCode: Scalars['String']['output']
  value: Scalars['String']['output']
}

export enum Direction {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

export type DurationOfWarranty = {
  typeValue: Scalars['String']['output']
  unitCode: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type EditorialPage = {
  body: Scalars['String']['output']
  breadcrumbs: Array<Breadcrumb>
  container: EditorialPageContainerType
  content: Array<GridBlock>
  disableSiteSelector: Scalars['Boolean']['output']
  dynamicBreadcrumbs: Scalars['Boolean']['output']
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export enum EditorialPageContainerType {
  Fluid = 'FLUID',
  None = 'NONE',
  Normal = 'NORMAL',
  Styledust = 'STYLEDUST',
}

export type ElectronicAddress = {
  electronicAddressType: ElectronicAddressType
  erpIdentifier?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  isPrimary: Scalars['Boolean']['output']
  value?: Maybe<Scalars['String']['output']>
}

export enum ElectronicAddressType {
  Cellphone = 'CELLPHONE',
  Email = 'EMAIL',
  Fax = 'FAX',
  None = 'NONE',
  OfficialPhoneNumber = 'OFFICIAL_PHONE_NUMBER',
  Phone = 'PHONE',
  Telex = 'TELEX',
  Url = 'URL',
}

export type ElectronicInvoiceReceiver = {
  id: Scalars['Int']['output']
  isDefault: Scalars['Boolean']['output']
  referenceText?: Maybe<Scalars['String']['output']>
  referenceValue?: Maybe<Scalars['String']['output']>
}

export enum EmailResponseType {
  AlreadySent = 'ALREADY_SENT',
  EmailAddressAlreadyExists = 'EMAIL_ADDRESS_ALREADY_EXISTS',
  Failed = 'FAILED',
  None = 'NONE',
  PartialSucess = 'PARTIAL_SUCESS',
  Success = 'SUCCESS',
}

export enum EmailStatus {
  EmailExists = 'EMAIL_EXISTS',
  IsFederated = 'IS_FEDERATED',
  Valid = 'VALID',
}

export type EndUserInformation = {
  id: Scalars['Int']['output']
  isMandatory: Scalars['Boolean']['output']
  label?: Maybe<Scalars['String']['output']>
  lineNumber: Scalars['Decimal']['output']
  value?: Maybe<Scalars['String']['output']>
}

export enum ErrorCode {
  GroupHasInvalidLevels = 'GROUP_HAS_INVALID_LEVELS',
  GroupHasNoLevels = 'GROUP_HAS_NO_LEVELS',
  GroupHasNoMembers = 'GROUP_HAS_NO_MEMBERS',
  LevelHasNoAttesters = 'LEVEL_HAS_NO_ATTESTERS',
}

export type ErrorMessage = {
  code?: Maybe<Scalars['String']['output']>
  field?: Maybe<Scalars['String']['output']>
}

export type ErrorResult = {
  hasError: Scalars['Boolean']['output']
  hasErrors: Scalars['Boolean']['output']
  messages?: Maybe<Array<Maybe<ErrorMessage>>>
}

export type ErrorResultHasErrorArgs = {
  errorCode?: InputMaybe<Scalars['String']['input']>
}

export type ExtendedDisplay = {
  description: Scalars['String']['output']
  descriptionIsAiGenerated: Scalars['Boolean']['output']
  descriptionIsMarkdown: Scalars['Boolean']['output']
  files: Array<ProductMediaDocumentType>
  imageIds: Array<Scalars['String']['output']>
  keySellingPoints: Array<Scalars['String']['output']>
  productErpIdentifier: Scalars['String']['output']
  seoText: Scalars['String']['output']
}

export type ExternalOrderDto = {
  billingAddress?: Maybe<Scalars['String']['output']>
  customerId: Scalars['Int']['output']
  externalOrderNumber?: Maybe<Scalars['String']['output']>
  grandTotalExcludingVat: Scalars['Decimal']['output']
  grandTotalExcludingVatDisplay?: Maybe<Scalars['String']['output']>
  grandTotalIncludingVat: Scalars['Decimal']['output']
  id: Scalars['Int']['output']
  orderDateUtc: Scalars['DateTime']['output']
  placedById: Scalars['Int']['output']
  shippingAddress?: Maybe<Scalars['String']['output']>
  shippingCost: Scalars['Decimal']['output']
}

export type ExternalOrderItemDto = {
  externalOrderId?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  priceValue: Scalars['Decimal']['output']
  priceValueDisplay?: Maybe<Scalars['String']['output']>
  priceVat: Scalars['Decimal']['output']
  priceVatDisplay?: Maybe<Scalars['String']['output']>
  productDisplayName?: Maybe<Scalars['String']['output']>
  quantityOrdered: Scalars['Int']['output']
  vendor?: Maybe<Scalars['String']['output']>
}

export type ExternalStockAvailability = {
  leadTime: ExternalStockLeadTime
  quantity: Scalars['Int']['output']
}

export enum ExternalStockLeadTime {
  Always = 'ALWAYS',
  FourSixDays = 'FOUR_SIX_DAYS',
  OneTwoDays = 'ONE_TWO_DAYS',
  SixEightDays = 'SIX_EIGHT_DAYS',
  TenTwelveDays = 'TEN_TWELVE_DAYS',
  ThreeFourDays = 'THREE_FOUR_DAYS',
}

export type Facet = {
  displayEnglishName: Scalars['String']['output']
  displayName: Scalars['String']['output']
  displayOrder: Scalars['Int']['output']
  facetOpened: Scalars['Boolean']['output']
  facetType: FacetType
  id: Scalars['String']['output']
  isTranslated: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  nameInUrl: Scalars['String']['output']
  ticket: Scalars['String']['output']
  totalNumberOfProducts: Scalars['Int']['output']
  type: FacetType
  unitText: Scalars['String']['output']
  values: Array<FacetValue>
}

export type FacetParameterInput = {
  name?: InputMaybe<Scalars['String']['input']>
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export enum FacetType {
  Boolean = 'BOOLEAN',
  Multiple = 'MULTIPLE',
  Range = 'RANGE',
}

export type FacetValue = {
  displayName?: Maybe<Scalars['String']['output']>
  hits: Scalars['Int']['output']
  id: Scalars['String']['output']
  max?: Maybe<Scalars['Decimal']['output']>
  min?: Maybe<Scalars['Decimal']['output']>
  name: Scalars['String']['output']
  selected: Scalars['Boolean']['output']
  ticket: Scalars['String']['output']
}

export type Favorites = {
  productLists?: Maybe<Array<Maybe<ProductList>>>
  productRecommendations?: Maybe<Array<ProductReference>>
}

export enum Field {
  CustomerPurchaseOrderNumber = 'CUSTOMER_PURCHASE_ORDER_NUMBER',
  PlacedByFirstName = 'PLACED_BY_FIRST_NAME',
  PreOrderAttestedDate = 'PRE_ORDER_ATTESTED_DATE',
  PreOrderCreatedDate = 'PRE_ORDER_CREATED_DATE',
  PreOrderId = 'PRE_ORDER_ID',
}

export type FoProductCategoryData = {
  brandPathSlug?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  pathSlug: Scalars['String']['output']
}

export type FoProductSpecificationCategoryData = {
  categoryText: Scalars['String']['output']
  specifications: Array<FoProductSpecificationData>
}

export type FoProductSpecificationData = {
  displayInProductTitle: Scalars['Boolean']['output']
  isPromoted: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  values: Array<Scalars['String']['output']>
}

export type Footer = {
  companyInfo: Scalars['String']['output']
  contactInfo?: Maybe<Scalars['String']['output']>
  navigationGroups: Array<FooterNavigationGroup>
  navigationGroups2: Array<FooterNavigationGroup>
  socialMediaLinks: SocialMediaLinks
}

export type FooterNavigationGroup = {
  header: Scalars['String']['output']
  links: Array<ContentLink>
}

export type Ga4EventInput = {
  name?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Array<KeyValuePairOfStringAndStringInput>>
}

export type Ga4Input = {
  clientId?: InputMaybe<Scalars['String']['input']>
  events?: InputMaybe<Array<InputMaybe<Ga4EventInput>>>
}

export type GdprContact = {
  companyName?: Maybe<Scalars['String']['output']>
  contactId: Scalars['Int']['output']
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
}

export type GdprErrand = {
  contact?: Maybe<GdprContact>
  createdDateTime?: Maybe<Scalars['DateTime']['output']>
  status: GdprErrandStatus
}

export enum GdprErrandStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  InProgress = 'IN_PROGRESS',
  None = 'NONE',
  Open = 'OPEN',
  WrongAccount = 'WRONG_ACCOUNT',
}

export type GetAddressSuggestionsRequestInput = {
  addressLine: Scalars['String']['input']
}

export type GetAddressSuggestionsResult = {
  addresses: Array<AddressSuggestionModel>
}

export enum GetAddressesQuerySortByValue {
  Addressee = 'ADDRESSEE',
  AddressLine = 'ADDRESS_LINE',
  AddressType = 'ADDRESS_TYPE',
  Created = 'CREATED',
  Department = 'DEPARTMENT',
  GoodsReceiverName = 'GOODS_RECEIVER_NAME',
  LastUsed = 'LAST_USED',
  PostalCode = 'POSTAL_CODE',
}

export type GetAddressesRequestInput = {
  addressTypes: Array<AddressType>
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  searchQuery: Scalars['String']['input']
  seeAllAddresses: Scalars['Boolean']['input']
  sortBy: GetAddressesQuerySortByValue
  sortByAscending: Scalars['Boolean']['input']
}

export type GetAddressesResult = {
  addresses?: Maybe<Array<Maybe<Address>>>
  numberOfPages: Scalars['Int']['output']
  pageNumber: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
}

export type GetAttestGroupInput = {
  groupId: Scalars['Int']['input']
}

export type GetAttestGroupResult = {
  group?: Maybe<AttestGroup>
}

export type GetAttestSummaryResult = {
  preOrdersToAttest: Scalars['Int']['output']
  preOrdersWaitingForAttest: Scalars['Int']['output']
}

export type GetBrandInfoResult = {
  descriptionHtml: Scalars['String']['output']
  logoUrl: Scalars['String']['output']
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type GetBusinessCustomerSettingsResult = {
  businessCustomerId: Scalars['Int']['output']
  enableCustomerPages: Scalars['Boolean']['output']
  showFrameAgreementBanner: Scalars['Boolean']['output']
}

export type GetByUrlDataResult = {
  customerLandingPage?: Maybe<Scalars['URL']['output']>
  orderId?: Maybe<Scalars['Int']['output']>
  state: ByUrlState
}

export type GetCampaignBannerResult = {
  buttonText: Scalars['String']['output']
  colorTheme: Scalars['String']['output']
  link?: Maybe<ContentLink>
  published: Scalars['DateTime']['output']
  text: Scalars['String']['output']
  title: Scalars['String']['output']
  unpublished: Scalars['DateTime']['output']
}

export type GetCartForCheckoutResult = {
  allItemsCanBeDeliveredImmediately: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  items?: Maybe<Array<Maybe<AccountGraphql_CartItem>>>
  totalPriceDisplay?: Maybe<Scalars['String']['output']>
  totals?: Maybe<CartTotals>
}

export type GetCaseRequestInput = {
  ticket: Scalars['String']['input']
}

export type GetCaseResult = {
  caseDetail: CaseDetailModel
}

export type GetCasesRequestInput = {
  endDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  searchPhrase: Scalars['String']['input']
  showAllCases: Scalars['Boolean']['input']
  startDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetCasesResult = {
  caseReferences: Array<CaseReferenceModel>
  totalCount: Scalars['Int']['output']
}

export type GetCategoriesDto = {
  categories?: Maybe<Array<CategoryDto>>
  totalCount: Scalars['Int']['output']
}

export type GetCompactOrdersResult = {
  orders?: Maybe<Array<CompactOrderDto>>
  pendingOrders: Scalars['Int']['output']
}

export type GetCompactPreOrderResult = {
  preOrders?: Maybe<Array<Maybe<CompactPreOrder>>>
  preOrdersToAttest?: Maybe<Array<Maybe<CompactPreOrder>>>
}

export type GetCompanyInfoQueryResult = {
  companyName?: Maybe<Scalars['String']['output']>
  disallowNewContacts: Scalars['Boolean']['output']
  isInvalidOrganizationNumber: Scalars['Boolean']['output']
  isRegisteredCompany: Scalars['Boolean']['output']
}

export type GetContactsForContactSelectorDto = {
  accountAndPrivacyTermsState: AccountAndPrivacyTermsState
  isFavorite: Scalars['Boolean']['output']
  lastLoginDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  needsToAcceptPrivacyTerms: Scalars['Boolean']['output']
}

export type GetCustomerPageCategoriesRequestInput = {
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type GetCustomerPageProductsRequestInput = {
  categoryId: Scalars['Int']['input']
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type GetExternalOrderItemsRequestInput = {
  externalOrderId: Scalars['Int']['input']
}

export type GetExternalOrderItemsResult = {
  orderItems?: Maybe<Array<Maybe<ExternalOrderItemDto>>>
}

export type GetExternalOrdersResult = {
  orders?: Maybe<Array<Maybe<ExternalOrderDto>>>
}

export type GetFederatedBusinessCustomerResult = {
  blocked: Scalars['Boolean']['output']
  companyName?: Maybe<Scalars['String']['output']>
  contactCanBeAdded: Scalars['Boolean']['output']
  customerId: Scalars['Int']['output']
  disallowNewContacts: Scalars['Boolean']['output']
  inactive: Scalars['Boolean']['output']
  organizationNumber?: Maybe<Scalars['String']['output']>
}

export type GetInvitedContactResult = {
  LoginStatus?: Maybe<InvitedContactLoginStatus>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  status: ContactInvitationValidationResult
}

export type GetInvoiceCopyRequestInput = {
  invoiceId: Scalars['Int']['input']
  sourcingCompany: SourcingCompanyInput
}

export type GetInvoiceCopyResult = {
  contentType?: Maybe<Scalars['String']['output']>
  fileContent?: Maybe<Array<Scalars['Byte']['output']>>
}

export type GetInvoiceDetailsRequestInput = {
  invoiceId: Scalars['Int']['input']
  seeAllInvoices: Scalars['Boolean']['input']
  sourcingCompany: SourcingCompanyInput
}

export type GetInvoiceDetailsResult = {
  charges?: Maybe<Array<Maybe<InvoiceCharge>>>
  createdDateUtc: Scalars['DateTime']['output']
  creditingInvoiceNumber?: Maybe<Scalars['String']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  customerErpIdentifier?: Maybe<Scalars['String']['output']>
  dueDateExpired: Scalars['Boolean']['output']
  dueDateUtc?: Maybe<Scalars['DateTime']['output']>
  externalInvoiceReferenceNumber?: Maybe<Scalars['String']['output']>
  grandTotalExcludingVat: Scalars['Decimal']['output']
  grandTotalIncludingVat: Scalars['Decimal']['output']
  grandTotalRoundOff: Scalars['Decimal']['output']
  grandTotalVat: Scalars['Decimal']['output']
  invoiceErpIdentifier?: Maybe<Scalars['String']['output']>
  invoiceItemsAmountExcludingVat: Scalars['Decimal']['output']
  invoiceItemsVatAmount: Scalars['Decimal']['output']
  invoiceOrders?: Maybe<Array<Maybe<Order>>>
  isCreditInvoice: Scalars['Boolean']['output']
  isReadyForDownload: Scalars['Boolean']['output']
  items?: Maybe<Array<Maybe<InvoiceItem>>>
  ocrNumber?: Maybe<Scalars['String']['output']>
  orderPaymentState: PaymentState
  paymentMethodId: Scalars['Int']['output']
  paymentState: PaymentState
  priceDisplay?: Maybe<InvoiceDetailPriceModel>
  pricesArePerMonth: Scalars['Boolean']['output']
}

export type GetInvoiceSummaryResult = {
  overdue: Scalars['Int']['output']
  unpaid: Scalars['Int']['output']
}

export enum GetInvoicesQuerySearchByValue {
  All = 'ALL',
  InvoiceErpIdentifier = 'INVOICE_ERP_IDENTIFIER',
  None = 'NONE',
  OcrNumber = 'OCR_NUMBER',
  OrderErpIdentifier = 'ORDER_ERP_IDENTIFIER',
}

export enum GetInvoicesQuerySortByValue {
  CreatedDate = 'CREATED_DATE',
  DueDate = 'DUE_DATE',
  GrandTotal = 'GRAND_TOTAL',
  InvoiceErpIdentifier = 'INVOICE_ERP_IDENTIFIER',
  None = 'NONE',
  OcrNumber = 'OCR_NUMBER',
}

export type GetInvoicesRequestInput = {
  datePeriod?: InputMaybe<DatePeriodType>
  endDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
  invoiceIds: Array<Scalars['Int']['input']>
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchBy: GetInvoicesQuerySearchByValue
  searchPhrase: Scalars['String']['input']
  seeAllInvoices: Scalars['Boolean']['input']
  showOnlyUnpaid: Scalars['Boolean']['input']
  sortBy: GetInvoicesQuerySortByValue
  sortByAscendingOrder: Scalars['Boolean']['input']
  sourcingCompany: SourcingCompanyInput
  startDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetInvoicesResult = {
  rows?: Maybe<Array<Maybe<InvoiceRow>>>
  totalCount: Scalars['Int']['output']
}

export type GetLatestBoughtProductsDto = {
  product?: Maybe<Product>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type GetLatestBoughtProductsResult = {
  products?: Maybe<Array<Maybe<GetLatestBoughtProductsDto>>>
}

export enum GetManageableContactsQuerySortBy {
  BlockWebLogin = 'BLOCK_WEB_LOGIN',
  CannotManageAddresses = 'CANNOT_MANAGE_ADDRESSES',
  CanSeeAllOrders = 'CAN_SEE_ALL_ORDERS',
  ContactInvitationDateUtc = 'CONTACT_INVITATION_DATE_UTC',
  ContactInvitationStatus = 'CONTACT_INVITATION_STATUS',
  Email = 'EMAIL',
  Name = 'NAME',
  SuperUser = 'SUPER_USER',
}

export type GetManageableContactsRequestInput = {
  contactInvitationStatuses: Array<ContactInvitationStatus>
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  searchQuery: Scalars['String']['input']
  sortBy: GetManageableContactsQuerySortBy
  sortByAscending: Scalars['Boolean']['input']
}

export type GetManageableContactsResult = {
  manageableContacts?: Maybe<Array<Maybe<Contact>>>
  totalCount: Scalars['Int']['output']
}

export type GetNavigationTreeResult = {
  categoryNavigationGroup?: Maybe<CategoryNavigationGroup>
  errorResponseMessage?: Maybe<Scalars['String']['output']>
}

export type GetNotificationBannerResult = {
  notificationButtonText: Scalars['String']['output']
  notificationButtonUrl: Scalars['String']['output']
  notificationContentList: Array<Scalars['String']['output']>
  notificationDescription: Scalars['String']['output']
  notificationDisplayEverywhere: Scalars['Boolean']['output']
  notificationDisplayUrls: Array<Scalars['String']['output']>
  notificationPrimaryButton: Scalars['Boolean']['output']
  notificationPublished: Scalars['String']['output']
  notificationTitle: Scalars['String']['output']
  notificationType: Scalars['String']['output']
  notificationUnpublished: Scalars['String']['output']
}

export type GetOffersByEmailStatusResult = {
  accepted: Scalars['Boolean']['output']
}

export type GetOrderConfirmationDetailRequestInput = {
  orderId: Scalars['Int']['input']
  token: Scalars['String']['input']
}

export type GetOrderDetailsForRmaRequestInput = {
  orderId: Scalars['Int']['input']
}

export type GetOrderDetailsRequestInput = {
  orderErpIdentifier?: InputMaybe<Scalars['String']['input']>
  orderId: Scalars['Int']['input']
  seeAllOrders: Scalars['Boolean']['input']
}

export type GetOrderDetailsResult = {
  accessories?: Maybe<AccountGraphql_Accessories>
  billingAddress?: Maybe<OrderDetailsShippingAddress>
  billingAddressId?: Maybe<Scalars['Int']['output']>
  canCreateRma: Scalars['Boolean']['output']
  canPayOrder: Scalars['Boolean']['output']
  canRequestPartialDelivery: Scalars['Boolean']['output']
  canResendPaymentConfirmation: Scalars['Boolean']['output']
  charges?: Maybe<Array<Maybe<OrderDetailsCharge>>>
  createdDateTimeUtc: Scalars['DateTime']['output']
  currencyCode: Currency
  customerInformation?: Maybe<CustomerInformation>
  deliveries?: Maybe<Array<Maybe<Delivery>>>
  deliveryMethodId: Scalars['Int']['output']
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  deliveryStatus: CustomerQueryDeliveryStatus
  grandTotalExcludingVat: Scalars['Decimal']['output']
  grandTotalVat: Scalars['Decimal']['output']
  invoiceInformation?: Maybe<InvoiceInformation>
  invoices?: Maybe<Array<Maybe<Invoice>>>
  items?: Maybe<Array<Maybe<OrderItem>>>
  lastPartialDeliveryRequestDateTime?: Maybe<Scalars['DateTime']['output']>
  latestPaymentState?: Maybe<OrderPaymentState>
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderId: Scalars['Int']['output']
  orderState: OrderState
  orderTotalExcludingVat: Scalars['Decimal']['output']
  orderTotalVat: Scalars['Decimal']['output']
  otherInformation?: Maybe<OtherInformation>
  paymentStates?: Maybe<Array<Maybe<OrderPaymentState>>>
  paymentType?: Maybe<Scalars['String']['output']>
  placedByContactId: Scalars['Int']['output']
  preOrderId?: Maybe<Scalars['Int']['output']>
  preOrderResult?: Maybe<GetPreOrderV2Result>
  pricesArePerMonth: Scalars['Boolean']['output']
  sentToErp: Scalars['Boolean']['output']
  shippingAddress?: Maybe<OrderDetailsShippingAddress>
  shippingAddressId: Scalars['Int']['output']
  showPartialDeliveryNotAvailable: Scalars['Boolean']['output']
}

export type GetOrderHistoryForProductDto = {
  canCreateRma: Scalars['Boolean']['output']
  createdDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderItemState: OrderItemState
  orderState: OrderState
  priceDisplay?: Maybe<PriceModel>
  priceValue: Scalars['Decimal']['output']
  priceVat: Scalars['Decimal']['output']
  pricesArePerMonth: Scalars['Boolean']['output']
  quantityAllocated: Scalars['Int']['output']
  quantityOrdered: Scalars['Int']['output']
  totalPriceValue: Scalars['Decimal']['output']
  totalPriceVat: Scalars['Decimal']['output']
}

export type GetOrderHistoryForProductRequestInput = {
  productErpIdentifier: Scalars['String']['input']
  seeAllOrders: Scalars['Boolean']['input']
}

export type GetOrderHistoryForProductResult = {
  orders?: Maybe<Array<Maybe<GetOrderHistoryForProductDto>>>
  quantities?: Maybe<ProductHistoryQuantityModel>
}

export enum GetOrderHistoryV2QuerySearchByValue {
  All = 'ALL',
  ContactName = 'CONTACT_NAME',
  CustomerPurchaseOrderNumber = 'CUSTOMER_PURCHASE_ORDER_NUMBER',
  None = 'NONE',
  OrderErpIdentifier = 'ORDER_ERP_IDENTIFIER',
  ProductDisplayName = 'PRODUCT_DISPLAY_NAME',
  ProductErpIdentifier = 'PRODUCT_ERP_IDENTIFIER',
  SerialNumber = 'SERIAL_NUMBER',
}

export enum GetOrderHistoryV2QuerySortByValue {
  ContactName = 'CONTACT_NAME',
  CustomerPurchaseOrderNumber = 'CUSTOMER_PURCHASE_ORDER_NUMBER',
  GrandTotal = 'GRAND_TOTAL',
  None = 'NONE',
  OrderDate = 'ORDER_DATE',
  OrderErpIdentifier = 'ORDER_ERP_IDENTIFIER',
  OrderState = 'ORDER_STATE',
  PaymentTypeName = 'PAYMENT_TYPE_NAME',
}

export type GetOrderHistoryV2Result = {
  orders?: Maybe<Array<Maybe<OrderDto>>>
  totalCount: Scalars['Int']['output']
}

export type GetOrdersRequestInput = {
  datePeriod?: InputMaybe<DatePeriodType>
  endDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
  excludeCancelled: Scalars['Boolean']['input']
  orderIds: Array<Scalars['Int']['input']>
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchBy: GetOrderHistoryV2QuerySearchByValue
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  seeAllOrders: Scalars['Boolean']['input']
  showOnlyOpenOrders: Scalars['Boolean']['input']
  showOnlyRmaOrders: Scalars['Boolean']['input']
  sortBy: GetOrderHistoryV2QuerySortByValue
  sortByAscendingOrder: Scalars['Boolean']['input']
  startDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetPreOrderInput = {
  preOrderId: Scalars['Int']['input']
}

export type GetPreOrderV2Result = {
  information?: Maybe<PreOrderInformationModel>
  preOrder?: Maybe<PreOrderV2>
}

export enum GetProductHistoryQuerySearchByValue {
  All = 'ALL',
  None = 'NONE',
  OrderErpIdentifier = 'ORDER_ERP_IDENTIFIER',
  ProductDisplayName = 'PRODUCT_DISPLAY_NAME',
  ProductErpIdentifier = 'PRODUCT_ERP_IDENTIFIER',
}

export enum GetProductHistoryQuerySortByValue {
  None = 'NONE',
  OrderItemCreatedDate = 'ORDER_ITEM_CREATED_DATE',
  ProductDisplayName = 'PRODUCT_DISPLAY_NAME',
  ProductErpIdentifier = 'PRODUCT_ERP_IDENTIFIER',
}

export type GetProductHistoryRequestInput = {
  datePeriod?: InputMaybe<DatePeriodType>
  endDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
  excludeCancelled: Scalars['Boolean']['input']
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchBy: GetProductHistoryQuerySearchByValue
  searchPhrase: Scalars['String']['input']
  seeAllOrders: Scalars['Boolean']['input']
  showOnlyOpenOrders: Scalars['Boolean']['input']
  sortBy: GetProductHistoryQuerySortByValue
  sortByAscendingOrder: Scalars['Boolean']['input']
  startDateTimeUtc?: InputMaybe<Scalars['DateTime']['input']>
}

export type GetProductHistoryResult = {
  productErpIdentifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  products?: Maybe<Array<Maybe<ProductHistoryDto>>>
  totalCount: Scalars['Int']['output']
}

export type GetProductListsResult = {
  productLists?: Maybe<Array<Maybe<AccountGraphql_ProductList>>>
}

export type GetProductsDto = {
  products?: Maybe<Array<Maybe<ProductDto>>>
  totalCount: Scalars['Int']['output']
}

export type GetRecommendationsResult = {
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  favouriteVendors?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  hits: Scalars['Int']['output']
  preferredCategoryId?: Maybe<Scalars['String']['output']>
  recommendedProducts?: Maybe<Array<Maybe<ProductReference>>>
  secondLevelPreferredCategoryId?: Maybe<Scalars['String']['output']>
}

export type GetSarReportContentResult = {
  contentType?: Maybe<Scalars['String']['output']>
  fileContent?: Maybe<Array<Scalars['Byte']['output']>>
  fileName?: Maybe<Scalars['String']['output']>
}

export type GetSearchPageResult = {
  autoCorrect?: Maybe<AutoCorrect>
  contentList?: Maybe<Array<Maybe<ContentReference>>>
  didYouMean?: Maybe<Array<Maybe<DidYouMean>>>
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  facets?: Maybe<Array<Maybe<Facet>>>
  hits: Scalars['Int']['output']
  navigation?: Maybe<CategoryNavigation>
  navigationTree?: Maybe<Array<Maybe<CategoryNavigationTreeItem>>>
  productReferences?: Maybe<Array<Maybe<ProductReference>>>
  relatedSearches?: Maybe<Array<Maybe<RelatedSearch>>>
  secondaryList?: Maybe<Array<Maybe<ProductReference>>>
}

export type GetUspResult = {
  usps: Array<Usp>
}

export type GoogleAnalytics = {
  apiSecret?: Maybe<Scalars['String']['output']>
  measurementId?: Maybe<Scalars['String']['output']>
}

export type GoogleAnalyticsPurchase = {
  coupon?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  deliveryStatus?: Maybe<Scalars['String']['output']>
  items?: Maybe<Array<Maybe<GoogleAnalyticsPurchaseItem>>>
  shippingCost: Scalars['Decimal']['output']
  shippingMethod?: Maybe<Scalars['String']['output']>
  tax: Scalars['Decimal']['output']
  transactionId?: Maybe<Scalars['String']['output']>
  value: Scalars['Decimal']['output']
}

export type GoogleAnalyticsPurchaseItem = {
  availability?: Maybe<Scalars['String']['output']>
  brand?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  category2?: Maybe<Scalars['String']['output']>
  category3?: Maybe<Scalars['String']['output']>
  category4?: Maybe<Scalars['String']['output']>
  coupon?: Maybe<Scalars['String']['output']>
  hasImage: Scalars['Boolean']['output']
  hasVariants: Scalars['Boolean']['output']
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  price: Scalars['Decimal']['output']
  productLifeCycle?: Maybe<Scalars['String']['output']>
  quantity: Scalars['Int']['output']
  weightedAverageScore?: Maybe<Scalars['Float']['output']>
}

export type GridBlock = {
  areas: Array<Area>
  columnSpan: Scalars['Int']['output']
  properties: Scalars['Any']['output']
  type: Scalars['String']['output']
}

export type GroupMemberRequestInput = {
  contactId: Scalars['Int']['input']
  groupId: Scalars['Int']['input']
}

export type Health = {
  response: Scalars['Boolean']['output']
}

export type Image = {
  height: Scalars['Int']['output']
  relativeUrl: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type InternalEtaStockAvailability = {
  eta: Scalars['DateTime']['output']
  quantity: Scalars['Int']['output']
}

export type InternalStockAvailability = {
  quantity: Scalars['Int']['output']
  showAlwaysInStock: Scalars['Boolean']['output']
}

export type InvitedContactLoginStatus = {
  hasLogin: Scalars['Boolean']['output']
  showLogin: Scalars['Boolean']['output']
  showLoginOtherAccount: Scalars['Boolean']['output']
}

export type Invoice = {
  dueDateExpired: Scalars['Boolean']['output']
  externalInvoiceReferenceNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  invoiceDateUtc?: Maybe<Scalars['DateTime']['output']>
  invoiceDueDateUtc?: Maybe<Scalars['DateTime']['output']>
  invoiceErpIdentifier?: Maybe<Scalars['String']['output']>
  isReadyForDownload: Scalars['Boolean']['output']
  paymentState: PaymentState
}

export type InvoiceCharge = {
  amount: Scalars['Decimal']['output']
  chargeType: ChargeType
  id: Scalars['Int']['output']
  priceDisplay?: Maybe<Scalars['String']['output']>
  vatAmount: Scalars['Decimal']['output']
}

export type InvoiceDto = {
  dueDateExpired: Scalars['Boolean']['output']
  externalInvoiceReferenceNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  invoiceDueDateUtc?: Maybe<Scalars['DateTime']['output']>
  invoiceErpIdentifier?: Maybe<Scalars['String']['output']>
  isReadyForDownload: Scalars['Boolean']['output']
  paymentState?: Maybe<Scalars['String']['output']>
}

export type InvoiceDetailPriceModel = {
  grandTotalExcludingVat: Scalars['String']['output']
  grandTotalIncludingVat: Scalars['String']['output']
  roundOff: Scalars['String']['output']
  vat: Scalars['String']['output']
}

export type InvoiceInformation = {
  electronicInvoiceReceiverReference?: Maybe<Scalars['String']['output']>
  invoiceEmailAddress?: Maybe<Scalars['String']['output']>
  invoiceType?: Maybe<Scalars['String']['output']>
}

export type InvoiceInformationDto = {
  electronicInvoiceReceiverReference?: Maybe<Scalars['String']['output']>
  invoiceEmailAddress?: Maybe<Scalars['String']['output']>
  invoiceType?: Maybe<Scalars['String']['output']>
}

export type InvoiceItem = {
  charges?: Maybe<Array<Maybe<InvoiceCharge>>>
  id: Scalars['Int']['output']
  itemPrice: Scalars['Decimal']['output']
  nameSlug?: Maybe<Scalars['String']['output']>
  priceDisplay?: Maybe<PriceModel>
  productDisplayName?: Maybe<Scalars['String']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  quantity: Scalars['Int']['output']
  rowPrice: Scalars['Decimal']['output']
  rowVat: Scalars['Decimal']['output']
  rowVatDisplay?: Maybe<Scalars['String']['output']>
}

export type InvoiceOrder = {
  customerPurchaseOrderNumber?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type InvoiceRow = {
  createdDateUtc: Scalars['DateTime']['output']
  currencyCode?: Maybe<Scalars['String']['output']>
  customerErpIdentifier?: Maybe<Scalars['String']['output']>
  dueDateExpired: Scalars['Boolean']['output']
  dueDateUtc?: Maybe<Scalars['DateTime']['output']>
  externalInvoiceReferenceNumber?: Maybe<Scalars['String']['output']>
  grandTotalExcludingVat: Scalars['Decimal']['output']
  grandTotalIncludingVat: Scalars['Decimal']['output']
  id: Scalars['Int']['output']
  invoiceErpIdentifier?: Maybe<Scalars['String']['output']>
  invoiceOrders?: Maybe<Array<Maybe<InvoiceOrder>>>
  isCreditInvoice: Scalars['Boolean']['output']
  isReadyForDownload: Scalars['Boolean']['output']
  ocrNumber?: Maybe<Scalars['String']['output']>
  orderPaymentState: PaymentState
  paymentState: PaymentState
  priceDisplay?: Maybe<Scalars['String']['output']>
  priceDisplayForExport?: Maybe<Scalars['String']['output']>
  pricesArePerMonth: Scalars['Boolean']['output']
}

export enum InvoiceType {
  Email = 'EMAIL',
  EmailAndPaper = 'EMAIL_AND_PAPER',
  None = 'NONE',
  NoPrint = 'NO_PRINT',
  Paper = 'PAPER',
  Xml = 'XML',
  XmlAndEmail = 'XML_AND_EMAIL',
  XmlAndPdf = 'XML_AND_PDF',
}

export type IsAttesterResult = {
  isAttester: Scalars['Boolean']['output']
}

export type KeyValuePairOfInt32AndString = {
  key: Scalars['Int']['output']
  value: Scalars['String']['output']
}

export type KeyValuePairOfStringAndStringInput = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type KitArticle = {
  id: Scalars['String']['output']
  product?: Maybe<Product>
  quantity: Scalars['Int']['output']
  sortOrder: Scalars['Int']['output']
}

export type LandingPage = {
  category?: Maybe<Category>
  categoryNavigation?: Maybe<CategoryNavigationGroup>
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  facets?: Maybe<Array<Maybe<Facet>>>
  hits: Scalars['Int']['output']
  navigationTree?: Maybe<Array<Maybe<CategoryNavigationTreeItem>>>
  pageId?: Maybe<Scalars['String']['output']>
  productReferences?: Maybe<Array<Maybe<ProductReference>>>
  recommendationList?: Maybe<Array<Maybe<RecommendationProductList>>>
}

export enum Language {
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Finnish = 'FINNISH',
  French = 'FRENCH',
  None = 'NONE',
  Norwegian = 'NORWEGIAN',
  Swedish = 'SWEDISH',
}

export type LatestBoughtProduct = {
  assortment?: Maybe<Scalars['String']['output']>
  availability?: Maybe<AccountGraphql_Availability>
  categoryName?: Maybe<Scalars['String']['output']>
  chargeGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  currentPrice?: Maybe<ProductHistoryPriceModel>
  displayName: Scalars['String']['output']
  displaySpecifications: Scalars['String']['output']
  ecoResCategoryErpIdentifier: Scalars['String']['output']
  ecoResCategoryName?: Maybe<Scalars['String']['output']>
  energyClass?: Maybe<Scalars['String']['output']>
  energyDocumentId?: Maybe<Scalars['String']['output']>
  energyLabelImageId?: Maybe<Scalars['String']['output']>
  freeFreight: Scalars['Boolean']['output']
  fullDisplayName: Scalars['String']['output']
  id: Scalars['String']['output']
  internalProduct: Scalars['Boolean']['output']
  isDemoProduct: Scalars['Boolean']['output']
  isHiddenFromSearchEngines: Scalars['Boolean']['output']
  isNewProduct: Scalars['Boolean']['output']
  isRentable: Scalars['Boolean']['output']
  lastModifiedDateTimeUtc: Scalars['DateTime']['output']
  lineDiscountGroupErpIdentifier: Scalars['String']['output']
  lotQuantity?: Maybe<Scalars['Int']['output']>
  manufacturerErpIdentifier: Scalars['String']['output']
  manufacturerName: Scalars['String']['output']
  manufacturerProductIdentifier?: Maybe<Scalars['String']['output']>
  maxQuantityPerOrder: Scalars['Int']['output']
  minQuantityPerOrder: Scalars['Int']['output']
  nameSlug: Scalars['String']['output']
  nonReturnable: Scalars['Boolean']['output']
  oneLiner?: Maybe<Scalars['String']['output']>
  price?: Maybe<AccountGraphql_Price>
  primaryImageId?: Maybe<Scalars['String']['output']>
  primaryServiceProductErpIdentifier?: Maybe<Scalars['String']['output']>
  productCategoryPimIdentifier: Scalars['String']['output']
  productErpIdentifier: Scalars['String']['output']
  productType: ProductType
  promotedSpecifications: Array<SpecificationForDisplayDto>
  reviewCount: Scalars['Int']['output']
  reviewScore: Scalars['Float']['output']
  showAlwaysInStock: Scalars['Boolean']['output']
  wayOfTransport: WayOfTransport
}

export type LogoDto = {
  fileName?: Maybe<Scalars['String']['output']>
  filePath?: Maybe<Scalars['String']['output']>
  fileSize: Scalars['Int']['output']
  pageId: Scalars['Int']['output']
}

export type MainNavigation = {
  menuItems: Array<MenuNavigationItem>
}

export type MakeContactInactiveRequestInput = {
  contactId: Scalars['Int']['input']
}

export type ManufacturerProductSearch = {
  facets: Array<Facet>
  navigationTree: Array<CategoryNavigationTreeItem>
  productHits: Scalars['Int']['output']
  productReferences: Array<ProductReference>
}

export type Media = {
  extension: Scalars['String']['output']
  fileType: Scalars['String']['output']
  filename: Scalars['String']['output']
  id: Scalars['String']['output']
  language: Scalars['String']['output']
  sortOrder: Scalars['Int']['output']
  source?: Maybe<Scalars['String']['output']>
  type: MediaType
}

export enum MediaType {
  Coc = 'COC',
  Document = 'DOCUMENT',
  DoC = 'DO_C',
  EnergyDocument = 'ENERGY_DOCUMENT',
  EnergyLabel = 'ENERGY_LABEL',
  Image = 'IMAGE',
  Normal = 'NORMAL',
  ProductAccessoryDocument = 'PRODUCT_ACCESSORY_DOCUMENT',
  ProductBrochure = 'PRODUCT_BROCHURE',
  ProductDataSheetBrochure = 'PRODUCT_DATA_SHEET_BROCHURE',
  ProductFamilyBrochure = 'PRODUCT_FAMILY_BROCHURE',
  QuickStartGuide = 'QUICK_START_GUIDE',
  RoHs = 'RO_HS',
  SafetyDataSheet = 'SAFETY_DATA_SHEET',
  Un38 = 'UN38',
  UserManual = 'USER_MANUAL',
}

export type MenuNavigationItem = {
  displayName: Scalars['String']['output']
  html: Scalars['String']['output']
  iconName?: Maybe<Scalars['String']['output']>
  inVariant: Scalars['Boolean']['output']
  isSelected: Scalars['Boolean']['output']
  subNavigationItems: Array<MenuSubNavigationItem>
  type: MenuNavigationItemType
  url?: Maybe<Scalars['String']['output']>
}

export enum MenuNavigationItemType {
  Brands = 'BRANDS',
  Categories = 'CATEGORIES',
  Compare = 'COMPARE',
  Normal = 'NORMAL',
}

export type MenuSubNavigationItem = {
  displayName: Scalars['String']['output']
  isInFooter: Scalars['Boolean']['output']
  url: Scalars['String']['output']
}

export type MenuVisibilityResult = {
  showAddresses: Scalars['Boolean']['output']
  showAttest: Scalars['Boolean']['output']
  showContacts: Scalars['Boolean']['output']
  showInvoices: Scalars['Boolean']['output']
  showPreOrder: Scalars['Boolean']['output']
  showServices: Scalars['Boolean']['output']
}

export type MonthlyCostDto = {
  amountExcludingVat?: Maybe<Scalars['Decimal']['output']>
  amountIncludingVat?: Maybe<Scalars['Decimal']['output']>
  effectiveInterestRate: Scalars['Decimal']['output']
  interestRate: Scalars['Float']['output']
  invoiceFee: Scalars['Decimal']['output']
  numberOfMonths?: Maybe<Scalars['Int']['output']>
  startFee: Scalars['Decimal']['output']
  totalCreditPurchaseCostIncludingVat: Scalars['Decimal']['output']
}

export type MutateProductReviewResult = {
  error?: Maybe<ErrorResult>
  review?: Maybe<ProductReview>
}

export type Mutation = {
  addAttestGroupMember?: Maybe<Scalars['Boolean']['output']>
  addAttester?: Maybe<Scalars['Boolean']['output']>
  attestPreOrder?: Maybe<AttestPreOrderResult>
  cancelContactInvitation?: Maybe<Scalars['Boolean']['output']>
  cancelPreOrder?: Maybe<Scalars['Boolean']['output']>
  changePassword?: Maybe<ChangePasswordBasicResult>
  completeBusinessActivation?: Maybe<RegisterCustomerResult>
  completeConsumerActivation?: Maybe<RegisterCustomerResult>
  confirmContactInvitation: Scalars['Boolean']['output']
  createActivation?: Maybe<CreateActivationResult>
  createAddress?: Maybe<CreateAddressResult>
  createAttestGroup?: Maybe<CreateGroupResult>
  createAttestGroupLevel?: Maybe<CreateAttestGroupLevelCommandResult>
  createCustomerPageBanner?: Maybe<CreateBannerDto>
  createCustomerPageCategory?: Maybe<CategoryDto>
  createCustomerPageContent?: Maybe<PageContentDto>
  createCustomerPageLogo?: Maybe<CreateLogoDto>
  createCustomerPageProduct?: Maybe<ProductDto>
  createFavoriteListFromCart?: Maybe<ProductList>
  createNotifyMeRegistration?: Maybe<Registration>
  createProductReview?: Maybe<MutateProductReviewResult>
  createReviewRequestExclusion: Result
  createRma?: Maybe<CreateRmaResult>
  declineContactInvitation?: Maybe<DeclineContactInvitationResult>
  deleteAddress?: Maybe<Scalars['Boolean']['output']>
  deleteAddresses?: Maybe<Scalars['Boolean']['output']>
  deleteAttestGroup?: Maybe<Scalars['Boolean']['output']>
  deleteAttestGroupLevel?: Maybe<Scalars['Boolean']['output']>
  deleteCustomerPageBanner?: Maybe<Scalars['Boolean']['output']>
  deleteCustomerPageCategory?: Maybe<Scalars['Boolean']['output']>
  deleteCustomerPageLogo?: Maybe<Scalars['Boolean']['output']>
  deleteCustomerPageProduct?: Maybe<Scalars['Boolean']['output']>
  deleteFavoriteList?: Maybe<DeleteProductListResult>
  deleteProductReview?: Maybe<Result>
  emptyCart?: Maybe<Cart>
  joinBusiness?: Maybe<RegisterCustomerResult>
  logClientMessage: Scalars['Boolean']['output']
  makeContactInactive?: Maybe<Scalars['Boolean']['output']>
  mergeCartsById: Scalars['Boolean']['output']
  mergeCartsByUser: Scalars['Boolean']['output']
  notifyAddFavorite: Scalars['String']['output']
  notifyAddToCart: Scalars['String']['output']
  notifyClick: Scalars['String']['output']
  notifyRemoveFavorite: Scalars['String']['output']
  notifyRemoveRecentSearches: Scalars['String']['output']
  notifyRemoveRecentlyViewed: Scalars['String']['output']
  registerBusiness?: Maybe<RegisterCustomerResult>
  registerConsumer?: Maybe<RegisterCustomerResult>
  removeAttestGroupMember?: Maybe<Scalars['Boolean']['output']>
  removeAttester?: Maybe<Scalars['Boolean']['output']>
  resendActivationEmail?: Maybe<ResendActivationEmailResult>
  sendAccountRequestEmailForExistingCompany?: Maybe<SendAccountRequestEmailForExistingCompanyResult>
  sendContactInvitation?: Maybe<SendContactInvitationResult>
  sendGoogleAnalyticsEvent: Scalars['Boolean']['output']
  sendPaymentConfirmation?: Maybe<PaymentConfirmationResult>
  sendProductListInvitation?: Maybe<SendProductListInvitationResult>
  sendRequestForPartialDelivery?: Maybe<SendRequestForPartialDeliveryResult>
  setAccountAndPrivacyTerms: Scalars['Boolean']['output']
  setAttestDefaultGroup?: Maybe<Scalars['Boolean']['output']>
  setContactSelectorFavorite: Scalars['Boolean']['output']
  setLastLogin: Scalars['Boolean']['output']
  setPrivacyTerms: Scalars['Boolean']['output']
  submitCustomerServiceInquiry: Scalars['String']['output']
  surveyOptIn?: Maybe<Scalars['Boolean']['output']>
  updateAccountInformation?: Maybe<Scalars['Boolean']['output']>
  updateAddress?: Maybe<UpdateAddressResult>
  updateAttestGroup?: Maybe<Scalars['Boolean']['output']>
  updateAttestGroupLevel?: Maybe<Scalars['Boolean']['output']>
  updateCartItemComment?: Maybe<UpdateCartItemCommentResult>
  updateCartWithItem?: Maybe<UpdateCartResult>
  updateCartWithMultipleItems?: Maybe<UpdateCartResult>
  updateCartWithProduct?: Maybe<Array<CartItemResult>>
  updateCartWithProducts?: Maybe<Array<CartItemResult>>
  updateCompareListWithProduct?: Maybe<UpdateProductListResult>
  updateContactFromOkta?: Maybe<Scalars['Boolean']['output']>
  updateContactPermissions?: Maybe<Scalars['Boolean']['output']>
  updateCustomerPageCategory?: Maybe<Scalars['Boolean']['output']>
  updateCustomerPageContent?: Maybe<Scalars['Boolean']['output']>
  updateFavoriteListName?: Maybe<UpdateProductListNameResult>
  updateFavoriteListWithProduct?: Maybe<UpdateProductListResult>
  updateProductReview?: Maybe<MutateProductReviewResult>
  updateRteRequestStatus?: Maybe<UpdateRequestStatusResult>
  updateSarRequestStatus?: Maybe<UpdateRequestStatusResult>
  updateShowPricesInclVatUserSettings?: Maybe<Scalars['Boolean']['output']>
  updateUserInformation?: Maybe<Scalars['Boolean']['output']>
  upsertEndUserInformation?: Maybe<UpsertRequiredEndUserInformationResult>
}

export type MutationAddAttestGroupMemberArgs = {
  command: GroupMemberRequestInput
}

export type MutationAddAttesterArgs = {
  command: AttesterRequestInput
}

export type MutationAttestPreOrderArgs = {
  command: AttestPreOrderRequestInput
}

export type MutationCancelContactInvitationArgs = {
  command: CancelContactInvitationRequestInput
}

export type MutationCancelPreOrderArgs = {
  command: CancelPreOrderRequestInput
}

export type MutationChangePasswordArgs = {
  command: ChangePasswordRequestInput
}

export type MutationCompleteBusinessActivationArgs = {
  activationId?: InputMaybe<Scalars['UUID']['input']>
  password?: InputMaybe<Scalars['String']['input']>
}

export type MutationCompleteConsumerActivationArgs = {
  activationId?: InputMaybe<Scalars['UUID']['input']>
  password?: InputMaybe<Scalars['String']['input']>
}

export type MutationConfirmContactInvitationArgs = {
  accountTermsAccepted: Scalars['Boolean']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  invitationIdentifier: Scalars['UUID']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
  offersByEmail: Scalars['Boolean']['input']
  password?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateActivationArgs = {
  accountTermsAccepted: Scalars['Boolean']['input']
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  offersByEmail: Scalars['Boolean']['input']
  organizationNumber?: InputMaybe<Scalars['String']['input']>
  preRegistrationToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateAddressArgs = {
  command: CreateAddressRequestInput
}

export type MutationCreateAttestGroupArgs = {
  command: CreateGroupRequestInput
}

export type MutationCreateAttestGroupLevelArgs = {
  command: CreateGroupLevelRequestInput
}

export type MutationCreateCustomerPageBannerArgs = {
  command: CreateBannerRequestInput
}

export type MutationCreateCustomerPageCategoryArgs = {
  command: CreateCategoryRequestInput
}

export type MutationCreateCustomerPageContentArgs = {
  command: CreatePageContentRequestInput
}

export type MutationCreateCustomerPageLogoArgs = {
  command: CreateLogoRequestInput
}

export type MutationCreateCustomerPageProductArgs = {
  command: CreateProductRequestInput
}

export type MutationCreateFavoriteListFromCartArgs = {
  favoriteListName: Scalars['String']['input']
}

export type MutationCreateNotifyMeRegistrationArgs = {
  email: Scalars['String']['input']
  productErpIdentifier: Scalars['String']['input']
}

export type MutationCreateProductReviewArgs = {
  author: Scalars['String']['input']
  contactToken?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  productErpIdentifier?: InputMaybe<Scalars['String']['input']>
  score: Scalars['Int']['input']
}

export type MutationCreateReviewRequestExclusionArgs = {
  contactToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateRmaArgs = {
  command: CreateRmaRequestInput
}

export type MutationDeclineContactInvitationArgs = {
  invitationIdentifier: Scalars['UUID']['input']
}

export type MutationDeleteAddressArgs = {
  command: DeleteAddressRequestInput
}

export type MutationDeleteAddressesArgs = {
  command: DeleteAddressesRequestInput
}

export type MutationDeleteAttestGroupArgs = {
  command: DeleteGroupRequestInput
}

export type MutationDeleteAttestGroupLevelArgs = {
  command: DeleteGroupLevelRequestInput
}

export type MutationDeleteCustomerPageBannerArgs = {
  command: DeleteBannerRequestInput
}

export type MutationDeleteCustomerPageCategoryArgs = {
  command: DeleteCategoryRequestInput
}

export type MutationDeleteCustomerPageLogoArgs = {
  command: DeleteLogoRequestInput
}

export type MutationDeleteCustomerPageProductArgs = {
  command: DeleteProductRequestInput
}

export type MutationDeleteFavoriteListArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteProductReviewArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>
  productErpIdentifier?: InputMaybe<Scalars['String']['input']>
}

export type MutationJoinBusinessArgs = {
  accountTermsAccepted: Scalars['Boolean']['input']
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  offersByEmail: Scalars['Boolean']['input']
  password?: InputMaybe<Scalars['String']['input']>
  preRegistrationToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationLogClientMessageArgs = {
  message?: InputMaybe<Scalars['String']['input']>
}

export type MutationMakeContactInactiveArgs = {
  command: MakeContactInactiveRequestInput
}

export type MutationMergeCartsByIdArgs = {
  sourceCartId: Scalars['Int']['input']
  targetContactId: Scalars['Int']['input']
}

export type MutationMergeCartsByUserArgs = {
  sourceContactId?: InputMaybe<Scalars['Int']['input']>
  sourceUserIdentifier?: InputMaybe<Scalars['UUID']['input']>
  targetContactId: Scalars['Int']['input']
}

export type MutationNotifyAddFavoriteArgs = {
  productErpIdentifier: Scalars['String']['input']
}

export type MutationNotifyAddToCartArgs = {
  ticket: Scalars['String']['input']
}

export type MutationNotifyClickArgs = {
  ticket: Scalars['String']['input']
}

export type MutationNotifyRemoveFavoriteArgs = {
  productErpIdentifier: Scalars['String']['input']
}

export type MutationNotifyRemoveRecentSearchesArgs = {
  phrase: Scalars['String']['input']
  removeAll: Scalars['Boolean']['input']
}

export type MutationNotifyRemoveRecentlyViewedArgs = {
  productErpIdentifier: Scalars['String']['input']
  removeAll: Scalars['Boolean']['input']
}

export type MutationRegisterBusinessArgs = {
  accountTermsAccepted: Scalars['Boolean']['input']
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  offersByEmail: Scalars['Boolean']['input']
  organizationNumber?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  preRegistrationToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationRegisterConsumerArgs = {
  accountTermsAccepted: Scalars['Boolean']['input']
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  offersByEmail: Scalars['Boolean']['input']
  password?: InputMaybe<Scalars['String']['input']>
  preRegistrationToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationRemoveAttestGroupMemberArgs = {
  command: GroupMemberRequestInput
}

export type MutationRemoveAttesterArgs = {
  command: RemoveAttesterRequestInput
}

export type MutationResendActivationEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type MutationSendAccountRequestEmailForExistingCompanyArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  orgNumber?: InputMaybe<Scalars['String']['input']>
}

export type MutationSendContactInvitationArgs = {
  command: SendContactInvitationRequestInput
}

export type MutationSendGoogleAnalyticsEventArgs = {
  ga4Input?: InputMaybe<Ga4Input>
  payload?: InputMaybe<Scalars['String']['input']>
}

export type MutationSendPaymentConfirmationArgs = {
  command: SendPaymentConfirmationEmailRequestInput
}

export type MutationSendProductListInvitationArgs = {
  id: Scalars['Int']['input']
  message: Scalars['String']['input']
  receiverEmailAddress: Scalars['String']['input']
  senderEmailAddress: Scalars['String']['input']
  senderFirstName: Scalars['String']['input']
  senderLastName: Scalars['String']['input']
}

export type MutationSendRequestForPartialDeliveryArgs = {
  command: SendRequestForPartialDeliveryRequestInput
}

export type MutationSetAccountAndPrivacyTermsArgs = {
  contactId: Scalars['Int']['input']
  offersByEmail?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSetAttestDefaultGroupArgs = {
  command: SetDefaultGroupRequestInput
}

export type MutationSetContactSelectorFavoriteArgs = {
  contactId: Scalars['Int']['input']
  isFavorite: Scalars['Boolean']['input']
}

export type MutationSetLastLoginArgs = {
  contactId: Scalars['Int']['input']
}

export type MutationSetPrivacyTermsArgs = {
  contactId: Scalars['Int']['input']
}

export type MutationSubmitCustomerServiceInquiryArgs = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>
  fields: Array<CustomerServiceInquiryFieldInput>
  id: Scalars['Int']['input']
  title: Scalars['String']['input']
}

export type MutationSurveyOptInArgs = {
  command: SurveyOptInRequestInput
}

export type MutationUpdateAccountInformationArgs = {
  command: UpdateAccountInformationRequestInput
}

export type MutationUpdateAddressArgs = {
  command: UpdateAddressRequestInput
}

export type MutationUpdateAttestGroupArgs = {
  command: UpdateGroupRequestInput
}

export type MutationUpdateAttestGroupLevelArgs = {
  command: UpdateGroupLevelRequestInput
}

export type MutationUpdateCartItemCommentArgs = {
  cartItemId: Scalars['Int']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateCartWithItemArgs = {
  command: UpdateCartWithItemRequestInput
}

export type MutationUpdateCartWithMultipleItemsArgs = {
  command: UpdateCartWithMultipleItemsRequestInput
}

export type MutationUpdateCartWithProductArgs = {
  comment?: InputMaybe<Scalars['String']['input']>
  mainProductErpIdentifier?: InputMaybe<Scalars['String']['input']>
  parentCartItemId?: InputMaybe<Scalars['Int']['input']>
  productErpIdentifier: Scalars['String']['input']
  quantity?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateCartWithProductsArgs = {
  cartItemParams: Array<InputMaybe<CartItemParamInput>>
}

export type MutationUpdateCompareListWithProductArgs = {
  productErpIdentifier: Scalars['String']['input']
  productListName?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateContactFromOktaArgs = {
  contactId: Scalars['Int']['input']
}

export type MutationUpdateContactPermissionsArgs = {
  command: UpdateContactPermissionsRequestInput
}

export type MutationUpdateCustomerPageCategoryArgs = {
  command: UpdateCategoryRequestInput
}

export type MutationUpdateCustomerPageContentArgs = {
  command: UpdatePageContentRequestInput
}

export type MutationUpdateFavoriteListNameArgs = {
  favoriteListName: Scalars['String']['input']
  updatedFavoriteListName: Scalars['String']['input']
}

export type MutationUpdateFavoriteListWithProductArgs = {
  cartItemId?: InputMaybe<Scalars['Int']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  favoriteListId?: InputMaybe<Scalars['Int']['input']>
  favoriteListName: Scalars['String']['input']
  productErpIdentifier: Scalars['String']['input']
  quantity?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateProductReviewArgs = {
  author: Scalars['String']['input']
  contactToken?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  productErpIdentifier?: InputMaybe<Scalars['String']['input']>
  score: Scalars['Int']['input']
}

export type MutationUpdateRteRequestStatusArgs = {
  accept: Scalars['Boolean']['input']
  token?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateSarRequestStatusArgs = {
  accept: Scalars['Boolean']['input']
  token?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateShowPricesInclVatUserSettingsArgs = {
  command: UpdateShowPricesInclVatUserSettingRequestInput
}

export type MutationUpdateUserInformationArgs = {
  command: UpdateUserInformationRequestInput
}

export type MutationUpsertEndUserInformationArgs = {
  cartItemId: Scalars['Int']['input']
  label: Scalars['String']['input']
  lineNumber: Scalars['Decimal']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export type NavigationByCategory = {
  /** Child categories for the given category tree node. */
  children: Array<ProductCategoryChildNavigationItem>
  /** Child categories for the given category tree node, ordered by number of hits. */
  childrenSortedByHits: Array<ProductCategoryChildNavigationItem>
  id?: Maybe<Scalars['String']['output']>
  /** Breadcrumb path to the requested category in the full category tree. */
  path: Array<CategoryNavigationItem>
  /** Sibling categories for the given category tree node. */
  siblings: Array<CategoryNavigationItem>
}

export enum NotificationType {
  AvailabilityAlert = 'AVAILABILITY_ALERT',
  CampaignAlert = 'CAMPAIGN_ALERT',
  None = 'NONE',
}

export type OciDataResult = {
  authorizationCode?: Maybe<Scalars['String']['output']>
  contactId: Scalars['Int']['output']
  customerLandingPage?: Maybe<Scalars['URL']['output']>
  punchOutTicket: Scalars['UUID']['output']
  sessionUserIdentifier: Scalars['UUID']['output']
  state: OciDataState
}

export enum OciDataState {
  InvalidHookUrl = 'INVALID_HOOK_URL',
  InvalidSiteType = 'INVALID_SITE_TYPE',
  InvalidUserNameOrPassword = 'INVALID_USER_NAME_OR_PASSWORD',
  MultipleContacts = 'MULTIPLE_CONTACTS',
  NoContacts = 'NO_CONTACTS',
  Ok = 'OK',
}

export type Order = {
  id: Scalars['Int']['output']
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type OrderCharge = {
  amountType: AmountType
  chargeOnlyOnFirstDelivery: Scalars['Boolean']['output']
  chargeType: ChargeType
  currencyCode: Currency
  deliveryCountryCode?: Maybe<Scalars['String']['output']>
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  invoiceType?: Maybe<Scalars['String']['output']>
  itemReference?: Maybe<Scalars['String']['output']>
  percentage?: Maybe<Scalars['Decimal']['output']>
  price: Scalars['Decimal']['output']
  priceVat: Scalars['Decimal']['output']
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
  taxGroup: TaxGroup
}

export type OrderChargeDto = {
  amountType?: Maybe<Scalars['String']['output']>
  chargeOnlyOnFirstDelivery: Scalars['Boolean']['output']
  chargeType?: Maybe<Scalars['String']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  deliveryCountryCode?: Maybe<Scalars['String']['output']>
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  invoiceType?: Maybe<Scalars['String']['output']>
  itemReference?: Maybe<Scalars['String']['output']>
  percentage?: Maybe<Scalars['Decimal']['output']>
  price: Scalars['Decimal']['output']
  priceDisplay?: Maybe<Scalars['String']['output']>
  priceDisplayWithVat?: Maybe<Scalars['String']['output']>
  priceVat: Scalars['Decimal']['output']
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
  taxGroup?: Maybe<Scalars['String']['output']>
}

export enum OrderChipStatus {
  Canceled = 'CANCELED',
  None = 'NONE',
  PartlyShipped = 'PARTLY_SHIPPED',
  Pending = 'PENDING',
  Shipped = 'SHIPPED',
}

export type OrderConfirmationDetails = {
  googleAnalyticsPurchase?: Maybe<GoogleAnalyticsPurchase>
  klarnaHtmlSnippet?: Maybe<Scalars['String']['output']>
  orderConfirmationTimedOut: Scalars['Boolean']['output']
  orderDetails?: Maybe<OrderDetails>
  orderUnavailable: Scalars['Boolean']['output']
}

export type OrderDetailPriceModel = {
  priceDisplay: Scalars['String']['output']
  quantityBackOrdered: Scalars['Int']['output']
  quantityCanceled: Scalars['Int']['output']
  quantityDelivered: Scalars['Int']['output']
  quantityReadyForDelivery: Scalars['Int']['output']
  singlePriceWithVat: Scalars['Decimal']['output']
  totalPriceDisplay: Scalars['String']['output']
  totalPriceDisplayBackOrdered: Scalars['String']['output']
  totalPriceDisplayCanceled: Scalars['String']['output']
  totalPriceDisplayDelivered: Scalars['String']['output']
  totalPriceDisplayReadyForDelivery: Scalars['String']['output']
}

export type OrderDetails = {
  billingAddress?: Maybe<AddressDetails>
  charges?: Maybe<Array<Maybe<OrderChargeDto>>>
  createdDateTimeUtc: Scalars['DateTime']['output']
  currencyCode?: Maybe<Scalars['String']['output']>
  customerErpId?: Maybe<Scalars['String']['output']>
  customerFirstName?: Maybe<Scalars['String']['output']>
  customerLastName?: Maybe<Scalars['String']['output']>
  customerUnit?: Maybe<Scalars['String']['output']>
  deliveries?: Maybe<Array<Maybe<DeliveryDto>>>
  deliveryMethod?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  grandTotalExcludingVat?: Maybe<Scalars['Decimal']['output']>
  invoiceInformation?: Maybe<InvoiceInformationDto>
  invoices?: Maybe<Array<Maybe<InvoiceDto>>>
  isGuestOrder: Scalars['Boolean']['output']
  isNewCustomer: Scalars['Boolean']['output']
  isRental: Scalars['Boolean']['output']
  isRentalPending?: Maybe<Scalars['Boolean']['output']>
  items?: Maybe<Array<Maybe<OrderItemDto>>>
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderState?: Maybe<Scalars['String']['output']>
  otherInformation?: Maybe<OtherInformatioDto>
  paymentMethod?: Maybe<Scalars['String']['output']>
  paymentType?: Maybe<Scalars['String']['output']>
  priceDisplay?: Maybe<Scalars['String']['output']>
  priceDisplayWithVat?: Maybe<Scalars['String']['output']>
  pricesArePerMonth?: Maybe<Scalars['Boolean']['output']>
  shippingAddress?: Maybe<AddressDetails>
}

export type OrderDetailsCharge = {
  amountType: AmountType
  chargeOnlyOnFirstDelivery: Scalars['Boolean']['output']
  chargeType: ChargeType
  currencyCode: Currency
  deliveryCountryCode?: Maybe<Scalars['String']['output']>
  deliveryModeErpIdentifier?: Maybe<Scalars['String']['output']>
  itemReference?: Maybe<Scalars['String']['output']>
  percentage?: Maybe<Scalars['Decimal']['output']>
  price: Scalars['Decimal']['output']
  priceDisplay?: Maybe<Scalars['String']['output']>
  priceVat: Scalars['Decimal']['output']
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
  taxGroup: TaxGroup
}

export type OrderDetailsForRmaOrderDto = {
  cellphone?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderId: Scalars['Int']['output']
}

export type OrderDetailsForRmaOrderItemDto = {
  productDisplayName?: Maybe<Scalars['String']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  quantityOrdered: Scalars['Int']['output']
}

export type OrderDetailsForRmaResult = {
  contact: ContactModel
  order?: Maybe<OrderDetailsForRmaOrderDto>
  orderItems?: Maybe<Array<OrderDetailsForRmaOrderItemDto>>
}

export type OrderDetailsShippingAddress = {
  addressLine?: Maybe<Scalars['String']['output']>
  addressee?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  department?: Maybe<Scalars['String']['output']>
  goodsReceiverName?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
}

export type OrderDto = {
  contactId?: Maybe<Scalars['Int']['output']>
  contactName?: Maybe<Scalars['String']['output']>
  currencyCode?: Maybe<Scalars['String']['output']>
  customerPurchaseOrderNumber?: Maybe<Scalars['String']['output']>
  customerReferenceCostCenter?: Maybe<Scalars['String']['output']>
  goodsMark?: Maybe<Scalars['String']['output']>
  grandTotalExcludingVat: Scalars['Decimal']['output']
  grandTotalIncludingVat: Scalars['Decimal']['output']
  invoiceDueDate?: Maybe<Scalars['DateTime']['output']>
  invoiceDueDateExpired?: Maybe<Scalars['Boolean']['output']>
  invoiceIdIdentifiers?: Maybe<Array<Scalars['Int']['output']>>
  orderDateUtc: Scalars['DateTime']['output']
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderId: Scalars['Int']['output']
  orderState: OrderState
  paymentState: PaymentState
  paymentTermsErpIdentifier?: Maybe<Scalars['String']['output']>
  paymentTypeName?: Maybe<Scalars['String']['output']>
  placedById?: Maybe<Scalars['Int']['output']>
  priceDisplay?: Maybe<Scalars['String']['output']>
  priceDisplayForExport?: Maybe<Scalars['String']['output']>
  pricesArePerMonth: Scalars['Boolean']['output']
}

export type OrderItem = {
  agreementAmount?: Maybe<Scalars['Decimal']['output']>
  agreementPercent?: Maybe<Scalars['Decimal']['output']>
  agreementType: PricingRuleAgreementType
  availabilityInformation?: Maybe<AccountGraphql_Availability>
  charges?: Maybe<Array<Maybe<OrderCharge>>>
  comments?: Maybe<Array<Maybe<OrderItemComment>>>
  costPrice: Scalars['Decimal']['output']
  displayName?: Maybe<Scalars['String']['output']>
  etaDateUtc?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  itemReference?: Maybe<Scalars['String']['output']>
  manufacturerProductIdentifier?: Maybe<Scalars['String']['output']>
  mediaIdentifier?: Maybe<Scalars['String']['output']>
  monthlyPrice?: Maybe<Scalars['Decimal']['output']>
  monthlyVat?: Maybe<Scalars['Decimal']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
  orderItemState: OrderItemState
  parentItemReference?: Maybe<Scalars['String']['output']>
  price: Scalars['Decimal']['output']
  priceDisplay?: Maybe<OrderDetailPriceModel>
  priceVat: Scalars['Decimal']['output']
  product?: Maybe<Product>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  productId: Scalars['Int']['output']
  productType: ProductType
  quantityAllocated?: Maybe<Scalars['Int']['output']>
  quantityOrdered: Scalars['Int']['output']
  quantityShipped: Scalars['Int']['output']
  serialNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  serviceDurationMonths?: Maybe<Scalars['Int']['output']>
  supplierCode?: Maybe<Scalars['String']['output']>
  taxCategoryErpIdentifier?: Maybe<Scalars['String']['output']>
  taxGroup: TaxGroup
  unitType: UnitType
}

export type OrderItemComment = {
  commentText?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type OrderItemCommentDto = {
  commentText?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type OrderItemDto = {
  comments?: Maybe<Array<Maybe<OrderItemCommentDto>>>
  displayName?: Maybe<Scalars['String']['output']>
  etaDateUtc?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  mediaIdentifier?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
  orderItemState?: Maybe<Scalars['String']['output']>
  price: Scalars['Decimal']['output']
  priceDisplay?: Maybe<Scalars['String']['output']>
  priceDisplayWithVat?: Maybe<Scalars['String']['output']>
  priceVat: Scalars['Decimal']['output']
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  productId: Scalars['Int']['output']
  quantityOrdered: Scalars['Int']['output']
  serialNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  totalPriceDisplay?: Maybe<Scalars['String']['output']>
  totalPriceDisplayWithVat?: Maybe<Scalars['String']['output']>
}

export enum OrderItemState {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Invoiced = 'INVOICED',
  None = 'NONE',
  Open = 'OPEN',
  PartlyShipped = 'PARTLY_SHIPPED',
  Shipped = 'SHIPPED',
}

export enum OrderPaymentChipStatus {
  None = 'NONE',
  NotPaid = 'NOT_PAID',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
}

export type OrderPaymentState = {
  amountPaid: Scalars['Decimal']['output']
  id: Scalars['Int']['output']
  orderId: Scalars['Int']['output']
  ourReference?: Maybe<Scalars['String']['output']>
  paidVia?: Maybe<Scalars['String']['output']>
  paymentMethodId: Scalars['Int']['output']
  paymentServiceProvider?: Maybe<Scalars['String']['output']>
  paymentServiceProviderErrorMessage?: Maybe<Scalars['String']['output']>
  paymentServiceProviderReference?: Maybe<Scalars['String']['output']>
  paymentServiceProviderStatus?: Maybe<Scalars['String']['output']>
  paymentStateSetBy?: Maybe<Scalars['String']['output']>
  paymentStateSetDateTimeUtc: Scalars['DateTime']['output']
  paymentTermsErpIdentifier?: Maybe<Scalars['String']['output']>
  paymentType?: Maybe<Scalars['String']['output']>
  site: Site
  state: PaymentState
}

export enum OrderState {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Invoiced = 'INVOICED',
  None = 'NONE',
  Open = 'OPEN',
  Shipped = 'SHIPPED',
}

export enum OrdersToShow {
  AllForCustomer = 'ALL_FOR_CUSTOMER',
  PlacedByContact = 'PLACED_BY_CONTACT',
  WhereContactIsAttester = 'WHERE_CONTACT_IS_ATTESTER',
}

export enum Origin {
  DidYouMean = 'DID_YOU_MEAN',
  Organic = 'ORGANIC',
  PhraseSuggest = 'PHRASE_SUGGEST',
  RecentSearch = 'RECENT_SEARCH',
  RelatedSearches = 'RELATED_SEARCHES',
  UndoAutoCorrect = 'UNDO_AUTO_CORRECT',
}

export type OtherInformatioDto = {
  costCenterReference?: Maybe<Scalars['String']['output']>
  goodsMark?: Maybe<Scalars['String']['output']>
  goodsReceiverDepartment?: Maybe<Scalars['String']['output']>
  goodsReceiverName?: Maybe<Scalars['String']['output']>
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>
  referenceName?: Maybe<Scalars['String']['output']>
}

export type OtherInformation = {
  costCenterReference?: Maybe<Scalars['String']['output']>
  goodsMark?: Maybe<Scalars['String']['output']>
  goodsReceiverDepartment?: Maybe<Scalars['String']['output']>
  goodsReceiverName?: Maybe<Scalars['String']['output']>
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>
  referenceName?: Maybe<Scalars['String']['output']>
}

export type Page =
  | ArticlePage
  | BlogPage
  | BrandContentPage
  | BrandListPage
  | BrandPage
  | CustomerProductGroupPage
  | CustomerStartPage
  | EditorialPage
  | SoftCategoryContentPage
  | SoftCategoryPage
  | StartPage

export type PageContentDto = {
  content?: Maybe<Scalars['String']['output']>
  header?: Maybe<Scalars['String']['output']>
  lead?: Maybe<Scalars['String']['output']>
  pageId: Scalars['Int']['output']
}

export type PageDto = {
  banner?: Maybe<BannerDto>
  categories?: Maybe<Array<CategoryDto>>
  id: Scalars['Int']['output']
  logo?: Maybe<LogoDto>
  name?: Maybe<Scalars['String']['output']>
  pageContent?: Maybe<PageContentDto>
  settings?: Maybe<SettingsDto>
}

export enum PageType {
  Article = 'ARTICLE',
  Blog = 'BLOG',
  Brand = 'BRAND',
  BrandContent = 'BRAND_CONTENT',
  BrandList = 'BRAND_LIST',
  CustomerProductGroup = 'CUSTOMER_PRODUCT_GROUP',
  CustomerStart = 'CUSTOMER_START',
  Editorial = 'EDITORIAL',
  Redirect = 'REDIRECT',
  SoftCategory = 'SOFT_CATEGORY',
  SoftCategoryContent = 'SOFT_CATEGORY_CONTENT',
  Start = 'START',
}

export type Pagination = {
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalHitsUntilEnd: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type ParentProduct = {
  descriptions: Array<QualifiedValueOfString>
  id: Scalars['String']['output']
  isEmpty: Scalars['Boolean']['output']
  keySellingPoints: Array<QualifiedValueOfString>
  names: Array<QualifiedValueOfString>
  oneliner: Array<QualifiedValueOfString>
}

export type PaymentCharge = {
  amountExcludingVat: Scalars['Decimal']['output']
  amountIncludingVat: Scalars['Decimal']['output']
  chargeId: Scalars['Int']['output']
  chargeType: ChargeType
  taxGroup: TaxGroup
  vat: Scalars['Decimal']['output']
}

export type PaymentConfirmationResult = {
  success: Scalars['Boolean']['output']
}

export type PaymentMethodPaymentServiceProviderParameter = {
  paymentMethodId: Scalars['Int']['output']
  paymentServiceProviderAgentName?: Maybe<Scalars['String']['output']>
  paymentServiceProviderParameterName?: Maybe<Scalars['String']['output']>
  paymentServiceProviderParameterValue?: Maybe<Scalars['String']['output']>
}

export enum PaymentState {
  None = 'NONE',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PaymentInitiated = 'PAYMENT_INITIATED',
  Unknown = 'UNKNOWN',
}

export type PeppolDataResult = {
  authorizationCode?: Maybe<Scalars['String']['output']>
  contactId: Scalars['Int']['output']
  customerLandingPage?: Maybe<Scalars['URL']['output']>
  punchOutTicket: Scalars['UUID']['output']
  sessionUserIdentifier: Scalars['UUID']['output']
  state: PeppolDataState
}

export enum PeppolDataState {
  InvalidHookUrl = 'INVALID_HOOK_URL',
  InvalidSiteType = 'INVALID_SITE_TYPE',
  InvalidUserNameOrPassword = 'INVALID_USER_NAME_OR_PASSWORD',
  MultipleContacts = 'MULTIPLE_CONTACTS',
  NoContacts = 'NO_CONTACTS',
  Ok = 'OK',
}

export enum Placement {
  Check = 'CHECK',
  Radio = 'RADIO',
  Top = 'TOP',
  Unspecified = 'UNSPECIFIED',
}

export enum PreOrderAttestState {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  None = 'NONE',
  Pending = 'PENDING',
}

export type PreOrderAttestStepV2 = {
  actionById?: Maybe<Scalars['Int']['output']>
  actionByName?: Maybe<Scalars['String']['output']>
  actionDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  actionOnBehalfOfId?: Maybe<Scalars['Int']['output']>
  actionOnBehalfOfName?: Maybe<Scalars['String']['output']>
  comment?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  isAttestable: Scalars['Boolean']['output']
  level: Scalars['Int']['output']
  limit: Scalars['Decimal']['output']
  limitDisplay?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  state: PreOrderAttestState
}

export type PreOrderChargeModel = {
  displayPriceExcludingVat: Scalars['String']['output']
  displayTextExcludingVat: Scalars['String']['output']
}

export type PreOrderInformationModel = {
  billingAddress: Address
  cart?: Maybe<GetCartForCheckoutResult>
  charges: Array<PreOrderChargeModel>
  deliveryAddress: Address
  deliveryMethod: DeliveryMethodDto
  paymentMethod: CheckoutPaymentMethod
  total: PreOrderTotalModel
}

export type PreOrderTotalModel = {
  totalExcludingVat: Scalars['String']['output']
  totalIncludingVat: Scalars['String']['output']
  totalVat: Scalars['String']['output']
}

export type PreOrderV2 = {
  allowSplitDelivery: Scalars['Boolean']['output']
  attestGroupName?: Maybe<Scalars['String']['output']>
  attestSteps?: Maybe<Array<Maybe<PreOrderAttestStepV2>>>
  billingAddressId: Scalars['Int']['output']
  callingClientIpAddress?: Maybe<Scalars['String']['output']>
  cartId: Scalars['Int']['output']
  cellphone?: Maybe<Scalars['String']['output']>
  comment?: Maybe<Scalars['String']['output']>
  createdDateTimeUtc: Scalars['DateTime']['output']
  currencyCode?: Maybe<Scalars['String']['output']>
  customerId: Scalars['Int']['output']
  customerPurchaseOrderNumber?: Maybe<Scalars['String']['output']>
  customerReferenceCostCenter?: Maybe<Scalars['String']['output']>
  customerReferenceName?: Maybe<Scalars['String']['output']>
  deliveryMethodId: Scalars['Int']['output']
  electronicInvoiceReceiverReferenceValue?: Maybe<Scalars['String']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  goodsMark?: Maybe<Scalars['String']['output']>
  goodsReceiverDepartment?: Maybe<Scalars['String']['output']>
  goodsReceiverName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  invoiceEmail?: Maybe<Scalars['String']['output']>
  invoiceType: Scalars['Int']['output']
  isAttestable: Scalars['Boolean']['output']
  isCancelable: Scalars['Boolean']['output']
  lastModifiedBy?: Maybe<Scalars['String']['output']>
  lastModifiedDateTimeUtc: Scalars['DateTime']['output']
  numberOfAttestedSteps: Scalars['Int']['output']
  numberOfSteps: Scalars['Int']['output']
  orderErpIdentifier?: Maybe<Scalars['String']['output']>
  orderId?: Maybe<Scalars['Int']['output']>
  orderSumWhenPreOrdering: Scalars['Decimal']['output']
  paymentMethodUniqueId?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  phoneNotification: Scalars['Boolean']['output']
  placedByFirstName?: Maybe<Scalars['String']['output']>
  placedById: Scalars['Int']['output']
  placedByLastName?: Maybe<Scalars['String']['output']>
  shippingAddressId: Scalars['Int']['output']
  smsNotification: Scalars['Boolean']['output']
  status: PreOrderAttestState
  voucherCode?: Maybe<Scalars['String']['output']>
}

export type Price = {
  bidDistributorErpIdentifier?: Maybe<Scalars['String']['output']>
  bidSourceLocally: Scalars['Boolean']['output']
  campaignPercentage?: Maybe<Scalars['Int']['output']>
  campaignType?: Maybe<CampaignType>
  /** Includes chemical tax. */
  costPrice: Scalars['Decimal']['output']
  formatted: PriceFormatted
  isBestSeller: Scalars['Boolean']['output']
  isBid: Scalars['Boolean']['output']
  isCampaign: Scalars['Boolean']['output']
  isRecommendedProduct: Scalars['Boolean']['output']
  originalPrice: Scalars['Decimal']['output']
  originalPriceExcludingVat: Scalars['Decimal']['output']
  originalPriceIncludingVat: Scalars['Decimal']['output']
  originalPriceVat: Scalars['Decimal']['output']
  price: Scalars['Decimal']['output']
  priceExcludingVat: Scalars['Decimal']['output']
  priceIncludingVat: Scalars['Decimal']['output']
  priceMargin: Scalars['Decimal']['output']
  priceVat: Scalars['Decimal']['output']
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  rentalPrice?: Maybe<MonthlyCostDto>
}

export enum PriceFeedType {
  None = 'NONE',
  Partner = 'PARTNER',
  PartnerSpecific = 'PARTNER_SPECIFIC',
  Public = 'PUBLIC',
}

export type PriceFormatted = {
  originalPrice: Scalars['String']['output']
  originalPriceExcludingVat: Scalars['String']['output']
  originalPriceIncludingVat: Scalars['String']['output']
  price: Scalars['String']['output']
  priceExcludingVat: Scalars['String']['output']
  priceIncludingVat: Scalars['String']['output']
}

export type PriceModel = {
  price: Scalars['String']['output']
  totalPrice: Scalars['String']['output']
}

export enum PricingRuleAgreementType {
  CostAdded = 'COST_ADDED',
  LinePrice = 'LINE_PRICE',
  MarginDiscount = 'MARGIN_DISCOUNT',
  None = 'NONE',
  PriceRebate = 'PRICE_REBATE',
}

export type Product = {
  abTest?: Maybe<ArticleAbTest>
  accessories?: Maybe<Accessories>
  allSpecifications?: Maybe<ProductSpecificationsWrapper>
  assortment: Scalars['String']['output']
  attachments?: Maybe<Attachments>
  availability?: Maybe<Availability>
  axCategory: Scalars['String']['output']
  axCategoryData?: Maybe<AxCategory>
  axCategoryName?: Maybe<Scalars['String']['output']>
  barcodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  brandInfo?: Maybe<GetBrandInfoResult>
  category?: Maybe<Category>
  categoryId?: Maybe<Scalars['String']['output']>
  characteristicTemplateNames?: Maybe<Array<Scalars['String']['output']>>
  chemicalNetWeight?: Maybe<Scalars['Int']['output']>
  delivery?: Maybe<DeliveryMethod>
  deliveryMethods?: Maybe<Array<Maybe<DeliveryMethod>>>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  displaySpecifications: Scalars['String']['output']
  displaySpecificationsVariant: Scalars['String']['output']
  displaySpecificationsVariantC: Scalars['String']['output']
  documentType: Scalars['String']['output']
  ecoResCategoryName?: Maybe<Scalars['String']['output']>
  energyClass?: Maybe<Scalars['String']['output']>
  energyDocumentId?: Maybe<Scalars['String']['output']>
  energyLabelImageId?: Maybe<Scalars['String']['output']>
  englishFullDisplayName: Scalars['String']['output']
  foCategoryData?: Maybe<FoProductCategoryData>
  foSpecificationsByCategory: Array<FoProductSpecificationCategoryData>
  freeFreight?: Maybe<Scalars['Boolean']['output']>
  fullDisplayName: Scalars['String']['output']
  globalName?: Maybe<Scalars['String']['output']>
  gtins?: Maybe<Array<Scalars['String']['output']>>
  hasAccessories?: Maybe<Scalars['Boolean']['output']>
  hasProductNearServices?: Maybe<Scalars['Boolean']['output']>
  hidden: Scalars['Boolean']['output']
  hideInFeeds: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  internalOnly: Scalars['Boolean']['output']
  internalProduct: Scalars['Boolean']['output']
  isDemo?: Maybe<Scalars['Boolean']['output']>
  isDemoProduct: Scalars['Boolean']['output']
  isFoSynthesized: Scalars['Boolean']['output']
  isHiddenFromSearchEngines: Scalars['Boolean']['output']
  isLcpItem?: Maybe<Scalars['Boolean']['output']>
  isNewProduct: Scalars['Boolean']['output']
  isPrivateLabel?: Maybe<Scalars['Boolean']['output']>
  isRentable?: Maybe<Scalars['Boolean']['output']>
  isSpecialItem?: Maybe<Scalars['Boolean']['output']>
  itemGroup: Scalars['String']['output']
  keySellingPoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  keywords?: Maybe<Scalars['String']['output']>
  kits?: Maybe<Array<Maybe<KitArticle>>>
  lastModifiedDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  lastModifiedUtc?: Maybe<Scalars['DateTime']['output']>
  leadTimeWeb?: Maybe<Scalars['String']['output']>
  lotQuantity?: Maybe<Scalars['Int']['output']>
  manufacturer?: Maybe<Scalars['String']['output']>
  manufacturerErpIdentifier: Scalars['String']['output']
  manufacturerId: Scalars['String']['output']
  manufacturerName: Scalars['String']['output']
  manufacturerPartNumber: Scalars['String']['output']
  manufacturerProductIdentifier?: Maybe<Scalars['String']['output']>
  market?: Maybe<Scalars['String']['output']>
  maxQuantity: Scalars['Int']['output']
  maxQuantityPerOrder?: Maybe<Scalars['Int']['output']>
  medias: Array<Media>
  minQuantity: Scalars['Int']['output']
  minQuantityPerOrder?: Maybe<Scalars['Int']['output']>
  nameSlug: Scalars['String']['output']
  nameSlugRedirect: Scalars['String']['output']
  nameSlugSeoCanonicalUrl: Scalars['String']['output']
  newUntilDate?: Maybe<Scalars['DateTime']['output']>
  noReturnsOnItem: Scalars['Boolean']['output']
  nonReturnable: Scalars['Boolean']['output']
  oneLiner?: Maybe<Scalars['String']['output']>
  oneliner: Array<QualifiedValueOfString>
  pageDisplayData?: Maybe<ExtendedDisplay>
  parentId?: Maybe<Scalars['String']['output']>
  parentProduct?: Maybe<ParentProduct>
  partitionKey: Scalars['String']['output']
  plcState?: Maybe<Scalars['String']['output']>
  price?: Maybe<Price>
  primaryImageId?: Maybe<Scalars['String']['output']>
  productCommonSpecificationsSeo?: Maybe<ProductCommonSpecificationsSeo>
  productErpIdentifier: Scalars['String']['output']
  productId: Scalars['String']['output']
  productLifecycle: Array<ProductLifecycle>
  productRedirectType: ProductRedirectType
  productType: ProductType
  promoted?: Maybe<Scalars['Boolean']['output']>
  promotedSpecifications: Array<PromotedSpecificationValue>
  purchasePrice: PurchasePrice
  purchaseTaxGroupId?: Maybe<Array<QualifiedCompanyValueOfString>>
  released?: Maybe<Scalars['Boolean']['output']>
  requireEndUserInfo?: Maybe<Scalars['String']['output']>
  requiredEndUserInformation?: Maybe<Array<RequiredEndUserInformationLineDto>>
  reviewCount: Scalars['Int']['output']
  reviewScore: Scalars['Float']['output']
  salesTaxGroupId?: Maybe<Array<QualifiedCompanyValueOfString>>
  salesUnit?: Maybe<Scalars['String']['output']>
  seoKeywords?: Maybe<Scalars['String']['output']>
  serialNumberControlled?: Maybe<Scalars['Boolean']['output']>
  showAlwaysInStock?: Maybe<Scalars['Boolean']['output']>
  showSpecificationsInProductCardTitle?: Maybe<Scalars['Boolean']['output']>
  softCategories?: Maybe<Array<Maybe<SoftCategory>>>
  structuredDataDescription?: Maybe<Scalars['String']['output']>
  suppressOnHand?: Maybe<Scalars['Boolean']['output']>
  variants?: Maybe<ProductVariantContainer>
  wayOfTransport: Scalars['String']['output']
}

export type ProductPromotedSpecificationsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type ProductAccessory = {
  dependent: Scalars['Boolean']['output']
  displayOrder: Scalars['Int']['output']
  id: Scalars['String']['output']
  mandatory: Scalars['Boolean']['output']
  placement: Placement
  type: AccessoryType
}

export type ProductCategoryChildNavigationItem = {
  category?: Maybe<Category>
  categoryDisplayName?: Maybe<Scalars['String']['output']>
  categoryEnglishDisplayName?: Maybe<Scalars['String']['output']>
  categoryId: Scalars['String']['output']
  children: Array<ProductCategoryChildNavigationItem>
  hits: Scalars['Int']['output']
  productCategoryPimIdentifier?: Maybe<Scalars['Int']['output']>
  selected: Scalars['Boolean']['output']
  sortOrder: Scalars['Int']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type ProductCommonSpecificationsSeo = {
  certificationsValue?: Maybe<Array<CertificationItem>>
  colorValue?: Maybe<Scalars['String']['output']>
  depthValue?: Maybe<DimensionBase>
  heightValue?: Maybe<DimensionBase>
  warrantyPeriodValue?: Maybe<Warranty>
  weightValue?: Maybe<DimensionBase>
  widthValue?: Maybe<DimensionBase>
}

export type ProductDto = {
  categoryId: Scalars['Int']['output']
  created: Scalars['DateTime']['output']
  product?: Maybe<Product>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type ProductEolSitemapValue = {
  eolTimestamp?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  productId: Scalars['String']['output']
}

export type ProductFilterDto = {
  allow: Scalars['Boolean']['output']
  categoryErpIdentifier?: Maybe<Scalars['String']['output']>
  ecoResCategoryErpIdentifierPath?: Maybe<Scalars['String']['output']>
  manufactureName?: Maybe<Scalars['String']['output']>
  productFilterErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type ProductFilterList = {
  facets: Array<Facet>
  hits: Scalars['Int']['output']
  pagination?: Maybe<Pagination>
  productReferences: Array<ProductReference>
}

export type ProductHardwareAttachSalesAccessoriesResult = {
  moreProductHardwareAttachSalesExist: Scalars['Boolean']['output']
  products: Array<Product>
}

export type ProductHistoryDto = {
  availabilityInformation?: Maybe<AccountGraphql_Availability>
  currentPrice?: Maybe<ProductHistoryPriceModel>
  id: Scalars['Int']['output']
  lineDiscountGroupErpIdentifier?: Maybe<Scalars['String']['output']>
  manufacturerErpIdentifier?: Maybe<Scalars['String']['output']>
  manufacturerProductIdentifier?: Maybe<Scalars['String']['output']>
  mediaIdentifier?: Maybe<Scalars['String']['output']>
  nameSlug?: Maybe<Scalars['String']['output']>
  orderId: Scalars['Int']['output']
  pricesArePerMonth: Scalars['Boolean']['output']
  product?: Maybe<Product>
  productDisplayName?: Maybe<Scalars['String']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type ProductHistoryPriceModel = {
  displayOriginalPrice: Scalars['String']['output']
  displayPrice: Scalars['String']['output']
  originalPriceExcludingVat?: Maybe<Scalars['Decimal']['output']>
  originalPriceIncludingVat?: Maybe<Scalars['Decimal']['output']>
  priceExcludingVat?: Maybe<Scalars['Decimal']['output']>
  priceIncludingVat?: Maybe<Scalars['Decimal']['output']>
}

export type ProductHistoryQuantityModel = {
  totalAllocated: Scalars['Int']['output']
  totalOrdered: Scalars['Int']['output']
}

export enum ProductLifeCycleState {
  Active = 'ACTIVE',
  Clearance = 'CLEARANCE',
  EndOfLife = 'END_OF_LIFE',
  ExternalClearance = 'EXTERNAL_CLEARANCE',
  New = 'NEW',
  None = 'NONE',
  NotReleased = 'NOT_RELEASED',
  PermanentlyStopped = 'PERMANENTLY_STOPPED',
  TempStopped = 'TEMP_STOPPED',
}

export type ProductLifecycle = {
  company: Scalars['String']['output']
  state: State
  validFrom: Scalars['String']['output']
  validTo: Scalars['String']['output']
}

export type ProductList = {
  contactId?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  items: Array<ProductListItem>
  productListName?: Maybe<Scalars['String']['output']>
  productListType: Scalars['Int']['output']
  userIdentifier: Scalars['UUID']['output']
}

export type ProductListItem = {
  comment?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  quantity: Scalars['Int']['output']
}

export type ProductMediaDocumentType = {
  displayName?: Maybe<Scalars['String']['output']>
  fileName?: Maybe<Scalars['String']['output']>
  language?: Maybe<Scalars['String']['output']>
  mediaIdentifier: Scalars['String']['output']
  mediaTypeName?: Maybe<Scalars['String']['output']>
}

export type ProductModelInput = {
  name: Scalars['String']['input']
  productErpIdentifier: Scalars['String']['input']
  quantity: Scalars['Int']['input']
  quantityOpened: Scalars['Int']['input']
}

export type ProductNearServicesAccessoriesResult = {
  moreProductNearServicesExist: Scalars['Boolean']['output']
  products: Array<Product>
}

export type ProductPageE4 = {
  alternativeProductsRecommendation: Array<ProductReference>
  errorResponseMessage?: Maybe<Scalars['String']['output']>
  moreFromSeriesProductsRecommendation: Array<ProductReference>
  product?: Maybe<ProductReference>
  recentlyViewedProductsRecommendation: Array<ProductReference>
  styleWithProductsRecommendation: Array<ProductReference>
  upsellProductsRecommendation: Array<ProductReference>
}

export type ProductPageE4Reference = {
  isBot?: Maybe<Scalars['Boolean']['output']>
  productErpIdentifier: Scalars['String']['output']
  productResult?: Maybe<Product>
  searchResult?: Maybe<ProductPageE4>
  touchpoint: Touchpoint
}

export enum ProductRedirectType {
  Category = 'CATEGORY',
  None = 'NONE',
  PermanentlyDeleted = 'PERMANENTLY_DELETED',
}

export type ProductReference = {
  id: Scalars['String']['output']
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  searchResultProduct?: Maybe<SearchResultProduct>
  ticket: Scalars['String']['output']
}

export type ProductReferenceList = {
  productHits: Scalars['Int']['output']
  productReferences: Array<ProductReference>
}

export type ProductReview = {
  author?: Maybe<Scalars['String']['output']>
  cons?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  created: Scalars['DateTime']['output']
  domain?: Maybe<Scalars['String']['output']>
  fullReviewUrl?: Maybe<Scalars['URL']['output']>
  id?: Maybe<Scalars['String']['output']>
  isTranslated: Scalars['Boolean']['output']
  isVerified: Scalars['Boolean']['output']
  language: Language
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  pros?: Maybe<Scalars['String']['output']>
  score: Scalars['Float']['output']
  source?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type: ReviewType
}

export type ProductReviewPages = {
  error?: Maybe<ErrorResult>
  nextPageQuery?: Maybe<Scalars['String']['output']>
  reviews?: Maybe<Array<Maybe<ProductReview>>>
}

export type ProductReviewRequest = {
  contactId: Scalars['String']['output']
  createdDate: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  notificationsCount: Scalars['Int']['output']
  orderId: Scalars['String']['output']
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  reviewedDate?: Maybe<Scalars['DateTime']['output']>
  shipmentDate: Scalars['DateTime']['output']
  token: Scalars['UUID']['output']
  totalCount: Scalars['Int']['output']
}

export type ProductReviewRequests = {
  error?: Maybe<ErrorResult>
  pageNumber: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  reviewRequests: Array<ProductReviewRequest>
  totalCount: Scalars['Int']['output']
}

export type ProductReviewSummary = {
  averageUserScore: Scalars['Float']['output']
  combinedScore: Scalars['Float']['output']
  count: Scalars['Int']['output']
  customerReviewCount: Scalars['Int']['output']
  customerReviews?: Maybe<ReviewPageResult>
  error?: Maybe<ErrorResult>
  id?: Maybe<Scalars['String']['output']>
  language: Language
  proReviewCount: Scalars['Int']['output']
  proReviews?: Maybe<ReviewPageResult>
  productErpIdentifier: Scalars['String']['output']
  reviewWriteAccess: ReviewWriteAccess
}

export type ProductReviews = {
  error?: Maybe<ErrorResult>
  reviews?: Maybe<Array<Maybe<ProductReview>>>
}

export type ProductSearch = {
  facets: Array<Facet>
  navigationTree: Array<CategoryNavigationTreeItem>
  productHits: Scalars['Int']['output']
  productReferences: Array<ProductReference>
}

export type ProductSpecification = {
  name: Scalars['String']['output']
  specificationItemAttributes?: Maybe<Array<SpecificationItemAttribute>>
  value: Scalars['String']['output']
}

export type ProductSpecificationsWrapper = {
  specificationsByCategory: Array<SpecificationsCategory>
}

export enum ProductType {
  CarePacks = 'CARE_PACKS',
  Config = 'CONFIG',
  ELicense = 'E_LICENSE',
  ELicenseAlso = 'E_LICENSE_ALSO',
  Freight = 'FREIGHT',
  GiftCards = 'GIFT_CARDS',
  Installation = 'INSTALLATION',
  Insurance = 'INSURANCE',
  Licenses = 'LICENSES',
  MobileSubscription = 'MOBILE_SUBSCRIPTION',
  None = 'NONE',
  OemItems = 'OEM_ITEMS',
  Other = 'OTHER',
  Products = 'PRODUCTS',
  Reinvoice = 'REINVOICE',
  Service = 'SERVICE',
  ServicePool = 'SERVICE_POOL',
  ServiceProduct = 'SERVICE_PRODUCT',
  Solutions = 'SOLUTIONS',
  Subscription = 'SUBSCRIPTION',
}

export type ProductValue = {
  displayNameEng: Scalars['String']['output']
  id: Scalars['Int']['output']
  itemText: Scalars['String']['output']
  itemValueText: Scalars['String']['output']
  itemValueTextEng: Scalars['String']['output']
  missingVariantNames: Array<Scalars['String']['output']>
  product?: Maybe<Product>
  productErpIdentifier: Scalars['String']['output']
  productVariantCombinationExists: Scalars['Boolean']['output']
  unitText?: Maybe<Scalars['String']['output']>
}

export type ProductVariant = {
  kind: ProductVariantKind
  sortOrder: Scalars['Int']['output']
  values: Array<ProductValue>
  variantName: Scalars['String']['output']
  variantNameEng?: Maybe<Scalars['String']['output']>
}

export type ProductVariantContainer = {
  productIdsCombinationDoesNotExists: Array<Scalars['String']['output']>
  productsWithoutVariantCombination: Array<Product>
  variantsInformation: Array<ProductVariant>
}

export enum ProductVariantKind {
  Boolean = 'BOOLEAN',
  ProductImage = 'PRODUCT_IMAGE',
  Text = 'TEXT',
}

export type ProductsByCategory = {
  ads: Array<AdContainer>
  categoryNavigation?: Maybe<NavigationByCategory>
  facets: Array<Facet>
  filterOnlyFacets?: Maybe<Array<Facet>>
  navigationTree?: Maybe<Array<CategoryNavigationTreeItem>>
  productHits: Scalars['Int']['output']
  productReferences: Array<ProductReference>
}

export type PromotedSpecificationValue = {
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type PurchasePrice = {
  currency: Scalars['String']['output']
  price: Scalars['Decimal']['output']
}

export type QualifiedCompanyValueOfString = {
  company: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type QualifiedValueOfString = {
  channel: Channel
  language: Language
  value: Scalars['String']['output']
}

export type Query = {
  accessories?: Maybe<Accessories>
  accessoryGuide?: Maybe<AccessoryGuide>
  accessoryGuideProducts?: Maybe<AccessoryGuideProductsWithHits>
  accessoryGuides?: Maybe<Array<Category>>
  activationEmailStatus: ActivationEmailStatus
  activity?: Maybe<Activity>
  addressSuggestions?: Maybe<GetAddressSuggestionsResult>
  /** List addresses for the current contact or, when allowed, company-wide in B2B. */
  addresses?: Maybe<GetAddressesResult>
  articleBoxList?: Maybe<ArticleBoxList>
  attachSalesAccessories?: Maybe<Accessories>
  attestGroup?: Maybe<GetAttestGroupResult>
  attestSetupOverview: AttestSetupOverview
  attestSummary?: Maybe<GetAttestSummaryResult>
  autoComplete?: Maybe<AutoComplete>
  autoCompleteE4?: Maybe<AutoCompleteE4>
  banner?: Maybe<Banner>
  brandInfo?: Maybe<GetBrandInfoResult>
  brandNavigation?: Maybe<BrandNavigation>
  businessCustomerSettings?: Maybe<GetBusinessCustomerSettingsResult>
  byUrlData?: Maybe<GetByUrlDataResult>
  campaignbanner?: Maybe<GetCampaignBannerResult>
  cart?: Maybe<Cart>
  cartId?: Maybe<Scalars['Int']['output']>
  cartPageRecommendations?: Maybe<CartPageRecommendations>
  case?: Maybe<GetCaseResult>
  cases?: Maybe<GetCasesResult>
  category?: Maybe<Category>
  categoryByPath?: Maybe<Category>
  categoryImages: Array<CategoryImages>
  categoryNavigation?: Maybe<NavigationByCategory>
  compactOrders?: Maybe<GetCompactOrdersResult>
  compactPreOrders?: Maybe<GetCompactPreOrderResult>
  companyInfo?: Maybe<GetCompanyInfoQueryResult>
  companyName?: Maybe<Scalars['String']['output']>
  comparisons?: Maybe<Comparisons>
  contact?: Maybe<Contact>
  contactWithTypedCustomer?: Maybe<ContactWithTypedCustomerResult>
  contacts?: Maybe<Array<Maybe<AuthConnectedListContact>>>
  customerLandingPage?: Maybe<Scalars['URL']['output']>
  customerNavigation?: Maybe<CustomerNavigation>
  customerPageCategories?: Maybe<GetCategoriesDto>
  customerPageProducts?: Maybe<GetProductsDto>
  customerServiceInquiry?: Maybe<CustomerServiceInquiry>
  cxmlData?: Maybe<CxmlDataResult>
  cxmlPreData?: Maybe<CxmlPreDataResult>
  deliveryMethodsSearch?: Maybe<Array<Maybe<DeliveryMethod>>>
  emailStatus: EmailStatus
  externalOrderItems?: Maybe<GetExternalOrderItemsResult>
  externalOrders?: Maybe<GetExternalOrdersResult>
  favorites?: Maybe<Favorites>
  favoritesById?: Maybe<ProductList>
  favourites?: Maybe<GetProductListsResult>
  federatedBusinessCustomer?: Maybe<GetFederatedBusinessCustomerResult>
  footer?: Maybe<Footer>
  health?: Maybe<Health>
  invitedContact?: Maybe<GetInvitedContactResult>
  invoiceCopy?: Maybe<GetInvoiceCopyResult>
  invoiceDetails?: Maybe<GetInvoiceDetailsResult>
  invoiceSummary?: Maybe<GetInvoiceSummaryResult>
  invoices?: Maybe<GetInvoicesResult>
  isAttester?: Maybe<IsAttesterResult>
  landingPage: LandingPage
  latestBoughtProducts?: Maybe<GetLatestBoughtProductsResult>
  mainNavigation?: Maybe<MainNavigation>
  manageableContacts?: Maybe<GetManageableContactsResult>
  manufacturerProductSearch?: Maybe<ManufacturerProductSearch>
  menuVisibility?: Maybe<MenuVisibilityResult>
  navigationTree: GetNavigationTreeResult
  notificationbanner?: Maybe<GetNotificationBannerResult>
  ociData?: Maybe<OciDataResult>
  offersByEmailStatus?: Maybe<GetOffersByEmailStatusResult>
  orderConfirmationDetail: OrderConfirmationDetails
  orderDetails?: Maybe<GetOrderDetailsResult>
  orderDetailsForRma?: Maybe<OrderDetailsForRmaResult>
  orderHistoryForProduct?: Maybe<GetOrderHistoryForProductResult>
  /** Search order history with filters and paging; B2B may enable 'see all' when permitted. */
  orders?: Maybe<GetOrderHistoryV2Result>
  page?: Maybe<Page>
  peppolData?: Maybe<PeppolDataResult>
  preOrder?: Maybe<GetPreOrderV2Result>
  preOrders?: Maybe<SearchPreOrdersV2Result>
  primaryCustomerPage?: Maybe<PageDto>
  product?: Maybe<Product>
  productFilters?: Maybe<Array<ProductFilterDto>>
  productHardwareAttachSalesAccessories: ProductHardwareAttachSalesAccessoriesResult
  productHistory?: Maybe<GetProductHistoryResult>
  productNearServicesAccessories: ProductNearServicesAccessoriesResult
  productPageE4?: Maybe<ProductPageE4Reference>
  productReviewPages: ProductReviewPages
  productReviewRequests: ProductReviewRequests
  productReviewSummary: ProductReviewSummary
  productReviews: ProductReviews
  productSearch?: Maybe<ProductSearch>
  productSearchByCategoryPath?: Maybe<ProductsByCategory>
  products: Array<Product>
  productsEol?: Maybe<Array<Maybe<ProductEolSitemapValue>>>
  productsEolCount?: Maybe<Scalars['Int']['output']>
  recentlyViewed?: Maybe<RecentlyViewed>
  recommendations: GetRecommendationsResult
  requiredEndUserInformation?: Maybe<Array<Maybe<RequiredEndUserInformationLineDto>>>
  rteErrand?: Maybe<GdprErrand>
  sarErrand?: Maybe<GdprErrand>
  sarReport?: Maybe<GdprErrand>
  sarReportContent?: Maybe<GetSarReportContentResult>
  searchPage: GetSearchPageResult
  suggestedDelivery?: Maybe<DeliveryMethod>
  topContentParts?: Maybe<ContentPartListType>
  topSellingCampaignProducts?: Maybe<TopSellingCampaignProducts>
  topSellingProducts?: Maybe<TopSellingProducts>
  userSettings?: Maybe<UserSettingsModel>
  usp?: Maybe<GetUspResult>
  verifyActivation: VerifyActivationStatus
}

export type QueryAccessoriesArgs = {
  productErpIdentifier: Scalars['String']['input']
}

export type QueryAccessoryGuideArgs = {
  categoryPath: Scalars['String']['input']
}

export type QueryAccessoryGuideProductsArgs = {
  categoryPath: Scalars['String']['input']
  manufacturerName: Scalars['String']['input']
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  searchPhrase?: InputMaybe<Scalars['String']['input']>
}

export type QueryActivationEmailStatusArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type QueryActivityArgs = {
  activityId: Scalars['Int']['input']
}

export type QueryAddressSuggestionsArgs = {
  query?: InputMaybe<GetAddressSuggestionsRequestInput>
}

export type QueryAddressesArgs = {
  query?: InputMaybe<GetAddressesRequestInput>
}

export type QueryArticleBoxListArgs = {
  articleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  categoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  mustIncludeAllTags?: InputMaybe<Scalars['Boolean']['input']>
  numberOfBoxes: Scalars['Int']['input']
  startIndex?: InputMaybe<Scalars['Int']['input']>
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryAttachSalesAccessoriesArgs = {
  accessoriesTakeCount: Scalars['Int']['input']
  excludedProductErpIdentifiers: Array<Scalars['String']['input']>
  productErpIdentifier: Scalars['String']['input']
}

export type QueryAttestGroupArgs = {
  query?: InputMaybe<GetAttestGroupInput>
}

export type QueryAutoCompleteArgs = {
  searchPhrase: Scalars['String']['input']
}

export type QueryAutoCompleteE4Args = {
  searchPhrase: Scalars['String']['input']
  touchpoint: Touchpoint
}

export type QueryBannerArgs = {
  bannerId: Scalars['Int']['input']
}

export type QueryBrandInfoArgs = {
  manufacturerName: Scalars['String']['input']
}

export type QueryByUrlDataArgs = {
  workerIdentifier?: InputMaybe<Scalars['String']['input']>
}

export type QueryCartIdArgs = {
  anonymousUserIdentifier?: InputMaybe<Scalars['UUID']['input']>
  contactId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCartPageRecommendationsArgs = {
  maxPrice?: InputMaybe<Scalars['Float']['input']>
  minPrice?: InputMaybe<Scalars['Float']['input']>
  noOfProducts?: InputMaybe<Scalars['Int']['input']>
  productIds: Array<Scalars['String']['input']>
}

export type QueryCaseArgs = {
  query?: InputMaybe<GetCaseRequestInput>
}

export type QueryCasesArgs = {
  query?: InputMaybe<GetCasesRequestInput>
}

export type QueryCategoryArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>
  onlyValidDescendants?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCategoryByPathArgs = {
  categoryPath?: InputMaybe<Scalars['String']['input']>
}

export type QueryCategoryImagesArgs = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>
  clearCache?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCompactOrdersArgs = {
  numberOfOrders: Scalars['Int']['input']
}

export type QueryCompactPreOrdersArgs = {
  numberOfOrders: Scalars['Int']['input']
}

export type QueryCompanyInfoArgs = {
  organizationNumber?: InputMaybe<Scalars['String']['input']>
}

export type QueryCompanyNameArgs = {
  organizationNumber?: InputMaybe<Scalars['String']['input']>
  sourcingCompany: SourcingCompany
}

export type QueryContactsArgs = {
  siteType: SiteType
}

export type QueryCustomerLandingPageArgs = {
  contactId: Scalars['Int']['input']
}

export type QueryCustomerPageCategoriesArgs = {
  query?: InputMaybe<GetCustomerPageCategoriesRequestInput>
}

export type QueryCustomerPageProductsArgs = {
  query?: InputMaybe<GetCustomerPageProductsRequestInput>
}

export type QueryCustomerServiceInquiryArgs = {
  id: Scalars['Int']['input']
}

export type QueryCxmlDataArgs = {
  ticket?: InputMaybe<Scalars['String']['input']>
}

export type QueryCxmlPreDataArgs = {
  baseUrl?: InputMaybe<Scalars['String']['input']>
  data?: InputMaybe<Scalars['String']['input']>
  httpMethod?: InputMaybe<Scalars['String']['input']>
}

export type QueryDeliveryMethodsSearchArgs = {
  productErpIdentifier: Scalars['String']['input']
}

export type QueryEmailStatusArgs = {
  email?: InputMaybe<Scalars['String']['input']>
}

export type QueryExternalOrderItemsArgs = {
  query?: InputMaybe<GetExternalOrderItemsRequestInput>
}

export type QueryFavoritesByIdArgs = {
  favoriteListId: Scalars['Int']['input']
}

export type QueryInvitedContactArgs = {
  invitationIdentifier: Scalars['UUID']['input']
}

export type QueryInvoiceCopyArgs = {
  query?: InputMaybe<GetInvoiceCopyRequestInput>
}

export type QueryInvoiceDetailsArgs = {
  query?: InputMaybe<GetInvoiceDetailsRequestInput>
}

export type QueryInvoicesArgs = {
  query?: InputMaybe<GetInvoicesRequestInput>
}

export type QueryLandingPageArgs = {
  facets?: InputMaybe<Array<FacetParameterInput>>
  page: Scalars['Int']['input']
  pageReference?: InputMaybe<Scalars['String']['input']>
  pageSize: Scalars['Int']['input']
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  sortBy: SortBy
  touchpoint: Touchpoint
}

export type QueryLatestBoughtProductsArgs = {
  numberOfProducts: Scalars['Int']['input']
}

export type QueryMainNavigationArgs = {
  uri: Scalars['String']['input']
}

export type QueryManageableContactsArgs = {
  query?: InputMaybe<GetManageableContactsRequestInput>
}

export type QueryManufacturerProductSearchArgs = {
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
  manufacturerName?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  selectedCategoryPath?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortBy>
}

export type QueryNavigationTreeArgs = {
  touchpoint: Touchpoint
}

export type QueryOciDataArgs = {
  dustin_url?: InputMaybe<Scalars['String']['input']>
  hook_url?: InputMaybe<Scalars['String']['input']>
  logon_pwd?: InputMaybe<Scalars['String']['input']>
  logon_uid?: InputMaybe<Scalars['String']['input']>
  originalMethod?: InputMaybe<Scalars['String']['input']>
  originalQueryParams?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  returnUrl?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type QueryOffersByEmailStatusArgs = {
  contactId: Scalars['Int']['input']
}

export type QueryOrderConfirmationDetailArgs = {
  query?: InputMaybe<GetOrderConfirmationDetailRequestInput>
}

export type QueryOrderDetailsArgs = {
  query?: InputMaybe<GetOrderDetailsRequestInput>
}

export type QueryOrderDetailsForRmaArgs = {
  query?: InputMaybe<GetOrderDetailsForRmaRequestInput>
}

export type QueryOrderHistoryForProductArgs = {
  query?: InputMaybe<GetOrderHistoryForProductRequestInput>
}

export type QueryOrdersArgs = {
  query?: InputMaybe<GetOrdersRequestInput>
}

export type QueryPageArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>
  uri: Scalars['String']['input']
}

export type QueryPeppolDataArgs = {
  bodyAsString?: InputMaybe<Scalars['String']['input']>
  buyerId?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  postUrl?: InputMaybe<Scalars['String']['input']>
  returnObjectSpecId?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type QueryPreOrderArgs = {
  query?: InputMaybe<GetPreOrderInput>
}

export type QueryPreOrdersArgs = {
  query?: InputMaybe<SearchPreOrderInput>
}

export type QueryProductArgs = {
  productErpIdentifier?: InputMaybe<Scalars['String']['input']>
}

export type QueryProductHardwareAttachSalesAccessoriesArgs = {
  accessoriesTakeCount: Scalars['Int']['input']
  productErpIdentifier: Scalars['String']['input']
}

export type QueryProductHistoryArgs = {
  query?: InputMaybe<GetProductHistoryRequestInput>
}

export type QueryProductNearServicesAccessoriesArgs = {
  accessoriesTakeCount: Scalars['Int']['input']
  productErpIdentifier: Scalars['String']['input']
}

export type QueryProductPageE4Args = {
  isBot?: InputMaybe<Scalars['Boolean']['input']>
  productErpIdentifier: Scalars['String']['input']
  touchpoint: Touchpoint
}

export type QueryProductReviewPagesArgs = {
  pageQuery: Scalars['String']['input']
  productErpIdentifier: Scalars['String']['input']
}

export type QueryProductReviewRequestsArgs = {
  contactToken: Scalars['String']['input']
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type QueryProductReviewSummaryArgs = {
  includeReviewTypes?: InputMaybe<Array<InputMaybe<ReviewType>>>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  productErpIdentifier: Scalars['String']['input']
}

export type QueryProductReviewsArgs = {
  contactId?: InputMaybe<Scalars['String']['input']>
  contactToken?: InputMaybe<Scalars['String']['input']>
  productErpIdentifier?: InputMaybe<Scalars['String']['input']>
}

export type QueryProductSearchArgs = {
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
  isUserInitiated?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  selectedCategoryPath?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortBy>
}

export type QueryProductSearchByCategoryPathArgs = {
  categoryPath: Scalars['String']['input']
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortBy>
}

export type QueryProductsArgs = {
  productErpIdentifiers: Array<Scalars['String']['input']>
}

export type QueryProductsEolArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRecommendationsArgs = {
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type QueryRequiredEndUserInformationArgs = {
  productErpIdentifier: Scalars['String']['input']
}

export type QueryRteErrandArgs = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type QuerySarErrandArgs = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type QuerySarReportArgs = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type QuerySarReportContentArgs = {
  token?: InputMaybe<Scalars['String']['input']>
}

export type QuerySearchPageArgs = {
  facets?: InputMaybe<Array<FacetParameterInput>>
  isUserInitiated?: InputMaybe<Scalars['Boolean']['input']>
  origin: Origin
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  selectedCategoryPath?: InputMaybe<Scalars['String']['input']>
  sortBy: SortBy
  touchpoint: Touchpoint
}

export type QueryTopContentPartsArgs = {
  uri: Scalars['String']['input']
}

export type QueryTopSellingCampaignProductsArgs = {
  numberOfProducts: Scalars['Int']['input']
}

export type QueryTopSellingProductsArgs = {
  categoryPath?: InputMaybe<Scalars['String']['input']>
  facets?: InputMaybe<Array<InputMaybe<FacetParameterInput>>>
  numberOfProducts?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVerifyActivationArgs = {
  activationId?: InputMaybe<Scalars['UUID']['input']>
}

export enum QueryFieldType {
  PredefinedValueSelection = 'PREDEFINED_VALUE_SELECTION',
  TextArea = 'TEXT_AREA',
  TextBox = 'TEXT_BOX',
}

export type RecentSearch = {
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type RecentlyViewed = {
  products: ProductReferenceList
  relatedProducts: ProductReferenceList
}

export type RecentlyViewedProductsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type RecentlyViewedRelatedProductsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type RecommendationProductList = {
  algorithm?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  limit: Scalars['Int']['output']
  productReferences?: Maybe<Array<Maybe<ProductReference>>>
  showMoreLink?: Maybe<Scalars['String']['output']>
  visible: Scalars['Boolean']['output']
  visualization?: Maybe<Scalars['String']['output']>
}

export type RecycledContent = {
  inScopeForBaseYear23_24: Scalars['Boolean']['output']
  recycledContentCMP: Scalars['Decimal']['output']
}

export type RegisterCustomerResult = {
  contactId?: Maybe<Scalars['Int']['output']>
  messages?: Maybe<Array<Maybe<ErrorMessage>>>
  status: RegisterCustomerStatus
  userIdentifier: Scalars['UUID']['output']
}

export enum RegisterCustomerStatus {
  ActivationIdIsNotFound = 'ACTIVATION_ID_IS_NOT_FOUND',
  DisallowNewContact = 'DISALLOW_NEW_CONTACT',
  LoginNotExists = 'LOGIN_NOT_EXISTS',
  OrganizationNumberAlreadyExists = 'ORGANIZATION_NUMBER_ALREADY_EXISTS',
  OrganizationNumberInvalid = 'ORGANIZATION_NUMBER_INVALID',
  PreRegistrationDataInvalid = 'PRE_REGISTRATION_DATA_INVALID',
  PreRegistrationEmailDomainInvalid = 'PRE_REGISTRATION_EMAIL_DOMAIN_INVALID',
  Success = 'SUCCESS',
  UsernameAlreadyExists = 'USERNAME_ALREADY_EXISTS',
  UsernameAlreadyRegisteredOnSite = 'USERNAME_ALREADY_REGISTERED_ON_SITE',
}

export type Registration = {
  errorMessage?: Maybe<Scalars['String']['output']>
  registration?: Maybe<RegistrationResult>
}

export type RegistrationResult = {
  createdAt: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  language: Language
  notificationType: NotificationType
  productId: Scalars['String']['output']
  site: Site
  userIdentifier: Scalars['String']['output']
}

export type RelatedSearch = {
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type RemoveAttesterRequestInput = {
  contactId: Scalars['Int']['input']
  levelId: Scalars['Int']['input']
}

export type RequiredEndUserInformationLineDto = {
  isMandatory: Scalars['Boolean']['output']
  label?: Maybe<Scalars['String']['output']>
  lineNumber: Scalars['Decimal']['output']
}

export type ResendActivationEmailResult = {
  status: ResendActivationEmailStatus
}

export enum ResendActivationEmailStatus {
  EmailFormatIncorrect = 'EMAIL_FORMAT_INCORRECT',
  EmailRequired = 'EMAIL_REQUIRED',
  Failed = 'FAILED',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LoginNotFoundForEmail = 'LOGIN_NOT_FOUND_FOR_EMAIL',
  PendingActivationNotFound = 'PENDING_ACTIVATION_NOT_FOUND',
  ResendActivationEmailDoesNotMatchActivationEmail = 'RESEND_ACTIVATION_EMAIL_DOES_NOT_MATCH_ACTIVATION_EMAIL',
  ResendActivationLimitReached = 'RESEND_ACTIVATION_LIMIT_REACHED',
  Success = 'SUCCESS',
}

export type Result = {
  error?: Maybe<ErrorResult>
}

export type ReviewPageResult = {
  nextPageQuery?: Maybe<Scalars['String']['output']>
  reviews?: Maybe<Array<ProductReview>>
}

export enum ReviewType {
  Customer = 'CUSTOMER',
  Pro = 'PRO',
}

export enum ReviewWriteAccess {
  Allowed = 'ALLOWED',
  AlreadyReviewedProduct = 'ALREADY_REVIEWED_PRODUCT',
  BlockedUser = 'BLOCKED_USER',
  NotAuthenticatedUser = 'NOT_AUTHENTICATED_USER',
  NotPurchasedProduct = 'NOT_PURCHASED_PRODUCT',
  ReviewRequestPending = 'REVIEW_REQUEST_PENDING',
}

export type SearchPreOrderInput = {
  datePeriod: DatePeriodType
  onlyPendingOrders: Scalars['Boolean']['input']
  ordersPlacedFromDateTime?: InputMaybe<Scalars['DateTime']['input']>
  ordersPlacedToDateTime?: InputMaybe<Scalars['DateTime']['input']>
  ordersToShow?: InputMaybe<OrdersToShow>
  pageNumber?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchPhrase: Scalars['String']['input']
  sortByDirection: Direction
  sortByField: Field
}

export type SearchPreOrdersV2Result = {
  preOrders?: Maybe<Array<Maybe<PreOrderV2>>>
  totalCount: Scalars['Int']['output']
}

export type SearchResultProduct = {
  assortmentId: Scalars['Int']['output']
  availability?: Maybe<Availability>
  categoryName?: Maybe<Scalars['String']['output']>
  categoryPath?: Maybe<Scalars['String']['output']>
  categoryPathEng?: Maybe<Scalars['String']['output']>
  categoryPimIdentifier: Scalars['Int']['output']
  displayName?: Maybe<Scalars['String']['output']>
  displaySpecifications: Scalars['String']['output']
  ecoResCategoryErpIdentifier: Scalars['String']['output']
  energyClass?: Maybe<Scalars['String']['output']>
  energyDocumentId?: Maybe<Scalars['String']['output']>
  energyLabelImageId?: Maybe<Scalars['String']['output']>
  englishFullDisplayName?: Maybe<Scalars['String']['output']>
  etaDateTimeUtc: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  internalProduct: Scalars['Boolean']['output']
  isNewProduct: Scalars['Boolean']['output']
  lineDiscountGroupErpIdentifier: Scalars['String']['output']
  manufacturerErpIdentifier: Scalars['String']['output']
  manufacturerIsWhiteLabel: Scalars['Boolean']['output']
  manufacturerName: Scalars['String']['output']
  manufacturerProductIdentifier?: Maybe<Scalars['String']['output']>
  maxQuantityPerOrder?: Maybe<Scalars['Int']['output']>
  minQuantityPerOrder?: Maybe<Scalars['Int']['output']>
  nameSlug: Scalars['String']['output']
  oneLiner?: Maybe<Scalars['String']['output']>
  price?: Maybe<Price>
  primaryImageId?: Maybe<Scalars['String']['output']>
  productErpIdentifier: Scalars['String']['output']
  productNewUntilDateTimeUtc: Scalars['DateTime']['output']
  promotedSpecifications: Array<ProductSpecification>
  reviewCount: Scalars['Int']['output']
  reviewScore: Scalars['Float']['output']
  showAlwaysInStock: Scalars['Boolean']['output']
  showEtaOnWeb: Scalars['Boolean']['output']
  showSpecificationsInProductCardTitle?: Maybe<Scalars['Boolean']['output']>
  suppressExternalStock: Scalars['Boolean']['output']
  ticket?: Maybe<Scalars['String']['output']>
}

export type SearchResultProductPromotedSpecificationsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type SendAccountRequestEmailForExistingCompanyResult = {
  message: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type SendContactInvitationRequestInput = {
  email: Scalars['String']['input']
}

export type SendContactInvitationResult = {
  emailResponseType: EmailResponseType
  ok: Scalars['Boolean']['output']
}

export type SendPaymentConfirmationEmailRequestInput = {
  orderId: Scalars['Int']['input']
}

export type SendProductListInvitationResult = {
  id: Scalars['Int']['output']
}

export type SendRequestForPartialDeliveryRequestInput = {
  orderId: Scalars['Int']['input']
}

export type SendRequestForPartialDeliveryResult = {
  success: Scalars['Boolean']['output']
}

export type SetDefaultGroupRequestInput = {
  groupId?: InputMaybe<Scalars['Int']['input']>
}

export type SettingsDto = {
  customerErp?: Maybe<Scalars['String']['output']>
  primaryPageId: Scalars['Int']['output']
}

export enum Site {
  DustinBelgium = 'DUSTIN_BELGIUM',
  DustinDenmark = 'DUSTIN_DENMARK',
  DustinFinland = 'DUSTIN_FINLAND',
  DustinHomeDenmark = 'DUSTIN_HOME_DENMARK',
  DustinHomeFinland = 'DUSTIN_HOME_FINLAND',
  DustinHomeNetherlands = 'DUSTIN_HOME_NETHERLANDS',
  DustinHomeNorway = 'DUSTIN_HOME_NORWAY',
  DustinHomeSweden = 'DUSTIN_HOME_SWEDEN',
  DustinNetherlands = 'DUSTIN_NETHERLANDS',
  DustinNorway = 'DUSTIN_NORWAY',
  DustinSweden = 'DUSTIN_SWEDEN',
  None = 'NONE',
}

export type SiteInfo = {
  googleAnalytics?: Maybe<GoogleAnalytics>
  name?: Maybe<Scalars['String']['output']>
  siteBaseUrl?: Maybe<Scalars['String']['output']>
}

export enum SiteType {
  Business = 'BUSINESS',
  Consumer = 'CONSUMER',
  None = 'NONE',
}

export type SocialMediaLinks = {
  facebook?: Maybe<Scalars['String']['output']>
  instagram?: Maybe<Scalars['String']['output']>
  linkedIn?: Maybe<Scalars['String']['output']>
  twitter?: Maybe<Scalars['String']['output']>
  youTube?: Maybe<Scalars['String']['output']>
}

export type SoftCategory = {
  campaignEndDateUtc?: Maybe<Scalars['DateTime']['output']>
  campaignStartDateUtc?: Maybe<Scalars['DateTime']['output']>
  campaignType: Scalars['String']['output']
  categoryIcon: Scalars['String']['output']
  categoryParentId: Scalars['String']['output']
  id: Scalars['String']['output']
  idPath: Scalars['String']['output']
  isLeaf: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  namePath?: Maybe<Scalars['String']['output']>
  pathSlug: Scalars['String']['output']
  seoLongTitleName?: Maybe<Scalars['String']['output']>
  seoMetaDescription?: Maybe<Scalars['String']['output']>
  seoText?: Maybe<Scalars['String']['output']>
  seoTitle?: Maybe<Scalars['String']['output']>
}

export type SoftCategoryContent = {
  bigHeader: Scalars['Boolean']['output']
  brandName?: Maybe<Scalars['String']['output']>
  campaignOnly: Scalars['Boolean']['output']
  categoryPath?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  contentBlocks: Array<GridBlock>
  cssClass: Scalars['String']['output']
  cssStyle?: Maybe<Scalars['String']['output']>
  header?: Maybe<Scalars['String']['output']>
  image?: Maybe<Image>
  newProductsOnly: Scalars['Boolean']['output']
  outerCssClass: Scalars['String']['output']
  outerCssStyle: Scalars['String']['output']
  searchPhrase?: Maybe<Scalars['String']['output']>
  showMoreText?: Maybe<Scalars['String']['output']>
  showMoreUrl?: Maybe<Scalars['String']['output']>
  textFirst: Scalars['Boolean']['output']
  type: SoftCategoryContentType
}

export type SoftCategoryContentNavigationItem = {
  displayName: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  subNavigationItems: Array<SoftCategoryContentSubNavigationItem>
  url: Scalars['String']['output']
}

export type SoftCategoryContentPage = {
  breadcrumbs: Array<Breadcrumb>
  content: Array<SoftCategoryContent>
  disableSiteSelector: Scalars['Boolean']['output']
  header?: Maybe<Scalars['String']['output']>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  navigationItems: Array<SoftCategoryContentNavigationItem>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export type SoftCategoryContentSubNavigationItem = {
  displayName: Scalars['String']['output']
  subNavigationItems: Array<SoftCategoryContentSubNavigationItem>
  url: Scalars['String']['output']
}

export enum SoftCategoryContentType {
  ActivityBanner = 'ACTIVITY_BANNER',
  HeaderBanner = 'HEADER_BANNER',
  HtmlBlock = 'HTML_BLOCK',
  ProductFilterBlock = 'PRODUCT_FILTER_BLOCK',
  ProductGroup = 'PRODUCT_GROUP',
  ShopByFilterSectionsContentBlocks = 'SHOP_BY_FILTER_SECTIONS_CONTENT_BLOCKS',
}

export type SoftCategoryPage = {
  breadcrumbs: Array<Breadcrumb>
  content: Array<SoftCategoryContent>
  contentBlocks: Array<GridBlock>
  description: Scalars['String']['output']
  disableSiteSelector: Scalars['Boolean']['output']
  header: Scalars['String']['output']
  logo?: Maybe<Image>
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
  url: Scalars['String']['output']
}

export enum SortBy {
  Alphabetical = 'ALPHABETICAL',
  Asc = 'ASC',
  Desc = 'DESC',
  Relevance = 'RELEVANCE',
  ReviewScore = 'REVIEW_SCORE',
  Sales = 'SALES',
}

export enum SourceSystem {
  Ax = 'AX',
  Cnet = 'CNET',
  Generated = 'GENERATED',
  Icecat = 'ICECAT',
  Legacy = 'LEGACY',
  Pim = 'PIM',
  Textual = 'TEXTUAL',
  Translated = 'TRANSLATED',
  Undefined = 'UNDEFINED',
}

export enum SourcingCompany {
  Be = 'BE',
  Dk = 'DK',
  Fi = 'FI',
  Nl = 'NL',
  No = 'NO',
  None = 'NONE',
  Se = 'SE',
}

export enum SourcingCompanyInput {
  Be = 'BE',
  Dk = 'DK',
  Fi = 'FI',
  Nl = 'NL',
  No = 'NO',
  None = 'NONE',
  Se = 'SE',
}

export type SpecificationForDisplayDto = {
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type SpecificationItem = {
  displayInProductTitle: Scalars['Boolean']['output']
  filterValue?: Maybe<Scalars['String']['output']>
  hideInPromotedSpecification: Scalars['Boolean']['output']
  hideInSpecification: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  isPromoted: Scalars['Boolean']['output']
  itemText: Scalars['String']['output']
  itemValuesEng: Array<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  sortOrder?: Maybe<Scalars['Int']['output']>
  unitText?: Maybe<Scalars['String']['output']>
  values: Array<Scalars['String']['output']>
  variantSortOrder?: Maybe<Scalars['Int']['output']>
  variantType?: Maybe<Scalars['String']['output']>
  webFilterSortOrder?: Maybe<Scalars['Int']['output']>
}

export enum SpecificationItemAttribute {
  FacetCollapsed = 'FACET_COLLAPSED',
  FacetOpened = 'FACET_OPENED',
  HideInShortSpecification = 'HIDE_IN_SHORT_SPECIFICATION',
  HideInSpecification = 'HIDE_IN_SPECIFICATION',
  None = 'NONE',
  ShowInProductName = 'SHOW_IN_PRODUCT_NAME',
  ShowOnSearchAndLandingPages = 'SHOW_ON_SEARCH_AND_LANDING_PAGES',
}

export type SpecificationsCategory = {
  categoryText: Scalars['String']['output']
  displayOrder: Scalars['Float']['output']
  specifications: Array<SpecificationItem>
}

export type StartPage = {
  body: Scalars['String']['output']
  breadcrumbs: Array<Breadcrumb>
  disableSiteSelector: Scalars['Boolean']['output']
  metaDescription?: Maybe<Scalars['String']['output']>
  metaKeywords?: Maybe<Scalars['String']['output']>
  noIndex: Scalars['Boolean']['output']
  ogImage?: Maybe<Image>
  theme: Theme
  title: Scalars['String']['output']
  type: PageType
}

export enum State {
  Active = 'ACTIVE',
  Clearance = 'CLEARANCE',
  EndOfLife = 'END_OF_LIFE',
  ExternalClearance = 'EXTERNAL_CLEARANCE',
  NotSet = 'NOT_SET',
  PermanentlyStopped = 'PERMANENTLY_STOPPED',
  PreOrder = 'PRE_ORDER',
  TempStopped = 'TEMP_STOPPED',
  Undefined = 'UNDEFINED',
}

export type StructureGroupAttribute = {
  description: Scalars['String']['output']
  groupName: Scalars['String']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  shortName: Scalars['String']['output']
}

export type SubTotal = {
  perMonthExcludingVat?: Maybe<Scalars['Decimal']['output']>
  perMonthIncludingVat?: Maybe<Scalars['Decimal']['output']>
  quantity: Scalars['Int']['output']
  serviceDurationMonths?: Maybe<Scalars['Int']['output']>
  totalExcludingVat: Scalars['Decimal']['output']
  totalIncludingVat: Scalars['Decimal']['output']
  totalVat: Scalars['Decimal']['output']
}

export type Suggestion = {
  rank: Scalars['Int']['output']
  relevance: Scalars['Decimal']['output']
  ticket?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type SurveyOptInRequestInput = {
  optedIn: Scalars['Boolean']['input']
}

export enum TaxGroup {
  FullG = 'FULL_G',
  FullG2 = 'FULL_G2',
  FullS = 'FULL_S',
  NlRev = 'NL_REV',
  None = 'NONE',
  Red1G = 'RED1_G',
  Red1S = 'RED1_S',
  Red2G = 'RED2_G',
  Red2S = 'RED2_S',
  ZeroG = 'ZERO_G',
  ZeroS = 'ZERO_S',
}

export enum Theme {
  BlackWeek = 'BLACK_WEEK',
  Default = 'DEFAULT',
}

export type TopSellingCampaignProducts = {
  products: Array<ProductReference>
}

export type TopSellingProducts = {
  productReferences: Array<ProductReference>
}

export enum Touchpoint {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
}

export enum UnitType {
  Hrs = 'HRS',
  None = 'NONE',
  Pack = 'PACK',
  Pcs = 'PCS',
}

export type Unspsc = {
  code: Scalars['String']['output']
  name: Scalars['String']['output']
  version: Scalars['Decimal']['output']
}

export type UpdateAccountInformationRequestInput = {
  invoiceEmail: Scalars['String']['input']
  invoiceType: InvoiceType
  selectedStandIn?: InputMaybe<Scalars['Int']['input']>
  standInUntilDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateAddressRequestInput = {
  addressId: Scalars['Int']['input']
  addressLine: Scalars['String']['input']
  addressee: Scalars['String']['input']
  billing: Scalars['Boolean']['input']
  city: Scalars['String']['input']
  department: Scalars['String']['input']
  goodsReceiverName: Scalars['String']['input']
  houseNumber: Scalars['String']['input']
  houseNumberSuffix: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  shipping: Scalars['Boolean']['input']
  suppressValidation: Scalars['Boolean']['input']
}

export type UpdateAddressResult = {
  newAddressId: Scalars['Int']['output']
}

export type UpdateCartItemCommentResult = {
  cartItemId: Scalars['Int']['output']
}

export type UpdateCartResult = {
  id: Scalars['Int']['output']
}

export type UpdateCartWithItemRequestInput = {
  lastViewedPriceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>
  lastViewedPriceIncludingVat?: InputMaybe<Scalars['Decimal']['input']>
  lastViewedVatAmount?: InputMaybe<Scalars['Decimal']['input']>
  productErpIdentifier: Scalars['String']['input']
  quantity: Scalars['Int']['input']
}

export type UpdateCartWithMultipleItemsRequestInput = {
  cartItems: Array<CartItemInput>
}

export type UpdateCategoryRequestInput = {
  categoryId: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type UpdateContactPermissionsRequestInput = {
  blockWebLogin: Scalars['Boolean']['input']
  canSeeAllOrders: Scalars['Boolean']['input']
  cannotManageAddresses: Scalars['Boolean']['input']
  contactId: Scalars['Int']['input']
  superUser: Scalars['Boolean']['input']
}

export type UpdateGroupLevelRequestInput = {
  levelId: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type UpdateGroupRequestInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
  useOnlyHighestAttestLevel: Scalars['Boolean']['input']
}

export type UpdatePageContentRequestInput = {
  content: Scalars['String']['input']
  header: Scalars['String']['input']
  lead: Scalars['String']['input']
  pageId: Scalars['Int']['input']
}

export type UpdateProductListNameResult = {
  updatedProductListName?: Maybe<Scalars['String']['output']>
}

export type UpdateProductListResult = {
  productListId: Scalars['Int']['output']
  productListItemId: Scalars['Int']['output']
}

export type UpdateRequestStatusResult = {
  status: GdprErrandStatus
  successful: Scalars['Boolean']['output']
}

export type UpdateShowPricesInclVatUserSettingRequestInput = {
  showPricesInclVat: Scalars['Boolean']['input']
}

export type UpdateUserInformationRequestInput = {
  cellPhone: Scalars['String']['input']
  customerReferenceCostCenter: Scalars['String']['input']
  customerReferenceName: Scalars['String']['input']
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  language: Language
  lastName: Scalars['String']['input']
  offersByEmail?: InputMaybe<Scalars['Boolean']['input']>
  phone: Scalars['String']['input']
  profilingAccepted: Scalars['Boolean']['input']
  sendSolutionsMagazine?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpsertRequiredEndUserInformationResult = {
  cartItemId: Scalars['Int']['output']
}

export type UserSettingsModel = {
  showPricesInclVat?: Maybe<Scalars['Boolean']['output']>
}

export enum UserType {
  B2B = 'B2B',
  B2C = 'B2C',
  None = 'NONE',
}

export type Usp = {
  iconId: Scalars['String']['output']
  link: ContentLink
  text: Scalars['String']['output']
}

export enum VerifyActivationStatus {
  Expired = 'EXPIRED',
  Valid = 'VALID',
}

export type Warranty = {
  durationOfWarranty?: Maybe<DurationOfWarranty>
  typeValue: Scalars['String']['output']
}

export enum WayOfTransport {
  Config = 'CONFIG',
  Email = 'EMAIL',
  GoodsLetter = 'GOODS_LETTER',
  Letter = 'LETTER',
  None = 'NONE',
  Package = 'PACKAGE',
  Pallet = 'PALLET',
  Sp = 'SP',
}

export type AccountGraphql_Accessories = {
  dependentAccessories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  insuranceAccessories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  mandatoryAccessories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  normalAccessories?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  topAccessories?: Maybe<Array<Maybe<AccessoryProductModel>>>
}

export type AccountGraphql_Availability = {
  availabilityDetails?: Maybe<AvailabilityDetails>
  availabilityStatus: AvailabilityStatus
  availabilityStatusPresentation: AvailabilityStatusPresentation
  externalStock?: Maybe<ExternalStockAvailability>
  internal: Scalars['Boolean']['output']
  internalEtaStock?: Maybe<InternalEtaStockAvailability>
  internalStock?: Maybe<InternalStockAvailability>
  isAvailableForSale: Scalars['Boolean']['output']
  isIncludedInKit: Scalars['Boolean']['output']
  isPreOrder: Scalars['Boolean']['output']
  maxAvailableQuantity?: Maybe<Scalars['Int']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  productLifeCycleState: ProductLifeCycleState
  showAvailabilityQuantities: Scalars['Boolean']['output']
  showEtaDate: Scalars['Boolean']['output']
}

export type AccountGraphql_CartItem = {
  canBeDeliveredImmediately: Scalars['Boolean']['output']
  comment?: Maybe<Scalars['String']['output']>
  endUserInformation?: Maybe<Array<Maybe<EndUserInformation>>>
  id: Scalars['Int']['output']
  parentCartItemId?: Maybe<Scalars['Int']['output']>
  product?: Maybe<CartProduct>
  quantity: Scalars['Int']['output']
  totalPriceDisplay?: Maybe<Scalars['String']['output']>
}

export type AccountGraphql_DeliveryMethod = {
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type AccountGraphql_Price = {
  bidDistributorErpIdentifier?: Maybe<Scalars['String']['output']>
  bidSourceLocally: Scalars['Boolean']['output']
  campaignEndDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  campaignPercentage?: Maybe<Scalars['Int']['output']>
  campaignStartDateTimeUtc?: Maybe<Scalars['DateTime']['output']>
  campaignType?: Maybe<CampaignType>
  /** Includes chemical tax. */
  costPrice: Scalars['Decimal']['output']
  formatted: PriceFormatted
  isBestSeller: Scalars['Boolean']['output']
  isBid: Scalars['Boolean']['output']
  isCampaign: Scalars['Boolean']['output']
  isRecommendedProduct: Scalars['Boolean']['output']
  originalPrice: Scalars['Decimal']['output']
  originalPriceExcludingVat: Scalars['Decimal']['output']
  originalPriceIncludingVat: Scalars['Decimal']['output']
  originalPriceVat: Scalars['Decimal']['output']
  price: Scalars['Decimal']['output']
  priceExcludingVat: Scalars['Decimal']['output']
  priceIncludingVat: Scalars['Decimal']['output']
  priceMargin: Scalars['Decimal']['output']
  priceVat: Scalars['Decimal']['output']
  productErpIdentifier?: Maybe<Scalars['String']['output']>
}

export type AccountGraphql_ProductList = {
  contactId?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  items?: Maybe<Array<Maybe<AccountGraphql_ProductListItem>>>
  productListName?: Maybe<Scalars['String']['output']>
  productListType: Scalars['Int']['output']
  userIdentifier: Scalars['UUID']['output']
}

export type AccountGraphql_ProductListItem = {
  comment?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  quantity: Scalars['Int']['output']
}

export type GetCategoryNavigationQueryVariables = Exact<{ [key: string]: never }>

export type GetCategoryNavigationQuery = {
  categoryNavigation?: {
    id?: string | null
    children: Array<{
      categoryId: string
      categoryDisplayName?: string | null
      categoryEnglishDisplayName?: string | null
      url?: string | null
      children: Array<{
        categoryId: string
        categoryDisplayName?: string | null
        categoryEnglishDisplayName?: string | null
        url?: string | null
        children: Array<{
          categoryId: string
          categoryDisplayName?: string | null
          categoryEnglishDisplayName?: string | null
          url?: string | null
        }>
      }>
    }>
  } | null
}

export type GetCategoryNavigationShallowQueryVariables = Exact<{ [key: string]: never }>

export type GetCategoryNavigationShallowQuery = {
  categoryNavigation?: {
    id?: string | null
    children: Array<{
      categoryId: string
      categoryDisplayName?: string | null
      categoryEnglishDisplayName?: string | null
      url?: string | null
    }>
  } | null
}

export type DeleteFavoriteListMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteFavoriteListMutation = { deleteFavoriteList?: { id: number } | null }

export type EmptyCartMutationVariables = Exact<{
  withRequiredEndUserInformation?: InputMaybe<Scalars['Boolean']['input']>
}>

export type EmptyCartMutation = {
  emptyCart?: {
    id: number
    items: Array<{
      id: number
      productErpIdentifier: string
      quantity: number
      isMandatory: boolean
      isDependent: boolean
      mainProductErpIdentifier?: string | null
      parentCartItemId?: number | null
      comment?: string | null
      product?: {
        displayName: string
        englishFullDisplayName: string
        displaySpecifications: string
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        nameSlug: string
        primaryImageId?: string | null
        productErpIdentifier: string
        reviewScore: number
        reviewCount: number
        maxQuantityPerOrder?: number | null
        minQuantityPerOrder?: number | null
        nonReturnable: boolean
        internalProduct: boolean
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        availability?: {
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          IsNotifyEligible: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          isIncludedInKit: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number } | null
        } | null
        price?: {
          priceExcludingVat: number
          priceIncludingVat: number
          originalPriceExcludingVat: number
          originalPriceIncludingVat: number
          isCampaign: boolean
          priceVat: number
          isBid: boolean
          formatted: { priceExcludingVat: string; priceIncludingVat: string }
        } | null
        requiredEndUserInformation?: Array<{
          label?: string | null
          lineNumber: number
          isMandatory: boolean
        }> | null
      } | null
      endUserInformation?: Array<{
        value?: string | null
        lineNumber: number
        label?: string | null
      } | null> | null
    }>
  } | null
}

export type CartItemProductFragment = {
  displayName: string
  englishFullDisplayName: string
  displaySpecifications: string
  manufacturerName: string
  manufacturerProductIdentifier?: string | null
  nameSlug: string
  primaryImageId?: string | null
  productErpIdentifier: string
  reviewScore: number
  reviewCount: number
  maxQuantityPerOrder?: number | null
  minQuantityPerOrder?: number | null
  nonReturnable: boolean
  internalProduct: boolean
  productType: ProductType
  category?: { englishPathSlug?: string | null } | null
  availability?: {
    maxAvailableQuantity?: number | null
    availabilityStatus: AvailabilityStatus
    availabilityStatusPresentation: AvailabilityStatusPresentation
    isAvailableForSale: boolean
    IsNotifyEligible: boolean
    isPreOrder: boolean
    productLifeCycleState: ProductLifeCycleState
    showAvailabilityQuantities: boolean
    showEtaDate: boolean
    isIncludedInKit: boolean
    internalEtaStock?: { quantity: number; eta: any } | null
    externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
    availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
    internalStock?: { quantity: number } | null
  } | null
  price?: {
    priceExcludingVat: number
    priceIncludingVat: number
    originalPriceExcludingVat: number
    originalPriceIncludingVat: number
    isCampaign: boolean
    priceVat: number
    isBid: boolean
    formatted: { priceExcludingVat: string; priceIncludingVat: string }
  } | null
  requiredEndUserInformation?: Array<{
    label?: string | null
    lineNumber: number
    isMandatory: boolean
  }> | null
}

export type CartItemFragment = {
  id: number
  productErpIdentifier: string
  quantity: number
  isMandatory: boolean
  isDependent: boolean
  mainProductErpIdentifier?: string | null
  parentCartItemId?: number | null
  comment?: string | null
  product?: {
    displayName: string
    englishFullDisplayName: string
    displaySpecifications: string
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    nameSlug: string
    primaryImageId?: string | null
    productErpIdentifier: string
    reviewScore: number
    reviewCount: number
    maxQuantityPerOrder?: number | null
    minQuantityPerOrder?: number | null
    nonReturnable: boolean
    internalProduct: boolean
    productType: ProductType
    category?: { englishPathSlug?: string | null } | null
    availability?: {
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      IsNotifyEligible: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      isIncludedInKit: boolean
      internalEtaStock?: { quantity: number; eta: any } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number } | null
    } | null
    price?: {
      priceExcludingVat: number
      priceIncludingVat: number
      originalPriceExcludingVat: number
      originalPriceIncludingVat: number
      isCampaign: boolean
      priceVat: number
      isBid: boolean
      formatted: { priceExcludingVat: string; priceIncludingVat: string }
    } | null
    requiredEndUserInformation?: Array<{
      label?: string | null
      lineNumber: number
      isMandatory: boolean
    }> | null
  } | null
  endUserInformation?: Array<{
    value?: string | null
    lineNumber: number
    label?: string | null
  } | null> | null
}

export type CartItemResultFragment = {
  id: number
  productErpIdentifier: string
  quantity: number
  isMandatory: boolean
  isDependent: boolean
  mainProductErpIdentifier?: string | null
  parentCartItemId: number
  comment?: string | null
  product?: {
    displayName: string
    englishFullDisplayName: string
    displaySpecifications: string
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    nameSlug: string
    primaryImageId?: string | null
    productErpIdentifier: string
    reviewScore: number
    reviewCount: number
    maxQuantityPerOrder?: number | null
    minQuantityPerOrder?: number | null
    nonReturnable: boolean
    internalProduct: boolean
    productType: ProductType
    category?: { englishPathSlug?: string | null } | null
    availability?: {
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      IsNotifyEligible: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      isIncludedInKit: boolean
      internalEtaStock?: { quantity: number; eta: any } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number } | null
    } | null
    price?: {
      priceExcludingVat: number
      priceIncludingVat: number
      originalPriceExcludingVat: number
      originalPriceIncludingVat: number
      isCampaign: boolean
      priceVat: number
      isBid: boolean
      formatted: { priceExcludingVat: string; priceIncludingVat: string }
    } | null
    requiredEndUserInformation?: Array<{
      label?: string | null
      lineNumber: number
      isMandatory: boolean
    }> | null
  } | null
}

export type CartFragment = {
  id: number
  items: Array<{
    id: number
    productErpIdentifier: string
    quantity: number
    isMandatory: boolean
    isDependent: boolean
    mainProductErpIdentifier?: string | null
    parentCartItemId?: number | null
    comment?: string | null
    product?: {
      displayName: string
      englishFullDisplayName: string
      displaySpecifications: string
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      nameSlug: string
      primaryImageId?: string | null
      productErpIdentifier: string
      reviewScore: number
      reviewCount: number
      maxQuantityPerOrder?: number | null
      minQuantityPerOrder?: number | null
      nonReturnable: boolean
      internalProduct: boolean
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      availability?: {
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        IsNotifyEligible: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        isIncludedInKit: boolean
        internalEtaStock?: { quantity: number; eta: any } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number } | null
      } | null
      price?: {
        priceExcludingVat: number
        priceIncludingVat: number
        originalPriceExcludingVat: number
        originalPriceIncludingVat: number
        isCampaign: boolean
        priceVat: number
        isBid: boolean
        formatted: { priceExcludingVat: string; priceIncludingVat: string }
      } | null
      requiredEndUserInformation?: Array<{
        label?: string | null
        lineNumber: number
        isMandatory: boolean
      }> | null
    } | null
    endUserInformation?: Array<{
      value?: string | null
      lineNumber: number
      label?: string | null
    } | null> | null
  }>
}

export type ProductFragment = {
  id: string
  productErpIdentifier: string
  displayName: string
  englishFullDisplayName: string
  primaryImageId?: string | null
  manufacturerName: string
  manufacturerProductIdentifier?: string | null
  displaySpecifications: string
  oneLiner?: string | null
  internalProduct: boolean
  nameSlug: string
  energyClass?: string | null
  energyLabelImageId?: string | null
  reviewScore: number
  reviewCount: number
  isNewProduct: boolean
  minQuantityPerOrder?: number | null
  maxQuantityPerOrder?: number | null
  showSpecificationsInProductCardTitle?: boolean | null
  productType: ProductType
  category?: { englishPathSlug?: string | null } | null
  promotedSpecifications: Array<{ name: string; value: string }>
  price?: {
    campaignPercentage?: number | null
    campaignType?: CampaignType | null
    isBestSeller: boolean
    isBid: boolean
    isCampaign: boolean
    isRecommendedProduct: boolean
    price: number
    priceExcludingVat: number
    priceIncludingVat: number
    originalPrice: number
    priceVat: number
    formatted: {
      price: string
      originalPrice: string
      priceExcludingVat: string
      priceIncludingVat: string
    }
  } | null
  availability?: {
    IsNotifyEligible: boolean
    maxAvailableQuantity?: number | null
    availabilityStatus: AvailabilityStatus
    availabilityStatusPresentation: AvailabilityStatusPresentation
    isAvailableForSale: boolean
    isPreOrder: boolean
    productLifeCycleState: ProductLifeCycleState
    showAvailabilityQuantities: boolean
    showEtaDate: boolean
    internalEtaStock?: { eta: any; quantity: number } | null
    externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
    availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
    internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
  } | null
}

export type ProductForListFragment = {
  id: string
  productErpIdentifier: string
  displayName?: string | null
  englishFullDisplayName?: string | null
  primaryImageId?: string | null
  manufacturerName: string
  manufacturerProductIdentifier?: string | null
  displaySpecifications: string
  oneLiner?: string | null
  internalProduct: boolean
  nameSlug: string
  energyClass?: string | null
  energyDocumentId?: string | null
  energyLabelImageId?: string | null
  reviewScore: number
  reviewCount: number
  isNewProduct: boolean
  showSpecificationsInProductCardTitle?: boolean | null
  categoryName?: string | null
  categoryPath?: string | null
  categoryPathEng?: string | null
  minQuantityPerOrder?: number | null
  promotedSpecifications: Array<{ name: string; value: string }>
  price?: {
    campaignPercentage?: number | null
    campaignType?: CampaignType | null
    isBestSeller: boolean
    isBid: boolean
    isCampaign: boolean
    isRecommendedProduct: boolean
    price: number
    priceExcludingVat: number
    priceIncludingVat: number
    originalPrice: number
    priceVat: number
    formatted: {
      price: string
      originalPrice: string
      priceExcludingVat: string
      priceIncludingVat: string
    }
  } | null
  availability?: {
    IsNotifyEligible: boolean
    maxAvailableQuantity?: number | null
    availabilityStatus: AvailabilityStatus
    availabilityStatusPresentation: AvailabilityStatusPresentation
    isAvailableForSale: boolean
    isPreOrder: boolean
    productLifeCycleState: ProductLifeCycleState
    showAvailabilityQuantities: boolean
    showEtaDate: boolean
    internalEtaStock?: { quantity: number; eta: any } | null
    externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
    availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
    internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
  } | null
}

export type ProductReferenceFragment = {
  id: string
  ticket: string
  searchResultProduct?: {
    id: string
    productErpIdentifier: string
    displayName?: string | null
    englishFullDisplayName?: string | null
    primaryImageId?: string | null
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    displaySpecifications: string
    oneLiner?: string | null
    internalProduct: boolean
    nameSlug: string
    energyClass?: string | null
    energyDocumentId?: string | null
    energyLabelImageId?: string | null
    reviewScore: number
    reviewCount: number
    isNewProduct: boolean
    showSpecificationsInProductCardTitle?: boolean | null
    categoryName?: string | null
    categoryPath?: string | null
    categoryPathEng?: string | null
    minQuantityPerOrder?: number | null
    promotedSpecifications: Array<{ name: string; value: string }>
    price?: {
      campaignPercentage?: number | null
      campaignType?: CampaignType | null
      isBestSeller: boolean
      isBid: boolean
      isCampaign: boolean
      isRecommendedProduct: boolean
      price: number
      priceExcludingVat: number
      priceIncludingVat: number
      originalPrice: number
      priceVat: number
      formatted: {
        price: string
        originalPrice: string
        priceExcludingVat: string
        priceIncludingVat: string
      }
    } | null
    availability?: {
      IsNotifyEligible: boolean
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      internalEtaStock?: { quantity: number; eta: any } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
    } | null
  } | null
}

export type AutocompleteProductFragment = {
  id: string
  ticket: string
  searchResultProduct?: {
    id: string
    productErpIdentifier: string
    displayName: string
    englishFullDisplayName: string
    primaryImageId?: string | null
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    displaySpecifications: string
    oneLiner?: string | null
    internalProduct: boolean
    nameSlug: string
    energyClass?: string | null
    energyLabelImageId?: string | null
    reviewScore: number
    reviewCount: number
    isNewProduct: boolean
    minQuantityPerOrder?: number | null
    maxQuantityPerOrder?: number | null
    showSpecificationsInProductCardTitle?: boolean | null
    productType: ProductType
    category?: { englishPathSlug?: string | null } | null
    promotedSpecifications: Array<{ name: string; value: string }>
    price?: {
      campaignPercentage?: number | null
      campaignType?: CampaignType | null
      isBestSeller: boolean
      isBid: boolean
      isCampaign: boolean
      isRecommendedProduct: boolean
      price: number
      priceExcludingVat: number
      priceIncludingVat: number
      originalPrice: number
      priceVat: number
      formatted: {
        price: string
        originalPrice: string
        priceExcludingVat: string
        priceIncludingVat: string
      }
    } | null
    availability?: {
      IsNotifyEligible: boolean
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      internalEtaStock?: { eta: any; quantity: number } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
    } | null
  } | null
}

export type ProductListItemFragment = {
  id: number
  productErpIdentifier: string
  product?: { id: string; productErpIdentifier: string; displayName: string } | null
}

export type ExtendedProductListItemFragment = {
  id: number
  productErpIdentifier: string
  quantity: number
  comment?: string | null
  product?: {
    id: string
    productErpIdentifier: string
    displayName: string
    englishFullDisplayName: string
    primaryImageId?: string | null
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    displaySpecifications: string
    oneLiner?: string | null
    internalProduct: boolean
    nameSlug: string
    energyClass?: string | null
    energyLabelImageId?: string | null
    reviewScore: number
    reviewCount: number
    isNewProduct: boolean
    minQuantityPerOrder?: number | null
    maxQuantityPerOrder?: number | null
    showSpecificationsInProductCardTitle?: boolean | null
    productType: ProductType
    category?: { englishPathSlug?: string | null } | null
    promotedSpecifications: Array<{ name: string; value: string }>
    price?: {
      campaignPercentage?: number | null
      campaignType?: CampaignType | null
      isBestSeller: boolean
      isBid: boolean
      isCampaign: boolean
      isRecommendedProduct: boolean
      price: number
      priceExcludingVat: number
      priceIncludingVat: number
      originalPrice: number
      priceVat: number
      formatted: {
        price: string
        originalPrice: string
        priceExcludingVat: string
        priceIncludingVat: string
      }
    } | null
    availability?: {
      IsNotifyEligible: boolean
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      internalEtaStock?: { eta: any; quantity: number } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
    } | null
  } | null
}

export type FavoriteListItemFragment = {
  id: number
  productListName?: string | null
  items: Array<{
    id: number
    productErpIdentifier: string
    product?: { id: string; productErpIdentifier: string; displayName: string } | null
  }>
}

export type ExtendedFavoriteListItemFragment = {
  id: number
  productListName?: string | null
  items: Array<{
    id: number
    productErpIdentifier: string
    quantity: number
    comment?: string | null
    product?: {
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    } | null
  }>
}

export type FavoritesFragment = {
  productLists?: Array<{
    id: number
    productListName?: string | null
    items: Array<{
      id: number
      productErpIdentifier: string
      product?: { id: string; productErpIdentifier: string; displayName: string } | null
    }>
  } | null> | null
}

export type ExtendedFavoritesFragment = {
  productLists?: Array<{
    id: number
    productListName?: string | null
    items: Array<{
      id: number
      productErpIdentifier: string
      quantity: number
      comment?: string | null
      product?: {
        id: string
        productErpIdentifier: string
        displayName: string
        englishFullDisplayName: string
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        minQuantityPerOrder?: number | null
        maxQuantityPerOrder?: number | null
        showSpecificationsInProductCardTitle?: boolean | null
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { eta: any; quantity: number } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null> | null
  productRecommendations?: Array<{
    id: string
    ticket: string
    searchResultProduct?: {
      id: string
      productErpIdentifier: string
      displayName?: string | null
      englishFullDisplayName?: string | null
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyDocumentId?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      showSpecificationsInProductCardTitle?: boolean | null
      categoryName?: string | null
      categoryPath?: string | null
      categoryPathEng?: string | null
      minQuantityPerOrder?: number | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { quantity: number; eta: any } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    } | null
  }> | null
}

export type ComparisonsFragment = {
  productLists: Array<{
    id: number
    productListName?: string | null
    items: Array<{
      id: number
      productErpIdentifier: string
      product?: { id: string; productErpIdentifier: string; displayName: string } | null
    }>
  }>
}

export type GetAccessoriesQueryVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
}>

export type GetAccessoriesQuery = {
  accessories?: {
    normalAccessories: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
    topAccessories: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
    dependentAccessories: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
  } | null
}

export type GetAttachSalesAccessoriesQueryVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
  accessoriesTakeCount: Scalars['Int']['input']
  excludedProductErpIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type GetAttachSalesAccessoriesQuery = {
  attachSalesAccessories?: {
    normalAccessories: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
    topAccessories: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
    dependentAccessories: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
  } | null
}

export type GetActivityProductsQueryVariables = Exact<{
  activityId: Scalars['Int']['input']
}>

export type GetActivityProductsQuery = {
  activity?: {
    id: number
    productErpIdentifiers?: Array<string | null> | null
    products: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { name?: string | null; englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
  } | null
}

export type GetAutocompleteE4QueryVariables = Exact<{
  searchPhrase: Scalars['String']['input']
  touchpoint: Touchpoint
}>

export type GetAutocompleteE4Query = {
  autoComplete?: {
    searchPhrase?: string | null
    productHitCount: number
    products?: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName: string
        englishFullDisplayName: string
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        minQuantityPerOrder?: number | null
        maxQuantityPerOrder?: number | null
        showSpecificationsInProductCardTitle?: boolean | null
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { eta: any; quantity: number } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    } | null> | null
    recentlyViewed?: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName: string
        englishFullDisplayName: string
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        minQuantityPerOrder?: number | null
        maxQuantityPerOrder?: number | null
        showSpecificationsInProductCardTitle?: boolean | null
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { eta: any; quantity: number } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    } | null> | null
    relatedCategories?: Array<{
      count: number
      category?: { name?: string | null; namePath?: string | null; pathSlug: string } | null
    }> | null
    suggestions?: Array<{
      title?: string | null
      rank: number
      ticket?: string | null
      url?: string | null
    } | null> | null
    recentSearches?: Array<{ title?: string | null; url?: string | null } | null> | null
  } | null
}

export type CartPageRecommendationsQueryVariables = Exact<{
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input']
  noOfProducts?: InputMaybe<Scalars['Int']['input']>
  minPrice?: InputMaybe<Scalars['Float']['input']>
  maxPrice?: InputMaybe<Scalars['Float']['input']>
}>

export type CartPageRecommendationsQuery = {
  cartPageRecommendations?: {
    productReferences: Array<{
      id: string
      ticket: string
      product?: {
        id: string
        productErpIdentifier: string
        displayName: string
        englishFullDisplayName: string
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        oneLiner?: string | null
        internalProduct: boolean
        displaySpecifications: string
        nameSlug: string
        energyClass?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        minQuantityPerOrder?: number | null
        maxQuantityPerOrder?: number | null
        category?: { englishPathSlug?: string | null } | null
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { eta: any; quantity: number } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null
}

export type CategoryPartFragment = { pathSlug: string; name?: string | null; id: string }

export type GetCategoriesQueryVariables = Exact<{
  categoryId: Scalars['String']['input']
  onlyValidDescendants?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetCategoriesQuery = {
  category?: {
    pathSlug: string
    name?: string | null
    id: string
    children?: Array<{
      pathSlug: string
      name?: string | null
      id: string
      children?: Array<{
        pathSlug: string
        name?: string | null
        id: string
        children?: Array<{ pathSlug: string; name?: string | null; id: string }> | null
      }> | null
    }> | null
  } | null
}

export type GetCategoryLinkByPathQueryVariables = Exact<{
  categoryPath: Scalars['String']['input']
}>

export type GetCategoryLinkByPathQuery = {
  categoryByPath?: {
    name?: string | null
    pathSlug: string
    mostPopularProduct?: {
      searchResultProduct?: { displayName?: string | null; primaryImageId?: string | null } | null
    } | null
  } | null
}

export type GetContactQueryVariables = Exact<{ [key: string]: never }>

export type GetContactQuery = {
  contact?: {
    firstName?: string | null
    lastName?: string | null
    superUser: boolean
    email?: string | null
    businessCustomer?: { attestEnabled: boolean; companyName?: string | null } | null
    customer?: { erpIdentifier?: string | null } | null
    connectedContacts?: Array<{ id: number }> | null
    visibility?: {
      showAddresses: boolean
      showAttest: boolean
      showContacts: boolean
      showServices: boolean
      showPreOrder: boolean
      showExternalOrders: boolean
      showInvoices: boolean
    } | null
  } | null
}

export type GetComparisonsQueryVariables = Exact<{ [key: string]: never }>

export type GetComparisonsQuery = {
  comparisons?: {
    productLists: Array<{
      id: number
      productListName?: string | null
      items: Array<{ id: number; productErpIdentifier: string }>
    }>
  } | null
}

export type GetFavoritesQueryVariables = Exact<{ [key: string]: never }>

export type GetFavoritesQuery = {
  favorites?: {
    productLists?: Array<{
      productListName?: string | null
      productListType: number
      id: number
      items: Array<{ comment?: string | null; id: number; productErpIdentifier: string }>
    } | null> | null
  } | null
}

export type GetProductRecommendationsForFavoritesQueryVariables = Exact<{ [key: string]: never }>

export type GetProductRecommendationsForFavoritesQuery = {
  favorites?: {
    productRecommendations?: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }> | null
  } | null
}

export type GetExtendedFavoritesQueryVariables = Exact<{
  enableFavoritesRecommendations?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetExtendedFavoritesQuery = {
  favorites?: {
    productLists?: Array<{
      id: number
      productListName?: string | null
      items: Array<{
        id: number
        productErpIdentifier: string
        quantity: number
        comment?: string | null
        product?: {
          id: string
          productErpIdentifier: string
          displayName: string
          englishFullDisplayName: string
          primaryImageId?: string | null
          manufacturerName: string
          manufacturerProductIdentifier?: string | null
          displaySpecifications: string
          oneLiner?: string | null
          internalProduct: boolean
          nameSlug: string
          energyClass?: string | null
          energyLabelImageId?: string | null
          reviewScore: number
          reviewCount: number
          isNewProduct: boolean
          minQuantityPerOrder?: number | null
          maxQuantityPerOrder?: number | null
          showSpecificationsInProductCardTitle?: boolean | null
          productType: ProductType
          category?: { englishPathSlug?: string | null } | null
          promotedSpecifications: Array<{ name: string; value: string }>
          price?: {
            campaignPercentage?: number | null
            campaignType?: CampaignType | null
            isBestSeller: boolean
            isBid: boolean
            isCampaign: boolean
            isRecommendedProduct: boolean
            price: number
            priceExcludingVat: number
            priceIncludingVat: number
            originalPrice: number
            priceVat: number
            formatted: {
              price: string
              originalPrice: string
              priceExcludingVat: string
              priceIncludingVat: string
            }
          } | null
          availability?: {
            IsNotifyEligible: boolean
            maxAvailableQuantity?: number | null
            availabilityStatus: AvailabilityStatus
            availabilityStatusPresentation: AvailabilityStatusPresentation
            isAvailableForSale: boolean
            isPreOrder: boolean
            productLifeCycleState: ProductLifeCycleState
            showAvailabilityQuantities: boolean
            showEtaDate: boolean
            internalEtaStock?: { eta: any; quantity: number } | null
            externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
            availabilityDetails?: {
              formattedDateUtc?: string | null
              key: AvailabilityStatusType
            } | null
            internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
          } | null
        } | null
      }>
    } | null> | null
    productRecommendations?: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }> | null
  } | null
}

export type GetExtendedFavoritesNoRecommendationsQueryVariables = Exact<{ [key: string]: never }>

export type GetExtendedFavoritesNoRecommendationsQuery = {
  favorites?: {
    productLists?: Array<{
      id: number
      productListName?: string | null
      items: Array<{
        id: number
        productErpIdentifier: string
        quantity: number
        comment?: string | null
        product?: {
          id: string
          productErpIdentifier: string
          displayName: string
          englishFullDisplayName: string
          primaryImageId?: string | null
          manufacturerName: string
          manufacturerProductIdentifier?: string | null
          displaySpecifications: string
          oneLiner?: string | null
          internalProduct: boolean
          nameSlug: string
          energyClass?: string | null
          energyLabelImageId?: string | null
          reviewScore: number
          reviewCount: number
          isNewProduct: boolean
          minQuantityPerOrder?: number | null
          maxQuantityPerOrder?: number | null
          showSpecificationsInProductCardTitle?: boolean | null
          productType: ProductType
          category?: { englishPathSlug?: string | null } | null
          promotedSpecifications: Array<{ name: string; value: string }>
          price?: {
            campaignPercentage?: number | null
            campaignType?: CampaignType | null
            isBestSeller: boolean
            isBid: boolean
            isCampaign: boolean
            isRecommendedProduct: boolean
            price: number
            priceExcludingVat: number
            priceIncludingVat: number
            originalPrice: number
            priceVat: number
            formatted: {
              price: string
              originalPrice: string
              priceExcludingVat: string
              priceIncludingVat: string
            }
          } | null
          availability?: {
            IsNotifyEligible: boolean
            maxAvailableQuantity?: number | null
            availabilityStatus: AvailabilityStatus
            availabilityStatusPresentation: AvailabilityStatusPresentation
            isAvailableForSale: boolean
            isPreOrder: boolean
            productLifeCycleState: ProductLifeCycleState
            showAvailabilityQuantities: boolean
            showEtaDate: boolean
            internalEtaStock?: { eta: any; quantity: number } | null
            externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
            availabilityDetails?: {
              formattedDateUtc?: string | null
              key: AvailabilityStatusType
            } | null
            internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
          } | null
        } | null
      }>
    } | null> | null
  } | null
}

export type GetFavoritesByIdQueryVariables = Exact<{
  favoriteListId: Scalars['Int']['input']
}>

export type GetFavoritesByIdQuery = {
  favoritesById?: {
    id: number
    productListName?: string | null
    items: Array<{
      id: number
      productErpIdentifier: string
      quantity: number
      comment?: string | null
      product?: {
        id: string
        productErpIdentifier: string
        displayName: string
        englishFullDisplayName: string
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        minQuantityPerOrder?: number | null
        maxQuantityPerOrder?: number | null
        showSpecificationsInProductCardTitle?: boolean | null
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { eta: any; quantity: number } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null
}

export type GetCartQueryVariables = Exact<{
  withRequiredEndUserInformation?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetCartQuery = {
  cart?: {
    id: number
    items: Array<{
      id: number
      productErpIdentifier: string
      quantity: number
      isMandatory: boolean
      isDependent: boolean
      mainProductErpIdentifier?: string | null
      parentCartItemId?: number | null
      comment?: string | null
      product?: {
        displayName: string
        englishFullDisplayName: string
        displaySpecifications: string
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        nameSlug: string
        primaryImageId?: string | null
        productErpIdentifier: string
        reviewScore: number
        reviewCount: number
        maxQuantityPerOrder?: number | null
        minQuantityPerOrder?: number | null
        nonReturnable: boolean
        internalProduct: boolean
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        availability?: {
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          IsNotifyEligible: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          isIncludedInKit: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number } | null
        } | null
        price?: {
          priceExcludingVat: number
          priceIncludingVat: number
          originalPriceExcludingVat: number
          originalPriceIncludingVat: number
          isCampaign: boolean
          priceVat: number
          isBid: boolean
          formatted: { priceExcludingVat: string; priceIncludingVat: string }
        } | null
        requiredEndUserInformation?: Array<{
          label?: string | null
          lineNumber: number
          isMandatory: boolean
        }> | null
      } | null
      endUserInformation?: Array<{
        value?: string | null
        lineNumber: number
        label?: string | null
      } | null> | null
    }>
  } | null
  suggestedDelivery?: {
    shippingFeeExcludingVat: number
    shippingFeeVat: number
    shippingInsuranceFeeExcludingVat: number
    shippingInsuranceFeeVat: number
  } | null
}

export type GetCustomerProductListsQueryVariables = Exact<{ [key: string]: never }>

export type GetCustomerProductListsQuery = {
  comparisons?: {
    productLists: Array<{
      id: number
      productListName?: string | null
      items: Array<{
        id: number
        productErpIdentifier: string
        product?: { id: string; productErpIdentifier: string; displayName: string } | null
      }>
    }>
  } | null
  favorites?: {
    productLists?: Array<{
      id: number
      productListName?: string | null
      items: Array<{
        id: number
        productErpIdentifier: string
        product?: { id: string; productErpIdentifier: string; displayName: string } | null
      }>
    } | null> | null
  } | null
}

export type RecommendedProductFragment = {
  id: string
  productErpIdentifier: string
  displayName: string
  englishFullDisplayName: string
  primaryImageId?: string | null
  manufacturerName: string
  manufacturerProductIdentifier?: string | null
  displaySpecifications: string
  oneLiner?: string | null
  internalProduct: boolean
  nameSlug: string
  energyClass?: string | null
  energyDocumentId?: string | null
  energyLabelImageId?: string | null
  reviewScore: number
  reviewCount: number
  isNewProduct: boolean
  showSpecificationsInProductCardTitle?: boolean | null
  minQuantityPerOrder?: number | null
  promotedSpecifications: Array<{ name: string; value: string }>
  price?: {
    campaignPercentage?: number | null
    campaignType?: CampaignType | null
    isBestSeller: boolean
    isBid: boolean
    isCampaign: boolean
    isRecommendedProduct: boolean
    price: number
    priceExcludingVat: number
    priceIncludingVat: number
    originalPrice: number
    priceVat: number
    formatted: {
      price: string
      originalPrice: string
      priceExcludingVat: string
      priceIncludingVat: string
    }
  } | null
  availability?: {
    IsNotifyEligible: boolean
    maxAvailableQuantity?: number | null
    availabilityStatus: AvailabilityStatus
    availabilityStatusPresentation: AvailabilityStatusPresentation
    isAvailableForSale: boolean
    isPreOrder: boolean
    productLifeCycleState: ProductLifeCycleState
    showAvailabilityQuantities: boolean
    showEtaDate: boolean
    internalEtaStock?: { quantity: number; eta: any } | null
    externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
    availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
    internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
  } | null
  category?: {
    englishPathSlug?: string | null
    name?: string | null
    namePath?: string | null
  } | null
}

export type GetLandingPageQueryVariables = Exact<{
  pageSize: Scalars['Int']['input']
  page: Scalars['Int']['input']
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  facets?: InputMaybe<Array<FacetParameterInput> | FacetParameterInput>
  sortBy: SortBy
  pageReference: Scalars['String']['input']
  touchpoint: Touchpoint
}>

export type GetLandingPageQuery = {
  landingPage: {
    pageId?: string | null
    recommendationList?: Array<{
      algorithm?: string | null
      id?: string | null
      label?: string | null
      limit: number
      showMoreLink?: string | null
      visible: boolean
      visualization?: string | null
      productReferences?: Array<{
        productErpIdentifier: string
        ticket: string
        product?: {
          id: string
          productErpIdentifier: string
          displayName: string
          englishFullDisplayName: string
          primaryImageId?: string | null
          manufacturerName: string
          manufacturerProductIdentifier?: string | null
          displaySpecifications: string
          oneLiner?: string | null
          internalProduct: boolean
          nameSlug: string
          energyClass?: string | null
          energyDocumentId?: string | null
          energyLabelImageId?: string | null
          reviewScore: number
          reviewCount: number
          isNewProduct: boolean
          showSpecificationsInProductCardTitle?: boolean | null
          minQuantityPerOrder?: number | null
          promotedSpecifications: Array<{ name: string; value: string }>
          price?: {
            campaignPercentage?: number | null
            campaignType?: CampaignType | null
            isBestSeller: boolean
            isBid: boolean
            isCampaign: boolean
            isRecommendedProduct: boolean
            price: number
            priceExcludingVat: number
            priceIncludingVat: number
            originalPrice: number
            priceVat: number
            formatted: {
              price: string
              originalPrice: string
              priceExcludingVat: string
              priceIncludingVat: string
            }
          } | null
          availability?: {
            IsNotifyEligible: boolean
            maxAvailableQuantity?: number | null
            availabilityStatus: AvailabilityStatus
            availabilityStatusPresentation: AvailabilityStatusPresentation
            isAvailableForSale: boolean
            isPreOrder: boolean
            productLifeCycleState: ProductLifeCycleState
            showAvailabilityQuantities: boolean
            showEtaDate: boolean
            internalEtaStock?: { quantity: number; eta: any } | null
            externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
            availabilityDetails?: {
              formattedDateUtc?: string | null
              key: AvailabilityStatusType
            } | null
            internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
          } | null
          category?: {
            englishPathSlug?: string | null
            name?: string | null
            namePath?: string | null
          } | null
        } | null
      } | null> | null
    } | null> | null
  }
}

export type GetProductByIdsQueryVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
}>

export type GetProductByIdsQuery = {
  product?: {
    id: string
    productErpIdentifier: string
    displayName: string
    englishFullDisplayName: string
    primaryImageId?: string | null
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    displaySpecifications: string
    oneLiner?: string | null
    internalProduct: boolean
    nameSlug: string
    energyClass?: string | null
    energyLabelImageId?: string | null
    reviewScore: number
    reviewCount: number
    isNewProduct: boolean
    minQuantityPerOrder?: number | null
    maxQuantityPerOrder?: number | null
    showSpecificationsInProductCardTitle?: boolean | null
    productType: ProductType
    category?: { englishPathSlug?: string | null } | null
    promotedSpecifications: Array<{ name: string; value: string }>
    price?: {
      campaignPercentage?: number | null
      campaignType?: CampaignType | null
      isBestSeller: boolean
      isBid: boolean
      isCampaign: boolean
      isRecommendedProduct: boolean
      price: number
      priceExcludingVat: number
      priceIncludingVat: number
      originalPrice: number
      priceVat: number
      formatted: {
        price: string
        originalPrice: string
        priceExcludingVat: string
        priceIncludingVat: string
      }
    } | null
    availability?: {
      IsNotifyEligible: boolean
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      internalEtaStock?: { eta: any; quantity: number } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
    } | null
  } | null
}

export type GetProductFilterListByActivityIdQueryVariables = Exact<{
  activityId: Scalars['Int']['input']
  facets?: InputMaybe<Array<FacetParameterInput> | FacetParameterInput>
  sortBy: SortBy
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}>

export type GetProductFilterListByActivityIdQuery = {
  activity?: {
    productFilterList: {
      hits: number
      productReferences: Array<{
        id: string
        ticket: string
        searchResultProduct?: {
          id: string
          productErpIdentifier: string
          displayName?: string | null
          englishFullDisplayName?: string | null
          primaryImageId?: string | null
          manufacturerName: string
          manufacturerProductIdentifier?: string | null
          displaySpecifications: string
          oneLiner?: string | null
          internalProduct: boolean
          nameSlug: string
          energyClass?: string | null
          energyDocumentId?: string | null
          energyLabelImageId?: string | null
          reviewScore: number
          reviewCount: number
          isNewProduct: boolean
          showSpecificationsInProductCardTitle?: boolean | null
          categoryName?: string | null
          categoryPath?: string | null
          categoryPathEng?: string | null
          minQuantityPerOrder?: number | null
          promotedSpecifications: Array<{ name: string; value: string }>
          price?: {
            campaignPercentage?: number | null
            campaignType?: CampaignType | null
            isBestSeller: boolean
            isBid: boolean
            isCampaign: boolean
            isRecommendedProduct: boolean
            price: number
            priceExcludingVat: number
            priceIncludingVat: number
            originalPrice: number
            priceVat: number
            formatted: {
              price: string
              originalPrice: string
              priceExcludingVat: string
              priceIncludingVat: string
            }
          } | null
          availability?: {
            IsNotifyEligible: boolean
            maxAvailableQuantity?: number | null
            availabilityStatus: AvailabilityStatus
            availabilityStatusPresentation: AvailabilityStatusPresentation
            isAvailableForSale: boolean
            isPreOrder: boolean
            productLifeCycleState: ProductLifeCycleState
            showAvailabilityQuantities: boolean
            showEtaDate: boolean
            internalEtaStock?: { quantity: number; eta: any } | null
            externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
            availabilityDetails?: {
              formattedDateUtc?: string | null
              key: AvailabilityStatusType
            } | null
            internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
          } | null
        } | null
      }>
      facets: Array<{
        name: string
        type: FacetType
        displayName: string
        displayEnglishName: string
        facetOpened: boolean
        nameInUrl: string
        isTranslated: boolean
        unitText: string
        id: string
        ticket: string
        displayOrder: number
        facetType: FacetType
        values: Array<{
          displayName?: string | null
          name: string
          hits: number
          min?: number | null
          max?: number | null
        }>
      }>
      pagination?: {
        pageSize: number
        totalPages: number
        page: number
        totalHitsUntilEnd: number
      } | null
    }
    banners?: Array<{
      displayMode: string
      imageUrl?: string | null
      text?: string | null
      relatedProductErpIdentifiers?: Array<string> | null
      relatedProducts?: Array<{
        id: string
        productErpIdentifier: string
        displayName: string
        englishFullDisplayName: string
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        minQuantityPerOrder?: number | null
        maxQuantityPerOrder?: number | null
        showSpecificationsInProductCardTitle?: boolean | null
        productType: ProductType
        category?: { englishPathSlug?: string | null } | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { eta: any; quantity: number } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      }> | null
    } | null> | null
  } | null
}

export type GetProductHardwareAttachSalesAccessoriesQueryVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
  accessoriesTakeCount: Scalars['Int']['input']
}>

export type GetProductHardwareAttachSalesAccessoriesQuery = {
  productHardwareAttachSalesAccessories: {
    moreProductHardwareAttachSalesExist: boolean
    products: Array<{
      id: string
      productErpIdentifier: string
      displayName: string
      englishFullDisplayName: string
      primaryImageId?: string | null
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      displaySpecifications: string
      oneLiner?: string | null
      internalProduct: boolean
      nameSlug: string
      energyClass?: string | null
      energyLabelImageId?: string | null
      reviewScore: number
      reviewCount: number
      isNewProduct: boolean
      minQuantityPerOrder?: number | null
      maxQuantityPerOrder?: number | null
      showSpecificationsInProductCardTitle?: boolean | null
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      promotedSpecifications: Array<{ name: string; value: string }>
      price?: {
        campaignPercentage?: number | null
        campaignType?: CampaignType | null
        isBestSeller: boolean
        isBid: boolean
        isCampaign: boolean
        isRecommendedProduct: boolean
        price: number
        priceExcludingVat: number
        priceIncludingVat: number
        originalPrice: number
        priceVat: number
        formatted: {
          price: string
          originalPrice: string
          priceExcludingVat: string
          priceIncludingVat: string
        }
      } | null
      availability?: {
        IsNotifyEligible: boolean
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        internalEtaStock?: { eta: any; quantity: number } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
      } | null
    }>
  }
}

export type GetProductsByCategoryPathQueryVariables = Exact<{
  categoryPath: Scalars['String']['input']
  selectedFacets?: InputMaybe<Array<FacetParameterInput> | FacetParameterInput>
  numberOfProducts: Scalars['Int']['input']
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortBy>
}>

export type GetProductsByCategoryPathQuery = {
  productSearchByCategoryPath?: {
    productReferences: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null
}

export type GetProductsByIdsQueryVariables = Exact<{
  productErpIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type GetProductsByIdsQuery = {
  products: Array<{
    id: string
    productErpIdentifier: string
    displayName: string
    englishFullDisplayName: string
    primaryImageId?: string | null
    manufacturerName: string
    manufacturerProductIdentifier?: string | null
    displaySpecifications: string
    oneLiner?: string | null
    internalProduct: boolean
    nameSlug: string
    energyClass?: string | null
    energyLabelImageId?: string | null
    reviewScore: number
    reviewCount: number
    isNewProduct: boolean
    minQuantityPerOrder?: number | null
    maxQuantityPerOrder?: number | null
    showSpecificationsInProductCardTitle?: boolean | null
    productType: ProductType
    category?: { name?: string | null; englishPathSlug?: string | null } | null
    promotedSpecifications: Array<{ name: string; value: string }>
    price?: {
      campaignPercentage?: number | null
      campaignType?: CampaignType | null
      isBestSeller: boolean
      isBid: boolean
      isCampaign: boolean
      isRecommendedProduct: boolean
      price: number
      priceExcludingVat: number
      priceIncludingVat: number
      originalPrice: number
      priceVat: number
      formatted: {
        price: string
        originalPrice: string
        priceExcludingVat: string
        priceIncludingVat: string
      }
    } | null
    availability?: {
      IsNotifyEligible: boolean
      maxAvailableQuantity?: number | null
      availabilityStatus: AvailabilityStatus
      availabilityStatusPresentation: AvailabilityStatusPresentation
      isAvailableForSale: boolean
      isPreOrder: boolean
      productLifeCycleState: ProductLifeCycleState
      showAvailabilityQuantities: boolean
      showEtaDate: boolean
      internalEtaStock?: { eta: any; quantity: number } | null
      externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
      availabilityDetails?: { formattedDateUtc?: string | null; key: AvailabilityStatusType } | null
      internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
    } | null
  }>
}

export type NavigationTreeItemFragment = {
  categoryDisplayName: string
  categoryPathSlug: string
  hits: number
}

export type GetProductsForManufacturerQueryVariables = Exact<{
  sortBy: SortBy
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  selectedFacets?: InputMaybe<Array<FacetParameterInput> | FacetParameterInput>
  selectedCategoryPath?: InputMaybe<Scalars['String']['input']>
  manufacturerName?: InputMaybe<Scalars['String']['input']>
}>

export type GetProductsForManufacturerQuery = {
  manufacturerProductSearch?: {
    productHits: number
    facets: Array<{
      name: string
      type: FacetType
      displayName: string
      displayEnglishName: string
      facetOpened: boolean
      nameInUrl: string
      isTranslated: boolean
      unitText: string
      values: Array<{
        displayName?: string | null
        name: string
        hits: number
        min?: number | null
        max?: number | null
      }>
    }>
    productReferences: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
    navigationTree: Array<{
      categoryDisplayName: string
      categoryPathSlug: string
      hits: number
      children: Array<{
        categoryDisplayName: string
        categoryPathSlug: string
        hits: number
        children: Array<{ categoryDisplayName: string; categoryPathSlug: string; hits: number }>
      }>
    }>
  } | null
}

export type GetRecentlyViewedQueryVariables = Exact<{ [key: string]: never }>

export type GetRecentlyViewedQuery = {
  recentlyViewed?: {
    products: {
      productReferences: Array<{
        id: string
        ticket: string
        searchResultProduct?: {
          id: string
          productErpIdentifier: string
          displayName?: string | null
          englishFullDisplayName?: string | null
          primaryImageId?: string | null
          manufacturerName: string
          manufacturerProductIdentifier?: string | null
          displaySpecifications: string
          oneLiner?: string | null
          internalProduct: boolean
          nameSlug: string
          energyClass?: string | null
          energyDocumentId?: string | null
          energyLabelImageId?: string | null
          reviewScore: number
          reviewCount: number
          isNewProduct: boolean
          showSpecificationsInProductCardTitle?: boolean | null
          categoryName?: string | null
          categoryPath?: string | null
          categoryPathEng?: string | null
          minQuantityPerOrder?: number | null
          promotedSpecifications: Array<{ name: string; value: string }>
          price?: {
            campaignPercentage?: number | null
            campaignType?: CampaignType | null
            isBestSeller: boolean
            isBid: boolean
            isCampaign: boolean
            isRecommendedProduct: boolean
            price: number
            priceExcludingVat: number
            priceIncludingVat: number
            originalPrice: number
            priceVat: number
            formatted: {
              price: string
              originalPrice: string
              priceExcludingVat: string
              priceIncludingVat: string
            }
          } | null
          availability?: {
            IsNotifyEligible: boolean
            maxAvailableQuantity?: number | null
            availabilityStatus: AvailabilityStatus
            availabilityStatusPresentation: AvailabilityStatusPresentation
            isAvailableForSale: boolean
            isPreOrder: boolean
            productLifeCycleState: ProductLifeCycleState
            showAvailabilityQuantities: boolean
            showEtaDate: boolean
            internalEtaStock?: { quantity: number; eta: any } | null
            externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
            availabilityDetails?: {
              formattedDateUtc?: string | null
              key: AvailabilityStatusType
            } | null
            internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
          } | null
        } | null
      }>
    }
    relatedProducts: {
      productReferences: Array<{
        id: string
        ticket: string
        searchResultProduct?: {
          id: string
          productErpIdentifier: string
          displayName?: string | null
          englishFullDisplayName?: string | null
          primaryImageId?: string | null
          manufacturerName: string
          manufacturerProductIdentifier?: string | null
          displaySpecifications: string
          oneLiner?: string | null
          internalProduct: boolean
          nameSlug: string
          energyClass?: string | null
          energyDocumentId?: string | null
          energyLabelImageId?: string | null
          reviewScore: number
          reviewCount: number
          isNewProduct: boolean
          showSpecificationsInProductCardTitle?: boolean | null
          categoryName?: string | null
          categoryPath?: string | null
          categoryPathEng?: string | null
          minQuantityPerOrder?: number | null
          promotedSpecifications: Array<{ name: string; value: string }>
          price?: {
            campaignPercentage?: number | null
            campaignType?: CampaignType | null
            isBestSeller: boolean
            isBid: boolean
            isCampaign: boolean
            isRecommendedProduct: boolean
            price: number
            priceExcludingVat: number
            priceIncludingVat: number
            originalPrice: number
            priceVat: number
            formatted: {
              price: string
              originalPrice: string
              priceExcludingVat: string
              priceIncludingVat: string
            }
          } | null
          availability?: {
            IsNotifyEligible: boolean
            maxAvailableQuantity?: number | null
            availabilityStatus: AvailabilityStatus
            availabilityStatusPresentation: AvailabilityStatusPresentation
            isAvailableForSale: boolean
            isPreOrder: boolean
            productLifeCycleState: ProductLifeCycleState
            showAvailabilityQuantities: boolean
            showEtaDate: boolean
            internalEtaStock?: { quantity: number; eta: any } | null
            externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
            availabilityDetails?: {
              formattedDateUtc?: string | null
              key: AvailabilityStatusType
            } | null
            internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
          } | null
        } | null
      }>
    }
  } | null
}

export type GetSearchPhraseProductsQueryVariables = Exact<{
  searchPhrase?: InputMaybe<Scalars['String']['input']>
  sortBy: SortBy
  page: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  selectedFacets?: InputMaybe<Array<FacetParameterInput> | FacetParameterInput>
}>

export type GetSearchPhraseProductsQuery = {
  productSearch?: {
    productReferences: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null
}

export type GetTopSellingCampaignProductsQueryVariables = Exact<{
  numberOfProducts: Scalars['Int']['input']
}>

export type GetTopSellingCampaignProductsQuery = {
  topSellingCampaignProducts?: {
    products: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null
}

export type GetTopSellingProductsQueryVariables = Exact<{
  categoryPath: Scalars['String']['input']
  numberOfProducts: Scalars['Int']['input']
  facets?: InputMaybe<Array<FacetParameterInput> | FacetParameterInput>
}>

export type GetTopSellingProductsQuery = {
  topSellingProducts?: {
    productReferences: Array<{
      id: string
      ticket: string
      searchResultProduct?: {
        id: string
        productErpIdentifier: string
        displayName?: string | null
        englishFullDisplayName?: string | null
        primaryImageId?: string | null
        manufacturerName: string
        manufacturerProductIdentifier?: string | null
        displaySpecifications: string
        oneLiner?: string | null
        internalProduct: boolean
        nameSlug: string
        energyClass?: string | null
        energyDocumentId?: string | null
        energyLabelImageId?: string | null
        reviewScore: number
        reviewCount: number
        isNewProduct: boolean
        showSpecificationsInProductCardTitle?: boolean | null
        categoryName?: string | null
        categoryPath?: string | null
        categoryPathEng?: string | null
        minQuantityPerOrder?: number | null
        promotedSpecifications: Array<{ name: string; value: string }>
        price?: {
          campaignPercentage?: number | null
          campaignType?: CampaignType | null
          isBestSeller: boolean
          isBid: boolean
          isCampaign: boolean
          isRecommendedProduct: boolean
          price: number
          priceExcludingVat: number
          priceIncludingVat: number
          originalPrice: number
          priceVat: number
          formatted: {
            price: string
            originalPrice: string
            priceExcludingVat: string
            priceIncludingVat: string
          }
        } | null
        availability?: {
          IsNotifyEligible: boolean
          maxAvailableQuantity?: number | null
          availabilityStatus: AvailabilityStatus
          availabilityStatusPresentation: AvailabilityStatusPresentation
          isAvailableForSale: boolean
          isPreOrder: boolean
          productLifeCycleState: ProductLifeCycleState
          showAvailabilityQuantities: boolean
          showEtaDate: boolean
          internalEtaStock?: { quantity: number; eta: any } | null
          externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
          availabilityDetails?: {
            formattedDateUtc?: string | null
            key: AvailabilityStatusType
          } | null
          internalStock?: { quantity: number; showAlwaysInStock: boolean } | null
        } | null
      } | null
    }>
  } | null
}

export type NotifyAddFavoriteMutationVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
}>

export type NotifyAddFavoriteMutation = { notifyAddFavorite: string }

export type NotifyAddToCartMutationVariables = Exact<{
  ticket: Scalars['String']['input']
}>

export type NotifyAddToCartMutation = { notifyAddToCart: string }

export type NotifyClickMutationVariables = Exact<{
  ticket: Scalars['String']['input']
}>

export type NotifyClickMutation = { notifyClick: string }

export type NotifyRemoveFavoriteMutationVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
}>

export type NotifyRemoveFavoriteMutation = { notifyRemoveFavorite: string }

export type NotifyRemoveRecentSearchesMutationVariables = Exact<{
  phrase: Scalars['String']['input']
  removeAll: Scalars['Boolean']['input']
}>

export type NotifyRemoveRecentSearchesMutation = { notifyRemoveRecentSearches: string }

export type NotifyRemoveRecentlyViewedMutationVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
  removeAll: Scalars['Boolean']['input']
}>

export type NotifyRemoveRecentlyViewedMutation = { notifyRemoveRecentlyViewed: string }

export type UpdateCartItemCommentMutationVariables = Exact<{
  cartItemId: Scalars['Int']['input']
  value?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateCartItemCommentMutation = {
  updateCartItemComment?: { cartItemId: number } | null
}

export type UpdateCartWithMultipleProductsMutationVariables = Exact<{
  cartItemParams: Array<InputMaybe<CartItemParamInput>> | InputMaybe<CartItemParamInput>
  withRequiredEndUserInformation?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateCartWithMultipleProductsMutation = {
  updateCartWithProducts?: Array<{
    id: number
    productErpIdentifier: string
    quantity: number
    isMandatory: boolean
    isDependent: boolean
    mainProductErpIdentifier?: string | null
    parentCartItemId: number
    comment?: string | null
    product?: {
      displayName: string
      englishFullDisplayName: string
      displaySpecifications: string
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      nameSlug: string
      primaryImageId?: string | null
      productErpIdentifier: string
      reviewScore: number
      reviewCount: number
      maxQuantityPerOrder?: number | null
      minQuantityPerOrder?: number | null
      nonReturnable: boolean
      internalProduct: boolean
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      availability?: {
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        IsNotifyEligible: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        isIncludedInKit: boolean
        internalEtaStock?: { quantity: number; eta: any } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number } | null
      } | null
      price?: {
        priceExcludingVat: number
        priceIncludingVat: number
        originalPriceExcludingVat: number
        originalPriceIncludingVat: number
        isCampaign: boolean
        priceVat: number
        isBid: boolean
        formatted: { priceExcludingVat: string; priceIncludingVat: string }
      } | null
      requiredEndUserInformation?: Array<{
        label?: string | null
        lineNumber: number
        isMandatory: boolean
      }> | null
    } | null
  }> | null
}

export type UpdateCartMutationVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
  mainProductErpIdentifier?: InputMaybe<Scalars['String']['input']>
  quantity: Scalars['Int']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  withRequiredEndUserInformation?: InputMaybe<Scalars['Boolean']['input']>
  parentCartItemId?: InputMaybe<Scalars['Int']['input']>
}>

export type UpdateCartMutation = {
  updateCartWithProduct?: Array<{
    id: number
    productErpIdentifier: string
    quantity: number
    isMandatory: boolean
    isDependent: boolean
    mainProductErpIdentifier?: string | null
    parentCartItemId: number
    comment?: string | null
    product?: {
      displayName: string
      englishFullDisplayName: string
      displaySpecifications: string
      manufacturerName: string
      manufacturerProductIdentifier?: string | null
      nameSlug: string
      primaryImageId?: string | null
      productErpIdentifier: string
      reviewScore: number
      reviewCount: number
      maxQuantityPerOrder?: number | null
      minQuantityPerOrder?: number | null
      nonReturnable: boolean
      internalProduct: boolean
      productType: ProductType
      category?: { englishPathSlug?: string | null } | null
      availability?: {
        maxAvailableQuantity?: number | null
        availabilityStatus: AvailabilityStatus
        availabilityStatusPresentation: AvailabilityStatusPresentation
        isAvailableForSale: boolean
        IsNotifyEligible: boolean
        isPreOrder: boolean
        productLifeCycleState: ProductLifeCycleState
        showAvailabilityQuantities: boolean
        showEtaDate: boolean
        isIncludedInKit: boolean
        internalEtaStock?: { quantity: number; eta: any } | null
        externalStock?: { leadTime: ExternalStockLeadTime; quantity: number } | null
        availabilityDetails?: {
          formattedDateUtc?: string | null
          key: AvailabilityStatusType
        } | null
        internalStock?: { quantity: number } | null
      } | null
      price?: {
        priceExcludingVat: number
        priceIncludingVat: number
        originalPriceExcludingVat: number
        originalPriceIncludingVat: number
        isCampaign: boolean
        priceVat: number
        isBid: boolean
        formatted: { priceExcludingVat: string; priceIncludingVat: string }
      } | null
      requiredEndUserInformation?: Array<{
        label?: string | null
        lineNumber: number
        isMandatory: boolean
      }> | null
    } | null
  }> | null
}

export type UpdateCompareListMutationVariables = Exact<{
  productErpIdentifier: Scalars['String']['input']
  quantity: Scalars['Int']['input']
  productListName?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateCompareListMutation = {
  updateCompareListWithProduct?: { productListId: number; productListItemId: number } | null
}

export type UpdateFavoriteListNameMutationVariables = Exact<{
  favoriteListName: Scalars['String']['input']
  updatedFavoriteListName: Scalars['String']['input']
}>

export type UpdateFavoriteListNameMutation = {
  updateFavoriteListName?: { updatedProductListName?: string | null } | null
}

export type UpdateFavoriteListMutationVariables = Exact<{
  favoriteListId?: InputMaybe<Scalars['Int']['input']>
  favoriteListName: Scalars['String']['input']
  productErpIdentifier: Scalars['String']['input']
  quantity: Scalars['Int']['input']
  cartItemId?: InputMaybe<Scalars['Int']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateFavoriteListMutation = {
  updateFavoriteListWithProduct?: { productListId: number; productListItemId: number } | null
}
